/**
 * Wholesale-all-in-one-min.js
 * Updated Date: April 2025
 **/

WSAIO.encode = function (number) {
	let encrypted = '';
	let strNum = number.toString();
	
	for (let i = 0; i < strNum.length; i++) {
		let char = strNum[i];
		if (char === '.') {
			encrypted += String.fromCharCode(char.charCodeAt(0) + 5);
		} else {
			encrypted += String.fromCharCode(char.charCodeAt(0) + 17);
		}  
	}
	return encrypted;
}
WSAIO.decrypt = function (encrypted) {
  let decrypted = '';
   for (let i = 0; i < encrypted.length; i++) {
     let char = encrypted[i];
      if (char.charCodeAt(0) === ('.'.charCodeAt(0) + 5)) {
         decrypted += '.'; 
        } else { 
         decrypted += String.fromCharCode(char.charCodeAt(0) - 17);
        }
    } 
    return decrypted; 
}

WSAIO.init = function () {
	try{
		if (window.location.href.includes('/account/login')) {
			const checkoutUrlField = document.querySelector('[name="checkout_url"]');
			if (checkoutUrlField) {
				checkoutUrlField.value = Shopify.routes.root + 'cart';
			}
		}
	}catch(e){}
	if(!WSAIO.main_liquid_file_included){
	  if(!WSAIO.no_logs){
		console.error("%cError 404 -- 'wholesale-all-in-one-main.liquid' file not found.", "font-size: 20px");
	  }
	  WSAIO_is_disabled = true;
	  return false;
	}
	
	var WS = this;
	WSAIO.httpRequest = new XMLHttpRequest();
	WSAIO.DiscountCode = {};
	localStorage.removeItem("ws-applied-coupon");
	WSAIO.all_discount_tags = [];
	WS.applied_tag = "all";
	WS.applied_tag_array = [];
	WSAIO.product_collections = [];
	var recheckout_marketPro = 0;
    WSAIO.custom_id_price = '';
    window.preDiscountData = [];
	WSAIO.shopInfo['dynamic_minjs_file'] = true;
	try{
		WSAIO.products_with_collections.forEach(val => {
			delete val.product_variants;
			WSAIO.product_collections.push(val);
		});
	}catch(e){}
 
	if ('undefined' === typeof WSAIO.Currency) {
	  WSAIO.Currency = {};
	}
	try{
		if(typeof WSAIO.customer != 'undefined' && WSAIO.customer.tax_exempt == true){
			WSAIO.exclude_VAT = 0;
		}
        setTimeout(function(){
		if(typeof WSAIO.tax_settings !== "undefined" && 
			WSAIO.tax_settings && 
			typeof WSAIO.tax_settings.taxes_included !== "undefined" && 
			WSAIO.tax_settings.taxes_included === true && 
			WSAIO.customer.id != null && WSAIO.customer.tax_exempt &&
                ((Shopify.country != WSAIO.tax_settings.primary.code) && (WSAIO.tax_settings.presentment != null && WSAIO.tax_settings.presentment.tax != 0))
            ){
				WSAIO.auto_vat_enable = true;
		}
        if(typeof WSAIO.exclude_VAT != 'undefined' && WSAIO.exclude_VAT != 0){
            if(typeof WSAIO.auto_vat_enable != 'undefined'){
              WSAIO.auto_vat_enable = false;
            }
		}
        },100)
	}catch(e){}
	if (!Array.prototype.findIndex) {
	  Object.defineProperty(Array.prototype, "findIndex", {
		value: function (c, d) {
		  if (null == this) throw new TypeError('"this" is null or not defined');
		  var b = Object(this),
			  e = b.length >>> 0;
		  if ("function" !== typeof c) throw new TypeError("predicate must be a function");
		  for (var a = 0; a < e;) {
			if (c.call(d, b[a], a, b)) return a;
			a++
		  }
		  return -1
		},
		configurable: !0,
		writable: !0
	  });
	}
	if (!Array.prototype.indexOf) {
	  Array.prototype.indexOf = function (d, e) {
		if (null == this) throw new TypeError('"this" is null or not defined');
		var c = Object(this),
			b = c.length >>> 0;
		if (0 === b) return -1;
		var a = e | 0;
		if (a >= b) return -1;
		for (a = Math.max(0 <= a ? a : b - Math.abs(a), 0); a < b; a++)
		  if (a in c && c[a] === d) return a;
		return -1
	  };
	}
	if (!Array.prototype.find) {
	  Object.defineProperty(Array.prototype, "find", {
		value: function (c, e) {
		  if (null == this) throw TypeError('"this" is null or not defined');
		  var b = Object(this),
			  f = b.length >>> 0;
		  if ("function" !== typeof c) throw TypeError("predicate must be a function");
		  for (var a = 0; a < f;) {
			var d = b[a];
			if (c.call(e, d, a, b)) return d;
			a++
		  }
		},
		configurable: !0,
		writable: !0
	  });
	}  
	function log(m = '',a = null) {
	  if (!WSAIO.no_logs && ["log", "info", "error", "warn", "Log", "Info", "Error", "Warn"].indexOf(WS.log) > -1) {
		try {
		  console[WS.log.toLowerCase()]("WSAIO " + WS.log.toUpperCase(), a);
		} catch (e) {}
	  }
	}
  
	function isError(a) {
	  if (!WSAIO.no_logs && ["log", "info", "error", "warn", "Log", "Info", "Error", "Warn"].indexOf(WS.errorLog) > -1) {
		try {
		  console[WS.errorLog]("WSAIO ERROR", a);
		} catch (e) {}
	  }
	}
  
	WSAIO.mF = function (a) {
	  if (isNaN(a) || null == a) return 0;
	  a = a.toString();
	  if ("string" == typeof a && -1 < a.indexOf(".")) return 2 > a.split(".")[1].length ? Number(a).toFixed(2).toString() : a.toString();
	  a = (Number(a) / 100).toFixed(2);
	  return a.toString()
	};

	function remove_emptyElement(html) {
		let tempElement = document.createElement('div');
		tempElement.innerHTML = html;

		let changed = true;

		while (changed) {
			changed = false;

			tempElement.querySelectorAll('*').forEach(el => {
				if (el.textContent.trim() === '') {
					el.remove();
					changed = true;
				}
			});
		}

		return tempElement.innerHTML;
	}

  
    WSAIO.price_selector_format = function(selector){
          if (typeof selector === 'string') {
                price_selector = document.querySelector(selector);
                } else if (selector instanceof Element) {
                price_selector = selector;
                } else if (selector?.length) {
                price_selector = selector[0]; // first element only
            }
            return price_selector;
    }
  
    function groupByProductWithCollections(list) {
		var map = {};
		var result = [];

		for (var i = 0; i < list.length; i++) {
			var item = list[i];
			var pid = item.product_id;

			if (!map[pid]) {
			map[pid] = {
				product_id: pid,
				product_handle: item.product_handle,
				collections: []
			};
			}

			if (map[pid].collections.indexOf(item.collection_id) === -1) {
			map[pid].collections.push(item.collection_id);
			}
		}

		for (var id in map) {
			result.push({
			collection_id: map[id].collections.join(","),
			product_id: map[id].product_id,
			product_handle: map[id].product_handle
			});
		}

		return result;
		}
  
  WSAIO.cart_relevent_collectionID = function(){
        const cartProductIds = cart_data.items.map(item => item.product_id);
		let missing_products_with_collections_list = preDiscountData.products_with_collections;
        if(WSAIO.product_collections != null){
			let filteredId = groupByProductWithCollections(WSAIO.product_collections.filter(item => cartProductIds.includes(Number(item.product_id))));
			if(Array.isArray(missing_products_with_collections_list) && missing_products_with_collections_list.length > 0){
				filteredId = filteredId.concat(missing_products_with_collections_list);
			}
        return filteredId;
        }else{
           return [];
        }
  }
   WSAIO.check_missing_collection_ids = function() {
    var available_collection_ids = WSAIO.cart_relevent_collectionID();
    if (!Array.isArray(available_collection_ids) || !WSAIO.collection_ids_required) {
        return [];
    }
		var cartlineitemProductIds = [];
		cart_data.items.forEach(function(item) {
			if (cartlineitemProductIds.indexOf(item.product_id) === -1) {
				cartlineitemProductIds.push(item.product_id);
			}
		});
    var missingProductIds = cartlineitemProductIds.filter(function(cartId) {
        return !available_collection_ids.some(function(colItem) {
            return Number(colItem.product_id) === cartId;
        });
    });
    return missingProductIds;
}

  
  
	WSAIO.formatMoney = function (t, g = null) {
		if(t == null){
			 return '';
		 }
		 var a = parseFloat(t);
		 if(typeof QOF_page !== 'undefined' && QOF_page && (typeof WSAIO.QOF_version == 'undefined' || WSAIO.QOF_version == 1)){
			 a= a/100;
		 }
 
		 "string" === typeof a && (a = a.replace(".", ""));
        var c = "",
            e = /\{\{\s*(\w+)\s*\}\}/,
            f = g || WS.shopInfo.money_format || WSAIO.shop_money_format;
            Number.prototype.format_pricing = function(n, x = null, s = null, c = null) {
              var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
                  num = this.toFixed(Math.max(0, ~~n));
              return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
          };
        switch (f.match(e)[1]) {
          case "amount":
              a = parseFloat(a);
              return f.replace(e, a.format_pricing(2));
            break;
          case "amount_no_decimals":
              a = parseFloat(a);
              return f.replace(e, a.format_pricing(0));
            break;
          case "amount_with_comma_separator":
              a = parseFloat(a);
              return f.replace(e, a.format_pricing(2, 3, '.', ','));
            break;
          case "amount_no_decimals_with_comma_separator":
              a = parseFloat(a);
              return f.replace(e, a.format_pricing(2, 0, '.').replace('.00',''));
            break;
          case "amount_no_decimals_with_space_separator":
           a = parseFloat(a);
           return f.replace(e, a.format_pricing(2, 3, ' ').replace('.00',''));
            break;
          case "  ":
              a = parseFloat(a);
              return f.replace(e, a.format_pricing(2, 3, "'"));
        }
        return f.replace(e, c)
      };
  
    WSAIO.calculate_tax_price_adjustments = function(price){
        //  if prices are tax-inclusive, need to make price adjustments
        price = Number(price);
        if(isNaN(price)) return price;
        /*  COND:
            if prices are tax-inclusive
                1) if customer is international: WSAIO.tax_settings.customer_is_local == false
                    :Exclude tax from price 
        */
        if(typeof WSAIO.tax_settings !== "undefined" && WSAIO.tax_settings && typeof WSAIO.tax_settings.taxes_included !== "undefined" && WSAIO.tax_settings.taxes_included === true && typeof WSAIO.tax_settings.auto_configure_tax_inclusivity != 'undefined' && WSAIO.tax_settings.auto_configure_tax_inclusivity && typeof WSAIO.selected_variant_taxable != 'undefined' && WSAIO.selected_variant_taxable && typeof WSAIO.auto_vat_enable != 'undefined' &&  WSAIO.auto_vat_enable){
            if(WSAIO.tax_settings.customer_is_local === false || WSAIO.customer.tax_exempt){
                //  Exclude TAX:
                //      calulcating tax using formula provided by shopify
                //      https://help.shopify.com/en/manual/taxes/location#include-taxes-in-product-prices

              
                var primary_tax = 0;
                if(WSAIO.tax_settings.primary){
                    primary_tax = Number((WSAIO.tax_settings.primary.tax * price) / (1 + WSAIO.tax_settings.primary.tax));
                }
                price -= Number(primary_tax);
				if(typeof WSAIO.product_parent_grid_selector != 'undefined' && typeof WSAIO.tax_include_label_selector != 'undefined'){
					const targetSelector = WSAIO.product_parent_grid_selector + ' ' + WSAIO.tax_include_label_selector;
					const taxLabelElements = document.querySelectorAll(targetSelector);
					taxLabelElements.forEach(element => {
						element.textContent = 'Tax Excluded.';
					});
				 }
                // Then, add presentment tax to price
                if(WSAIO.tax_settings.presentment && (WSAIO.customer.id == null || WSAIO.customer.tax_exempt == false)){
                    // this tax will be 0 if tax need to be excluded
                    price = Number((price * (1 + WSAIO.tax_settings.presentment.tax)));
                }
                
            }
        }

        return price.toFixed(2);
    }
  
	// Equivalent Native JavaScript Code

	WSAIO.displayTable = function (a, b, v) {
		if ("undefined" === typeof b) {
			return isError("Volume discount table selector for product page was not defined."); 
		}
		if (-1 < b.indexOf(":")) {
			var d = b.split(":")[1]; 
			var c = b.split(":")[0]; 
			
			var tElement2 = document.querySelector(c);
			
			if (!tElement2) {
				return; 
			}

			switch (d) {
				case "append":
					tElement2.insertAdjacentHTML('beforeend', a);
					break;
					
				case "prepend":
					tElement2.insertAdjacentHTML('afterbegin', a);
					break;
					
				case "before":
					tElement2.insertAdjacentHTML('beforebegin', a);
					break;
					
				case "after":
					tElement2.insertAdjacentHTML('afterend', a);
					break;
					
				default:
					tElement2.innerHTML = a;
			}
		} else {
			const tElement = document.querySelector(b);
			if (tElement) {
				tElement.innerHTML = a;
			} else {
				console.error(`WSAIO.displayTable: Default target element not found for selector "${b}"`);
			}
		}
	};
  
	WSAIO.alterHTML = function (htmlContent, destination) {
		if (typeof destination === "undefined" || destination === "") {
			return isError("Selector was not defined.");
		}
		if (destination.includes(":") && 
			(destination.includes("append") || destination.includes("prepend") || 
			destination.includes("before") || destination.includes("after") || destination.includes("same"))
		) {
			const parts = destination.split(":");
			const selector = parts[0]; 
			const action = parts[1];

			const targetElements = document.querySelectorAll(selector);

			if (targetElements.length === 0) {
				return; 
			}
			targetElements.forEach(element => {
				switch (action) {
					case "append":
						element.insertAdjacentHTML('beforeend', htmlContent);
						break;
					case "prepend":
						element.insertAdjacentHTML('afterbegin', htmlContent);
						break;
					case "before":
						element.insertAdjacentHTML('beforebegin', htmlContent);
						break;
					case "after":
						element.insertAdjacentHTML('afterend', htmlContent);
						break;
					case "same":
						element.innerHTML = htmlContent;
						break;
					default:
						element.innerHTML = htmlContent;
						break;
				}
			});

		} else {
			document.querySelectorAll(destination).forEach(element => {
				element.innerHTML = htmlContent;
			});
		}
	};

	WSAIO.DiscountCode.addForm = function (html, selector) {
		if(WSAIO.general_settings.discount_method == 'coupon_code' && (typeof WSAIO.net_disable_default_checkout == 'undefined' || !WSAIO.net_disable_default_checkout)){
	  if(document.querySelectorAll(".wsaio_coupon_box").length > 0){
		document.querySelectorAll(".wsaio_coupon_box").forEach(element => {
			element.remove();
		});
	  }
	  if(document.querySelectorAll(".wsaio_coupon_link").length > 0){
				document.querySelectorAll(".wsaio_coupon_link").forEach(element => {
			element.remove();
		});
	  }

	  if(typeof selector == 'undefined' && WS.discount_code_field_selector == ''){
		WS.alterHTML(html || WS.discount_code_form_html,WSAIO.subtotal_selector.split(':')[0]+':after');
	  }else{
		WS.alterHTML(html || WS.discount_code_form_html, selector || WS.discount_code_field_selector);
		if(typeof WSAIO.show_drawer_coupon != 'undefined' && WSAIO.show_drawer_coupon){
            WS.alterHTML(html || WS.discount_code_form_html,WS.discount_code_link_selector+':after');
		}else{
			WS.alterHTML(WSAIO.coupon_code_link_html,WS.discount_code_link_selector+':after');
		}
	  }
	}
	}
  
	WSAIO.DiscountCode.toggle = function (state) {
	  if ('undefined' === typeof state) var state = 'show';
	  if (WS.discount_code_field_selector.indexOf(':') > -1) {
			const selector = WS.discount_code_field_selector.split(":")[0];
			const element = document.querySelector(selector);

			if (element) {
				element.style.display = (state === 'show' ? 'block' : 'none');
			}
	  } else {
		const selector = WS.discount_code_field_selector;
		const element = document.querySelector(selector);

		if (element) {
			element.style.display = (state === 'show' ? 'block' : 'none');
		}
	  }
	}
  
	WSAIO.checkCustomer = function (type, tags, excluded) {
	  if (WSAIO.debugger) debugger;
	  switch (type) {
		case 'has_tag':
		  if (WS.customer.id) {
			var isTag_all = tags.indexOf("all");
			var isTag_has_account = tags.indexOf("has_account");
			var isTag = [];
			try {
			  isTag = tags.map(function (tag) {
				return WS.customer.tags.findIndex(function (tag2) {
				  return tag.toLowerCase() === tag2
				}) > -1
			  });
			} catch (error) {}
			if (isTag.indexOf(true) > -1) {
			  WS.applied_tag = tags[isTag.indexOf(true)];
			  WS.applied_tag_array.push(tags[isTag.indexOf(true)]);
			  return isTag.indexOf(true) > -1
			} else if (isTag_all > -1) {
				WS.applied_tag_array.push('all');
			  return true;
			} else if (isTag_has_account > -1 && (WS.applied_tag == 'all' || WS.applied_tag == 'has_account' || WS.applied_tag == '') ) {
				WS.applied_tag_array.push('has_account');
			  WS.applied_tag = 'has_account';
			  return true;
			} else {
			  return isTag.indexOf(true) > -1
			}
		  } else {
			var isTag_all = tags.indexOf("all");
			var isTag_no_account = tags.indexOf("no_account");
			if (isTag_no_account > -1) {
			  WS.applied_tag = 'no_account';
			  WS.applied_tag_array.push('no_account');
			  return true;
			} else if (isTag_all > -1) {
				WS.applied_tag_array.push('all');
			  return true;
			} else {
			  return false;
			}
		  }
		  
		  break;
		case 'has_account':
		  WS.applied_tag = "has_account";
		  WS.applied_tag_array.push("has_account");
		  if (WS.customer.id) {
			var isTag = [];
			try {
			  isTag = excluded.map(function (tag) {
				return WS.customer.tags.findIndex(function (tag2) {
				  return tag.toLowerCase() === tag2
				}) > -1
			  });
			} catch (error) {}
			if (isTag.indexOf(true) > -1) {
			  WS.excluded_tag = excluded[isTag.indexOf(true)];
			}
			return isTag.indexOf(true) === -1
		  } else return false;
		  break;
		case 'no_account':
		  WS.applied_tag = "no_account";
		  WS.applied_tag_array.push("no_account");
		  return WS.customer.id ? false : true;
		  break;
		case 'all':
		  if (WS.customer.id) {
			var isTag = [];
			try {
			  isTag = excluded.map(function (tag) {
				return WS.customer.tags.findIndex(function (tag2) {
				  return tag.toLowerCase() === tag2
				}) > -1
			  });
			} catch (error) {}
			if (isTag.indexOf(true) > -1) {
			  WS.excluded_tag = excluded[isTag.indexOf(true)];
			}
			return isTag.indexOf(true) === -1
		  } else return true;
		  break;
		default:
		  if (WS.customer.id) {
			var isTag = [];
			try {
			  isTag = excluded.map(function (tag) {
				return WS.customer.tags.findIndex(function (tag2) {
				  return tag.toLowerCase() === tag2
				}) > -1
			  });
			} catch (error) {}
			if (isTag.indexOf(true) > -1) {
			  WS.excluded_tag = excluded[isTag.indexOf(true)];
			}
			return isTag.indexOf(true) === -1
		  } else return true;
		  break;
	  }
	};
  
    WSAIO.remove_comparePrice = function(html){
				const tempDiv = document.createElement('div');
				tempDiv.innerHTML = html;
				const moneyElements = tempDiv.querySelectorAll('.money');
				moneyElements.forEach(element => {
					if (/%compare_at_price%/gi.test(element.textContent)) {
						element.classList.remove('money');
					}
				});
				return tempDiv.innerHTML;
			}
  
	WSAIO.checkAppliesTo = function (params) {
	  if (WSAIO.debugger) debugger;
	  switch (params.type) {
		case "products":
		  params.rule["priority"] = 1;
		  applies_to_products();
		  break;
		case "collections":
		  params.rule["priority"] = 2;
		  applies_to_collections();
		  break;
		case "entire_store":
		  var excluded = false;
		  if (params.rule.exclude_products && params.rule.exclude_products.findIndex(function (x) {
			return x.handle == WS.selected_product.handle
		  }) > -1) {
			excluded = true;
		  }
		  if (params.rule.exclude_collections && params.rule.exclude_collections.length > 0 && WS.product_in_collects != null) {
			for (var xzy = 0; xzy < WS.product_in_collects.length; xzy++) {
			  var item = WS.product_in_collects[xzy];
			  if (-1 < params.rule.exclude_collections.findIndex(function (x) {
				return x.id == item.collection_id
			  })) {
				if (WS.selected_product.id == item.product_id) {
				  excluded = true;
				}
			  }
			}
		  }
		  if (!excluded) {
			params.rule["priority"] = 3;
			if (params.module === "regular_discount") {
			  WS.productRd.push(params.rule);
			} else {
			  WS.productVd.push(params.rule);
			}
		  }
		  break;
		default:
		  params.rule["priority"] = 3;
		  if (params.module === "regular_discount") {
			WS.productRd.push(params.rule);
		  } else {
			WS.productVd.push(params.rule);
		  }
		  break;
	  }
  
	  function applies_to_products() {
		if (WSAIO.debugger) debugger;
		// Apply only if selected_product_id was defined.
		if ('undefined' !== typeof WS.selected_product.handle || 'undefined' !== typeof WS.selected_product.id) {
		  var isFound = params.rule.products.findIndex(function (x) {
			return (x.handle === WS.selected_product.handle || x.id == WS.selected_product.id)
		  })
		  if (isFound > -1) {
			if (params.module === "regular_discount") {
			//   if (params.rule.products[isFound].variant_level === true) {
			// 	WS.productRd = [];
			//   }
			  WS.productRd.push(params.rule);
			} else {
			//   if (params.rule.products[isFound].variant_level === true) {
			// 	WS.productVd = [];
			//   }
			  WS.productVd.push(params.rule);
			}
		  }
		} else {
		  isError("Selected product handle is not defined.");
		}
	  }
  
	  function applies_to_collections() {
		if (WSAIO.debugger) debugger;
		var isFound = [false];
		// if selected_product_id is defined
		if (WS.selected_product.handle) {
		  var excluded = false;
		  if (params.rule.exclude_products && params.rule.exclude_products.findIndex(function (x) {
			return x.handle == WS.selected_product.handle
		  }) > -1) {
			excluded = true;
		  }
		  if (!excluded) {
			isFound = params.rule.collections.map(function (collection, i) {
			  return -1 < (WS.product_in_collects.findIndex(function (x) {
				return (x.product_handle == WS.selected_product.handle || x.product_id == WS.selected_product.id) && x.collection_id == collection.id
			  }))
			});
			if (isFound.indexOf(true) > -1) {
			  if (params.module === "regular_discount") {
				WS.productRd.push(params.rule);
			  } else {
				WS.productVd.push(params.rule);
			  }
			}
		  }
		}
		// if only selected_collection.id is defined.
		else if (WS.template === "collection" && WS.selected_collection.id) {
		  // WS.selected_collection.id (if template is collection then this id contains current collection id, otherwise null). for other case
		  isFound = params.rule.collections.map(function (collection, i) {
			return collection.id == WS.selected_collection.id;
		  });
		  if (isFound.indexOf(true) > -1) {
			if (params.module === "regular_discount") {
			  WS.productRd.push(params.rule);
			} else {
			  WS.productVd.push(params.rule);
			}
		  }
		} else {
		  isError("Missing either product's id or collection's id or template is not set for collections");
		}
	  }
	  if (params.module === "regular_discount") {
		if (WS.productRd && WS.productRd.length > 1) {
		  if (-1 < WS.productRd.findIndex(function (z) {
			return z.individual_product === true
		  })) {
			WS.productRd = WS.productRd.filter(function (x) {
			  return x.individual_product === true
			});
		  } else if (-1 < WS.productRd.findIndex(function (z) {
			return z.customer_group === 'has_tag'
		  })) {
			WS.productRd = WS.productRd.filter(function (x) {
			  return x.customer_group === 'has_tag'
			});
		  } else if (-1 < WS.productRd.findIndex(function (z) {
			return z.customer_group === 'has_tag'
		  })) {
			WS.productRd = WS.productRd.filter(function (x) {
			  return x.customer_group === 'has_tag'
			});
		  } else if (-1 < WS.productRd.findIndex(function (z) {
			return z.customer_group === 'has_account'
		  })) {
			WS.productRd = WS.productRd.filter(function (x) {
			  return x.customer_group === 'has_account'
			});
		  } else if (-1 < WS.productRd.findIndex(function (z) {
			return z.customer_group === 'no_account'
		  })) {
			WS.productRd = WS.productRd.filter(function (x) {
			  return x.customer_group === 'no_account'
			});
		  }
		}
	  } else {
		if (WS.productVd && WS.productVd.length > 1) {
		  if (-1 < WS.productVd.findIndex(function (z) {
			return z.individual_product === true
		  })) {
			WS.productVd = WS.productVd.filter(function (x) {
			  return x.individual_product === true
			});
		  } else if (-1 < WS.productVd.findIndex(function (z) {
			return z.customer_group === 'has_tag'
		  })) {
			WS.productVd = WS.productVd.filter(function (x) {
			  return x.customer_group === 'has_tag'
			});
		  } else if (-1 < WS.productVd.findIndex(function (z) {
			return z.customer_group === 'has_account'
		  })) {
			WS.productVd = WS.productVd.filter(function (x) {
			  return x.customer_group === 'has_account'
			});
		  } else if (-1 < WS.productVd.findIndex(function (z) {
			return z.customer_group === 'no_account'
		  })) {
			WS.productVd = WS.productVd.filter(function (x) {
			  return x.customer_group === 'no_account'
			});
		  }
		}
	  }
	};
  
	  WSAIO.price_with_unit = function(price){
		  if(typeof WSAIO.country_currency_code != 'undefined' && typeof WSAIO.customer.default_address.country_code != 'undefined'){
				price = price+' '+WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0];
		  }else{
			price = price+' '+Shopify.currency.active;
		  }
		  return price;
	   };
	  WSAIO.change_currency_sign = function(price){
			  if(typeof WSAIO.country_currency_code != 'undefined' && typeof WSAIO.customer.default_address.country_code != 'undefined' && typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO.formatMoney('0').indexOf(Shopify.currency.active) == -1 && typeof WSAIO.market_selected != 'undefined' && typeof WSAIO.customer.default_address.country_code != 'undefined' && (WSAIO.market_selected != WSAIO.customer.default_address.country_code)){
				   var character = null;
			  price = price.toString();
				   character= price.replace( /(<([^>]+)>)/ig, '');
					character= character.replace(/\d.+/g, '');
					character= character.replace(/\d,+/g, '')
				  price = price.replace(character,WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[1])
		  }
		  return price;
	   }
    WSAIO.check_currency_unit = function(price){
      if(typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO.formatMoney('0').indexOf(Shopify.currency.active) == -1){
          price = price+' '+Shopify.currency.active;
      }
      return price;
    }
	WSAIO.volumeDiscount = function (params, callback) {
	  if (WSAIO.debugger) debugger;
	  if (typeof params === 'function') callback = params;
	  if(!params){
		isError("No params provided for volume discount");
		return false;
	  }
	  if(!params.item_price_selector){
		isError("Item price selector is undefined");
		// return false;
	  }
	  if (WSAIO.isWholesaleCustomer() === false) {
		if (typeof callback === "function") {
		  return callback({
			error: "Invalid customer"
		  });
		} else {
		  return "Invalid customer";
		}
	  }
	  
      var WSAIO_variant_sku_are_same = true;

      if(typeof WSAIO.enable_auto_firstRow == 'undefined' || !WSAIO.enable_auto_firstRow){
        WSAIO.rd_or_regularPrice = 0;
      }
	  
	  
	  	let price_selector;

	  if (typeof params.item_price_selector === 'string') {
		price_selector = document.querySelector(params.item_price_selector);
		} else if (params.item_price_selector instanceof Element) {
		price_selector = params.item_price_selector;
		} else if (params.item_price_selector?.length) {
		price_selector = params.item_price_selector[0]; // first element only
	  }
		if (price_selector?.getAttribute) {
		const pidClass = 'wsaio_' + params.product_id;
		const vidClass = 'wsaio_' + params.variant_id;
		const hasWsaio = price_selector.className.includes('wsaio_');
		const isQuickOrder = price_selector.closest('.quick-order-list__table');

		if (!hasWsaio && !isQuickOrder) {
			price_selector.classList.add(pidClass, vidClass);
				} else {
			price_selector.classList.remove(pidClass);
			price_selector.classList.add(pidClass, vidClass);
				}
			}


	  if (typeof params.template !== 'undefined' && typeof WSAIO.auto_vat_enable != 'undefined' &&  WSAIO.auto_vat_enable){
		var _id = params.product_id;
		if(WSAIO.template != 'cart' && typeof WSAIO.product_in_collects != 'undefined' && WSAIO.product_in_collects.length != 0){
			 var _indx = WSAIO.product_in_collects.findIndex(function(e,r){
				 return e.product_id == _id;
			 });
			 if(typeof WSAIO.product_in_collects[_indx] != 'undefined' && typeof WSAIO.product_in_collects[_indx].product_variants != 'undefined'){
				 var  current_product_variant = WSAIO.product_in_collects[_indx].product_variants;
				 var _indx_of_variant = current_product_variant.findIndex(function(d,t){
					 return d.id == params.variant_id;
				 })
				 WSAIO.selected_variant_taxable = current_product_variant[_indx_of_variant].taxable;
				 // if Price set in price adjustment, then no tax include function run
				 if(typeof WSAIO.tax_settings != 'undefined' && WSAIO.tax_settings.presentment != null && WSAIO.tax_settings.presentment.price_adjustments != null && typeof WSAIO.tax_settings.presentment.price_adjustments.fixed_variant_ids != 'undefined' && WSAIO.tax_settings.presentment.price_adjustments.fixed_variant_ids.length && WSAIO.tax_settings.presentment.price_adjustments.fixed_variant_ids.indexOf(current_product_variant[_indx_of_variant].id) > -1){
					WSAIO.selected_variant_taxable = false;
				}
			 }
		 }else if(typeof WSAIO.products_with_collections != 'undefined' && WSAIO.products_with_collections.length != 0){
			 var _indx = WSAIO.products_with_collections.findIndex(function(e,r){
				 return e.product_id == _id;
			 });
			 if(typeof WSAIO.products_with_collections[_indx] != 'undefined' && typeof WSAIO.products_with_collections[_indx].product_variants != 'undefined'){
				 var  current_product_variant = WSAIO.products_with_collections[_indx].product_variants;
				 var _indx_of_variant = current_product_variant.findIndex(function(d,t){
					 return d.id == params.variant_id;
				 })
				 WSAIO.selected_variant_taxable = current_product_variant[_indx_of_variant].taxable;
				 // if Fixed Price set in price adjustment, then no tax include function run
				 if(typeof WSAIO.tax_settings != 'undefined' && WSAIO.tax_settings.presentment != null && WSAIO.tax_settings.presentment.price_adjustments != null && typeof WSAIO.tax_settings.presentment.price_adjustments.fixed_variant_ids != 'undefined' && WSAIO.tax_settings.presentment.price_adjustments.fixed_variant_ids.length && WSAIO.tax_settings.presentment.price_adjustments.fixed_variant_ids.indexOf(current_product_variant[_indx_of_variant].id) > -1){
					WSAIO.selected_variant_taxable = false;
				}
			 }
		 }
   }
	  WS.output = true;
	  WS.remove_duplicate_table = false;
	  WS.selected_variant = JSON.parse(JSON.stringify(WS.current_variant)); // current variant obj should not change
	  WS.selected_product = JSON.parse(JSON.stringify(WS.current_product)); // current product obj should not change
	  WS.selected_collection = JSON.parse(JSON.stringify(WS.current_collection)); // current collection obj should not change
	  if (typeof params === 'object') {
		if (typeof params.product_id !== 'undefined' && params.product_id !== "default") WS.selected_product.id = params.product_id;
		if (typeof params.product_handle !== 'undefined' && params.product_handle !== "default") WS.selected_product.handle = params.product_handle;
		if (typeof params.variant_id !== 'undefined' && params.variant_id !== "default") WS.selected_variant.id = params.variant_id;
		if (typeof params.variant_sku !== 'undefined' && params.variant_sku !== "default") WS.selected_variant.sku = params.variant_sku;
		if (typeof params.variant_price !== 'undefined' && params.variant_price !== "default") WS.selected_variant.price = params.variant_price;
		if (typeof params.variant_compare_at_price !== 'undefined' && params.variant_compare_at_price !== "default") WS.selected_variant.compare_at_price = params.variant_compare_at_price;
		if (typeof params.collection_id !== 'undefined' && params.collection_id !== "default") WS.selected_collection.id = params.collection_id;
		if (typeof params.output !== 'undefined' && params.output !== "default") WS.output = params.output;
		if (typeof params.product_parent_grid_selector !== 'undefined' && params.product_parent_grid_selector !== "default") WS.product_qb_table_selector = params.qb_table_selector;
		if (typeof params.remove_duplicate_table !== 'undefined' && params.remove_duplicate_table !== "default") WS.remove_duplicate_table = params.remove_duplicate_table;
		if (typeof params.template !== 'undefined' && params.template !== "default") WS.landingTemplate = params.template;
	  }
	  if (WS.selected_variant && typeof WS.selected_variant.price === "string" && WS.selected_variant.price.indexOf(".") > -1) {
		WS.selected_variant.price = WS.selected_variant.price.replace('.', '');
	  }
	  if (WS.selected_variant && typeof WS.selected_variant.compare_at_price === "string" && WS.selected_variant.compare_at_price.indexOf(".") > -1) {
		WS.selected_variant.compare_at_price = WS.selected_variant.compare_at_price.replace('.', '');
	  }
	  WS.productVd = [];

      var hasImportRule = WS.volume_discounts.some(function(item){
		return item.applies_to == "products" && item.products.length && item.products[0].id == item.products[0].handle;
      });

      if(hasImportRule){
        WS.volume_discounts.sort(function (a, b) {
            // Shifting import rule to end
            if(b.applies_to == "products" || a.applies_to == "products"){
                if(a.products != undefined && a.products.length && (a.products[0].id == a.products[0].handle)){
                    return 1;
                }
                if(b.products != undefined && b.products.length && (b.products[0].id == b.products[0].handle)){
                    return -1;
                }
			}
            return 0;
        });
      }
	  WS.applied_tag_array = [];
	  // for loop
	  for (var i = 0, len_i = WS.volume_discounts.length; i < len_i; i++) {
		var volume_discount = WS.volume_discounts[i];
		if (volume_discount.state !== 'published') continue;
		if (WS.checkCustomer(volume_discount.customer_group, volume_discount.tags, volume_discount.tags_excluded) === false) continue;
		if (volume_discount.schedule_active) {
		  var _schedule = WS.getSchedule(volume_discount.schedule);
		  log("_schedule", _schedule);
		  if (_schedule.ends_in) {
			if (
			  Number(_schedule.ends_in.years) <= 0 &&
			  Number(_schedule.ends_in.months) <= 0 &&
			  Number(_schedule.ends_in.days) <= 0 &&
			  Number(_schedule.ends_in.hours) <= 0 &&
			  Number(_schedule.ends_in.minutes) <= 0 &&
			  Number(_schedule.ends_in.seconds) <= 0
			) {
			  log("This rule was expired", _schedule);
			  continue;
			}
			if (
			  Number(_schedule.started.years) >= 0 &&
			  Number(_schedule.started.months) >= 0 &&
			  Number(_schedule.started.days) >= 0 &&
			  Number(_schedule.started.hours) >= 0 &&
			  Number(_schedule.started.minutes) >= 0 &&
			  Number(_schedule.started.seconds) >= 0
			) {
			  log("This rule was schedules and will be started in", _schedule);
			  continue;
			}
		  }
		}
		WS.checkAppliesTo({
		  "type": volume_discount.applies_to,
		  "rule": volume_discount,
		  "module": "volume_discount"
		});
	  } // end for loop
	  if (WS.productVd.length > 0) {
		// sort array by priority
		WS.productVd.sort(function (a, b) {
		  return Number(a.priority) - Number(b.priority)
		});
		// if this array contains multiple applies to, then filter by products or by collection, to exclude extra rules.
		if (-1 < WS.productVd.findIndex(function (x) {
		  return x.applies_to == "products"
		})) {
		  WS.productVd = WS.productVd.filter(function (x) {
			return x.applies_to === "products"
		  });
		} else if (-1 < WS.productVd.findIndex(function (x) {
		  return x.applies_to == "collections"
		})) {
		  WS.productVd = WS.productVd.filter(function (y) {
			return y.applies_to === "collections"
		  });
		}
	  }
	  WS.product_qb = [];
	  WS.product_volume_discount = {};
	  WS.vd_has_discount = false; // assume this has
	  if (WS.productVd && WS.productVd.length > 1) {
         var rule_date_found = WS.productVd.some(function(e,r){ return typeof e.created_at !== "undefined"});
        if(rule_date_found){
          var update_sorted_rule = JSON.parse(JSON.stringify(WS.productVd));
          try{
			
            update_sorted_rule.sort(function(a,b){
                if(typeof a.created_at === 'undefined' || typeof b.created_at === 'undefined'){
                  return 0;
                }else{
                    if(new Date(a.created_at) > new Date(b.created_at)){
                       return -1;
                    }else{
                        return 1;
                    }
                }
            });
          } catch(e){ update_sorted_rule = []; }
  
          if(update_sorted_rule.length > 0){
            WS.productVd = JSON.parse(JSON.stringify(update_sorted_rule));
          }
          
        }
		WS.productVd = [WS.productVd[0]];
	  }

      var hasImported_Rule = WS.productVd.some(function(item){
        return item.applies_to == "products" && item.products.length && item.products[0].id == item.products[0].handle;
      });
	  if(hasImported_Rule || WSAIO.variant_sku_are_same == false){
		WSAIO_variant_sku_are_same = false;
	  }

	  // Checking priority of volume discount. 
	  WS.volumeDiscountPriority();
	  if (WS.productVd && WS.productVd.length > 0) {
		WS.vd_has_discount = true;
		// for loop
		for (var j = 0, len_j = WS.productVd.length; j < len_j; j++) {
		  var vd_rule = WS.productVd[j];
		  if ("products" === vd_rule.applies_to && vd_rule.individual_product === true) {
			for (var kk = 0; kk < vd_rule.products.length; kk++) {
			  var product = vd_rule.products[kk],
				  pIndex = kk;
			  if (product.handle === WS.selected_product.handle || product.id == WS.selected_product.id) {
				if (WS.product_volume_discount.handle !== product.handle) {
				  WS.product_volume_discount = JSON.parse(JSON.stringify(vd_rule));
				  WS.product_volume_discount["product"] = product;
				}
				if (product.variant_level) {
				  for (var ll = 0; ll < product.variants.length; ll++) {
					var variant = product.variants[ll],
						vIndex = ll;

					var check_tag = false;
					var vIn_check = false;
					var vIn_check = variant.tag_options.findIndex(function (apt) {
						if(apt.name.toString().toLowerCase() == 'all'){
                           return true;
						}
					})
					if(vIn_check > -1){
                        if(WSAIO.customer){
					var vIn = variant.tag_options.findIndex(function (apt) {
								if(apt.name.toString().toLowerCase() !== 'all'){
						WS.applied_tag_array.findIndex(function (single_tag){
							if(apt.name.toString().toLowerCase() == single_tag.toString().toLowerCase())
							{
								check_tag = true;
												
							}
						})
						if(check_tag){
							return true;
						}
								}
							})
						}
						if(!check_tag){
							var vIn = variant.tag_options.findIndex(function (apt) {
								WS.applied_tag_array.findIndex(function (single_tag){
									if(apt.name.toString().toLowerCase() == single_tag.toString().toLowerCase())
											{
												check_tag = true;
												
											}
									})
									if(check_tag){
										return true;
									}
							})
						}
					}else{
						var vIn = variant.tag_options.findIndex(function (apt) {
						WS.applied_tag_array.findIndex(function (single_tag){
							if(apt.name.toString().toLowerCase() == single_tag.toString().toLowerCase())
									{
										check_tag = true;
										
									}
							})
							if(check_tag){
								return true;
							}
						})
					}
          var variant_sku = variant.sku;
          var selected_variant_sku = WS.selected_variant.sku;
          if(variant_sku != null && variant_sku != ''){ variant_sku = variant_sku.toLowerCase();}
          if(selected_variant_sku != null && selected_variant_sku != ''){ selected_variant_sku = selected_variant_sku.toLowerCase();}
          if (vIn > -1 && (variant.id == WS.selected_variant.id) || ((variant_sku == selected_variant_sku && hasImported_Rule) && !WSAIO_variant_sku_are_same)) {
					  var v_tag_option = variant.tag_options[vIn];
					  WS.product_qb.push({
						name: v_tag_option.name,
						value: v_tag_option.value,
						type: v_tag_option.type,
						qty: variant.quantity
					  });
					}
				  }
				} else {
					var check_tag = false;
					var vIn_check = false;
					var vIn_check = product.tag_options.findIndex(function (apt) {
						if(apt.name.toString().toLowerCase() == 'all'){
                           return true;
						}
					})
					if(vIn_check > -1){
                        if(WSAIO.customer){
					var pIn = product.tag_options.findIndex(function (apt) {
								if(apt.name.toString().toLowerCase() !== 'all'){
					  WS.applied_tag_array.findIndex(function (single_tag){
						  if(apt.name.toString().toLowerCase() == single_tag.toString().toLowerCase())
						  {
							  check_tag = true;
						  }
					  })
					  if(check_tag){
						  return true;
					  }
								}
					});
						}
						if(!check_tag){
							var pIn = product.tag_options.findIndex(function (apt) {
								WS.applied_tag_array.findIndex(function (single_tag){
									if(apt.name.toString().toLowerCase() == single_tag.toString().toLowerCase())
									{
										check_tag = true;
									}
								})
								if(check_tag){
									return true;
								}
							  });
						}
					}else{
					var pIn = product.tag_options.findIndex(function (apt) {
					  WS.applied_tag_array.findIndex(function (single_tag){
						  if(apt.name.toString().toLowerCase() == single_tag.toString().toLowerCase())
						  {
							  check_tag = true;
						  }
					  })
					  if(check_tag){
						  return true;
					  }
					});
					}
					
				  if (pIn > -1) {
					var tag_option = product.tag_options[pIn];
					WS.product_qb.push({
					  name: tag_option.name,
					  value: tag_option.value,
					  type: tag_option.type,
					  qty: product.quantity
					});
				  }
				}
			  }
			}
		  } else {
			for (var pp = 0; pp < vd_rule.volume_discount.length; pp++) {
			  var vd = vd_rule.volume_discount[pp],
				  vdIndex = pp;
			  WS.product_qb.push({
				name: vd_rule.applies_to,
				value: vd.value,
				type: vd_rule.discount_type,
				qty: vd.qty
			  });
  
			}
			WS.product_volume_discount = JSON.parse(JSON.stringify(vd_rule));
			if (vd_rule.applies_to === "collections") {
			  WS.product_volume_discount["collections"] = WS.product_volume_discount.collections.filter(function (c) {
				return c.id == WS.selected_collection.id
			  });
			}
		  }
		}
	  }
	  WS.product_volume_discount["volume_discount"] = JSON.parse(JSON.stringify(WS.product_qb));
    if(typeof WS.product_volume_discount.show_volume_table_heading != 'undefined' && WS.product_volume_discount.show_volume_table_heading){
      if(typeof WS.product_volume_discount.volume_table_heading != 'undefined' && WS.product_volume_discount.volume_table_heading != ''){
        params['volume_table_heading'] = WS.product_volume_discount.volume_table_heading; 
      }
    }
	  // if TRUE, app will alter prices. our app will output price and compare at price
	  if (WS.output && WS.vd_has_discount && (typeof WS.product_volume_discount.display_option != 'undefined' && WS.product_volume_discount.display_option != 'no_volume_table') && ( WS.product_volume_discount.enable_volume_table == undefined || (typeof WS.product_volume_discount.enable_volume_table != 'undefined' && WS.product_volume_discount.enable_volume_table))) {
		if (WS.landingTemplate === "product" || (window.location.href.indexOf('/pages/') > -1 && WS.landingTemplate === "collection") || WSAIO.show_volumeRange || (WS.landingTemplate === "collection" && WSAIO.applied_rgDiscount_price == 0)) {
		  // Remove the table, also check for the quick view
		  if (WS.remove_duplicate_table) {
			document.querySelectorAll(".wholesale-table").forEach(element => {
				element.remove();
			});
		  }
		  if (typeof WS.product_volume_discount === 'undefined') isError("Volume discount table could not created. Because the rule is empty or not defined. Reference variable is WSAIO.product_volume_discount.");
		  switch (WS.product_volume_discount.display_option) {
			case "detailed_grid":
			  WS.detailed_grid_table(WS.product_volume_discount, params);
			  break;
			case "basic_grid":
			  WS.basic_grid_table(WS.product_volume_discount, params);
			  break;
			case "grid_range":
			  WS.grid_range_table(WS.product_volume_discount, params);
			  break;
			case "detailed_grid_percent":
			  WS.detailed_grid_percent_table(WS.product_volume_discount, params);
			  break;
			case "percent_grid":
			  WS.percent_grid_table(WS.product_volume_discount, params);
			  break;
			case "grid_range_alternate":
			  WS.grid_range_alternate_table(WS.product_volume_discount, params);
			  break;
			default:
			  WS.grid_range_alternate_table(WS.product_volume_discount, params);
			  break;
		  }
		} else {
		  // This is used for collection listing page
		  var value_range = [];
		  for (var ee = 0; ee < WS.product_volume_discount.volume_discount.length; ee++) {
			var v = WS.product_volume_discount.volume_discount[ee];
			value_range.push(Number(v.value));
		  }
		  var min = Math.min.apply(null, value_range);
		  var max = Math.max.apply(null, value_range);
		  log("Min discount: " + min);
		  log("Max discount: " + max);
		  var max_discount_index = WS.product_volume_discount.volume_discount.findIndex(function (b) {
			return b.value == max
		  });
		  if (max_discount_index > -1) {
			var max_discount = WS.product_volume_discount.volume_discount[max_discount_index];
			var price = Number(WS.mF(WS.selected_variant.price));
			var discount = WS.get_discount(price, max_discount.type, max_discount.value);
			if (Number(discount) == 0 || (Number(price) == 0)) {
			  WS.vd_has_discount = false;
			}
			if (WS.vd_has_discount) {
			  var compare_at_price = Number(WS.mF(WS.selected_variant.price));
			  if (WS.general_settings.show_compare_at_price) {
				compare_at_price = Number(WS.mF(WS.selected_variant.compare_at_price));
			  }
			  if (isNaN(WS.selected_variant.compare_at_price) || (Number(WS.selected_variant.compare_at_price) <= Number(WS.selected_variant.price))) {
				compare_at_price = 0;
				if ((Number(price) - Number(discount)) < Number(price)) {
				  compare_at_price = Number(price).toFixed(2);
				}
			  }
			  var regular_price = WS.formatMoney((Number(price) - Number(discount)).toFixed(2));
			  compare_at_price = WS.formatMoney(Number(compare_at_price).toFixed(2));
			  if (Number(compare_at_price) < 1) {
				compare_at_price = "";
			  }
			  if (!WS.general_settings.compare_at_price) {
				compare_at_price = "";
			  }
			  var html = '';
			  if (WS.template === 'product') {
				html = WS.product_price_html;
			  } else {
				html = WS.hcsr_qb_price_html;
			  }
              if (!WS.general_settings.compare_at_price) {
				compare_at_price = "";
				html = WSAIO.remove_comparePrice(html);
			  }
			  try {
				compare_at_price = compare_at_price.replace("$", "$@");
				regular_price = regular_price.replace("$", "$@");
			  } catch (e) {
				log(e)
			  }
			  html = html
			  .replace(new RegExp("%regular_price%", "gi"), WS.Lang.from + " " + regular_price)
			  .replace(new RegExp("%compare_at_price%", "gi"), compare_at_price);
			  try {
				html = html.replace(/@/g, '');
			  } catch (e) {
				log(e);
			  }
			  if (params.item_price_selector && WS.selected_product.id) {
				document.querySelectorAll(params.item_price_selector).forEach(element => {
					element.innerHTML = html;
				});
			  } else {
				isError("Item price selector is undefined");
			  }			  
			}
		  }
		}
		WS.saleClock(WS.product_volume_discount, WS.selected_product, "vd");
	  }
	  if (typeof WS.callback === 'function') {
		WS.callback({
		  product_volume_discount: WS.product_volume_discount,
		  quantity_breaks: WS.product_qb,
		  product: WS.selected_product,
		  variant: WS.selected_variant
		});
	  }
	  // response back
	  if (typeof callback === 'function') {
		callback({
		  product_volume_discount: WS.product_volume_discount,
		  quantity_breaks: WS.product_qb,
		  product: WS.selected_product,
		  variant: WS.selected_variant
		});
	  }
	  // end for loop
	};
  
	WSAIO.regularDiscount = function (params, callback) {
		
	  if (WSAIO.debugger) debugger;
	  if (typeof params === 'function') callback = params;
	  if(!params){
		isError("No params provided for regular discount");
		return false;
	  }
	  if(!params.item_price_selector){
		isError("Item price selector is undefined");
		// return false;
	  }
	  if (WSAIO.isWholesaleCustomer() === false) {
		if (typeof callback === "function") {
		  return callback({
			error: "Invalid customer"
		  });
		} else {
		  return "Invalid customer";
		}
	  }
	 
	
      let price_selector = [];

	  if (typeof params.item_price_selector === 'string') {
            price_selector = document.querySelectorAll(params.item_price_selector);
		} else if (params.item_price_selector instanceof Element) {
            price_selector = [params.item_price_selector];
		} else if (params.item_price_selector?.length) {
            price_selector = Array.from(params.item_price_selector);
	  }

		price_selector.forEach(el => {
                if (!el) return;
                const pid = `wsaio_${params.product_id}`;
                const vid = `wsaio_${params.variant_id}`;
                if (el.getAttribute('class') !== undefined) {
            const hasWsaio = el.className.includes('wsaio_');
            const isQuickOrder = el.closest('.quick-order-list__table');
		if (!hasWsaio && !isQuickOrder) {
                        el.classList.add(pid, vid);
				} else {
                        el.classList.remove(pid);
                        el.classList.add(pid, vid);
				}
			}
        });


      var WSAIO_variant_sku_are_same = true;
      WSAIO.rd_or_regularPrice = 0;
	   
      if (typeof params.template !== 'undefined' && typeof WSAIO.auto_vat_enable != 'undefined' &&  WSAIO.auto_vat_enable){
		   var _id = params.product_id;
		   if(WSAIO.template != 'cart' && typeof WSAIO.product_in_collects != 'undefined' && WSAIO.product_in_collects.length != 0){
				var _indx = WSAIO.product_in_collects.findIndex(function(e,r){
					return e.product_id == _id;
				});
				if(typeof WSAIO.product_in_collects[_indx] != 'undefined' && typeof WSAIO.product_in_collects[_indx].product_variants != 'undefined'){
			     	var  current_product_variant = WSAIO.product_in_collects[_indx].product_variants;
					var _indx_of_variant = current_product_variant.findIndex(function(d,t){
						return d.id == params.variant_id;
					});
					WSAIO.selected_variant_taxable = current_product_variant[_indx_of_variant].taxable;
					// if Price set in price adjustment, then no tax include function run
					if(typeof WSAIO.tax_settings != 'undefined' && WSAIO.tax_settings.presentment != null && WSAIO.tax_settings.presentment.price_adjustments != null && typeof WSAIO.tax_settings.presentment.price_adjustments.fixed_variant_ids != 'undefined' && WSAIO.tax_settings.presentment.price_adjustments.fixed_variant_ids.length && WSAIO.tax_settings.presentment.price_adjustments.fixed_variant_ids.indexOf(current_product_variant[_indx_of_variant].id) > -1){
						WSAIO.selected_variant_taxable = false;
					}
				}
			}else if(typeof WSAIO.products_with_collections != 'undefined' && WSAIO.products_with_collections.length != 0){
				var _indx = WSAIO.products_with_collections.findIndex(function(e,r){
					return e.product_id == _id;
				});
				if(typeof WSAIO.products_with_collections[_indx] != 'undefined' && typeof WSAIO.products_with_collections[_indx].product_variants != 'undefined'){
					var  current_product_variant = WSAIO.products_with_collections[_indx].product_variants;
					var _indx_of_variant = current_product_variant.findIndex(function(d,t){
						return d.id == params.variant_id;
					})
					WSAIO.selected_variant_taxable = current_product_variant[_indx_of_variant].taxable;
					// if Price set in price adjustment, then no tax include function run
					if(typeof WSAIO.tax_settings != 'undefined' && WSAIO.tax_settings.presentment != null && WSAIO.tax_settings.presentment.price_adjustments != null && typeof WSAIO.tax_settings.presentment.price_adjustments.fixed_variant_ids != 'undefined' && WSAIO.tax_settings.presentment.price_adjustments.fixed_variant_ids.length && WSAIO.tax_settings.presentment.price_adjustments.fixed_variant_ids.indexOf(current_product_variant[_indx_of_variant].id) > -1){
						WSAIO.selected_variant_taxable = false;
					}
				}
			}
      }
     
	  WS.output = true;
	  WS.selected_variant = JSON.parse(JSON.stringify(WS.current_variant)); // current variant obj should not change
	  WS.selected_product = JSON.parse(JSON.stringify(WS.current_product)); // current product obj should not change
	  WS.selected_collection = JSON.parse(JSON.stringify(WS.current_collection)); // current collection obj should not change
	  if (typeof params === 'object') {
		if (typeof params.product_id !== 'undefined' && params.product_id !== "default") WS.selected_product.id = params.product_id;
		if (typeof params.product_handle !== 'undefined' && params.product_handle !== "default") WS.selected_product.handle = params.product_handle;
		if (typeof params.variant_id !== 'undefined' && params.variant_id !== "default") WS.selected_variant.id = params.variant_id;
		if (typeof params.variant_sku !== 'undefined' && params.variant_sku !== "default") WS.selected_variant.sku = params.variant_sku;
		if (typeof params.variant_price !== 'undefined' && params.variant_id !== "default") WS.selected_variant.price = params.variant_price;
		if (typeof params.variant_compare_at_price !== 'undefined' && params.variant_sku !== "default") WS.selected_variant.compare_at_price = params.variant_compare_at_price;
		if (typeof params.collection_id !== 'undefined' && params.collection_id !== "default") WS.selected_collection.id = params.collection_id;
		if (typeof params.output !== 'undefined' && params.output !== "default") WS.output = params.output;
		if (typeof params.template !== 'undefined' && params.template !== "default") WS.landingTemplate = params.template;
	  }
	  if (WS.selected_variant && typeof WS.selected_variant.price === "string" && WS.selected_variant.price.indexOf(".") > -1) {
		WS.selected_variant.price = WS.selected_variant.price.replace('.', '');
	  }
	  if (WS.selected_variant && typeof WS.selected_variant.compare_at_price === "string" && WS.selected_variant.compare_at_price.indexOf(".") > -1) {
		WS.selected_variant.compare_at_price = WS.selected_variant.compare_at_price.replace('.', '');
	  }
	  WS.productRd = [];

      var hasImportRule = WS.regular_discounts.some(function(item){
        return item.applies_to == "products" && item.products.length && item.products[0].id == item.products[0].handle;
      });

	  if(hasImportRule){
		WS.regular_discounts.sort(function (a, b) {
			// Shifting import rule to end
			if(b.applies_to == "products" || a.applies_to == "products"){
				if(a.products != undefined && a.products.length && (a.products[0].id == a.products[0].handle)){
					return 1;
				}
				if(b.products != undefined && b.products.length && (b.products[0].id == b.products[0].handle)){
					return -1;
				}
                }
			return 0;
		});
	}

	  WS.applied_tag_array = [];
	  // for loop
	  for (var i = 0, len_i = WS.regular_discounts.length; i < len_i; i++) {
		var regular_discount = WS.regular_discounts[i];
		if (regular_discount.state !== 'published') continue;
		if (WS.checkCustomer(regular_discount.customer_group, regular_discount.tags, regular_discount.tags_excluded) === false) continue;
		if (regular_discount.schedule_active) {
		  var _schedule = WS.getSchedule(regular_discount.schedule);
		  log("_schedule", _schedule);
		  if (_schedule.ends_in) {
			if (
			  Number(_schedule.ends_in.years) <= 0 &&
			  Number(_schedule.ends_in.months) <= 0 &&
			  Number(_schedule.ends_in.days) <= 0 &&
			  Number(_schedule.ends_in.hours) <= 0 &&
			  Number(_schedule.ends_in.minutes) <= 0 &&
			  Number(_schedule.ends_in.seconds) <= 0
			) {
			  log("This rule was expired", _schedule);
			  continue;
			}
			if (
			  Number(_schedule.started.years) >= 0 &&
			  Number(_schedule.started.months) >= 0 &&
			  Number(_schedule.started.days) >= 0 &&
			  Number(_schedule.started.hours) >= 0 &&
			  Number(_schedule.started.minutes) >= 0 &&
			  Number(_schedule.started.seconds) >= 0
			) {
			  log("This rule was schedules and will be started in", _schedule);
			  continue;
			}
		  }
		}
		WS.checkAppliesTo({
		  "type": regular_discount.applies_to,
		  "rule": regular_discount,
		  "module": "regular_discount"
		});
	  } // end for loop
	  if (WS.productRd.length > 0) {
		// sort array by priority
		WS.productRd.sort(function (a, b) {
		  return Number(a.priority) - Number(b.priority)
		});
		// if this array contains multiple applies to, then filter by products or by collection, to exclude extra rules.
		if (-1 < WS.productRd.findIndex(function (x) {
		  return x.applies_to == "products"
		})) {
		  WS.productRd = WS.productRd.filter(function (x) {
			return x.applies_to === "products"
		  });
		} else if (-1 < WS.productRd.findIndex(function (x) {
		  return x.applies_to == "collections"
		})) {
		  WS.productRd = WS.productRd.filter(function (y) {
			return y.applies_to === "collections"
		  });
		}
	  }
	  
	  WS.product_rd_obj = [];
	  WS.product_regular_discount = {};
	  WS.rd_has_discount = false; // assume this has
	  if (WS.productRd && WS.productRd.length > 1) {
        var rule_date_found = WS.productRd.some(function(e,r){ return typeof e.created_at !== "undefined"});
        if(rule_date_found){
          var update_sorted_rule = JSON.parse(JSON.stringify(WS.productRd));
          try{
            update_sorted_rule.sort(function(a,b){
                if(typeof a.created_at === 'undefined' || typeof b.created_at === 'undefined'){
                  return 0;
                }else{
                    if(new Date(a.created_at) > new Date(b.created_at)){
                       return -1;
                    }else{
                        return 1;
                    }
                }
            });
          } catch(e){ update_sorted_rule = []; }
  
          if(update_sorted_rule.length > 0){
            WS.productRd = JSON.parse(JSON.stringify(update_sorted_rule));
          }
          
        }
		WS.productRd = [WS.productRd[0]];
	  }
	  
	  var hasImported_Rule = WS.productRd.some(function(item){
        return item.applies_to == "products" && item.products.length && item.products[0].id == item.products[0].handle;
      });
      if(hasImported_Rule || WSAIO.variant_sku_are_same == false){
		WSAIO_variant_sku_are_same = false;
	  }

	  if (WS.productRd.length > 0) {
		WS.rd_has_discount = true;
		// for loop
		for (var j = 0, len_j = WS.productRd.length; j < len_j; j++) {
		  var rd_rule = WS.productRd[j];
		  if ("products" === rd_rule.applies_to && rd_rule.individual_product === true) {
			for (var tt = 0; tt < rd_rule.products.length; tt++) {
			  var product = rd_rule.products[tt],
				  pIndex = tt;
			  if (product.handle === WS.selected_product.handle || product.id == WS.selected_product.id) {
				if (WS.product_regular_discount.handle !== product.handle) {
				  WS.product_regular_discount = JSON.parse(JSON.stringify(rd_rule));
				  WS.product_regular_discount["product"] = product;
				}
				if (product.variant_level) {
				  for (var nn = 0; nn < product.variants.length; nn++) {
					var variant = product.variants[nn],
						vIndex = nn;
						var check_tag = false;
						var vIn = variant.tag_options.findIndex(function (apt) {
							WS.applied_tag_array.findIndex(function (single_tag){
								if(apt.name.toString().toLowerCase() == single_tag.toString().toLowerCase())
								{
									check_tag = true;
								}
							})
							if(check_tag){
								return true;
							}
						});
          var variant_sku = variant.sku;
          var selected_variant_sku = WS.selected_variant.sku;
          if(variant_sku != null && variant_sku != ''){ variant_sku = variant_sku.toLowerCase();}
          if(selected_variant_sku != null && selected_variant_sku != ''){ selected_variant_sku = selected_variant_sku.toLowerCase();}
          if (vIn > -1 && (variant.id == WS.selected_variant.id || ((variant_sku == selected_variant_sku && hasImported_Rule) && (!WSAIO_variant_sku_are_same)))) {
					  var v_tag_option = variant.tag_options[vIn];
					  WS.product_rd_obj.push({
						name: v_tag_option.name,
						value: v_tag_option.value,
						type: v_tag_option.type
					  });
					}
				  }
				} else {
					var check_tag = false;
					var pIn = product.tag_options.findIndex(function (apt) {
					  WS.applied_tag_array.findIndex(function (single_tag){
						  if(apt.name.toString().toLowerCase() == single_tag.toString().toLowerCase())
						  {
							  check_tag = true;
						  }
					  })
					  if(check_tag){
						  return true;
					  }
					});
				  if (pIn > -1) {
					var tag_option = product.tag_options[pIn];
					WS.product_rd_obj.push({
					  name: tag_option.name,
					  value: tag_option.value,
					  type: tag_option.type
					});
				  }
				}
			  }
			}
		  } else {
			WS.product_rd_obj = {
			  name: rd_rule.applies_to,
			  type: rd_rule.discount_type,
			  value: rd_rule.discount_value
			}
			WS.product_regular_discount = JSON.parse(JSON.stringify(rd_rule));
			if (rd_rule.applies_to === "collections") {
			  WS.product_regular_discount["collections"] = WS.product_regular_discount.collections.filter(function (c) {
				return c.id == WS.selected_collection.id
			  });
			}
		  }
		}
	  }
        
	  WS.product_regular_discount["volume_discount"] = JSON.parse(JSON.stringify(WS.product_rd_obj));
	  // if TRUE, app will alter prices. our app will output price and compare at price
	  var price = Number(WS.mF(WS.selected_variant.price));

	  // if customer exampt true, then subtract international tax from original price
	  if(WSAIO.customer.id != null && WSAIO.customer.tax_exempt && WSAIO.selected_variant_taxable){
		if(typeof WSAIO.tax_settings !== "undefined" && WSAIO.tax_settings && typeof WSAIO.tax_settings.taxes_included !== "undefined" && WSAIO.tax_settings.taxes_included === true &&  typeof WSAIO.tax_settings.auto_configure_tax_inclusivity != 'undefined' && WSAIO.tax_settings.auto_configure_tax_inclusivity && typeof WSAIO.auto_vat_enable != 'undefined' &&  WSAIO.auto_vat_enable){
		       price = Number(WS.mF(WS.selected_variant.price))/(1+WSAIO.tax_settings.presentment.tax);
         }
	  }
	  if (WS.product_regular_discount["volume_discount"].length > 0) {
		WS.product_regular_discount.discount_type = WS.product_regular_discount["volume_discount"][0].type;
		WS.product_regular_discount.discount_value = WS.product_regular_discount["volume_discount"][0].value;
	  }
	  if (typeof WS.product_regular_discount.discount_type === 'undefined') {
		WS.rd_has_discount = !1;
	  }
	  if (typeof WS.product_regular_discount.discount_value === 'undefined') {
		WS.rd_has_discount = !1;
	  }
	  var discount = WS.get_discount(price, WS.product_regular_discount.discount_type, WS.product_regular_discount.discount_value);
	  if (Number(discount) == 0 || (Number(price) == 0)) {
		WS.rd_has_discount = !1;
	  }
	 
	  WSAIO.applied_rgDiscount_price = 0;
      WSAIO.rd_or_regularPrice = price;
	  if (WS.rd_has_discount && WS.output) {
		var regular_price = (Number(price) - Number(discount)).toFixed(2);
		if(WSAIO.general_settings.discount_method == 'coupon_code' && (typeof WSAIO.enable_lineCouponCode != 'undefined' && WSAIO.enable_lineCouponCode)){
			var discounted_percentage = ((Number(discount)/Number(price))*100);
			if(WS.product_regular_discount.discount_type == 'price_discount' || WS.product_regular_discount.discount_type == 'fixed_price'){
				const original_price = ((Number(price)/Shopify.currency.rate).toFixed(0))*Shopify.currency.rate;
				discounted_percentage = ((Number(discount)/Number(original_price))*100)
			} 
			setTimeout(function() {
					const itemPriceElement = document.querySelector(params.item_price_selector);

					if (itemPriceElement) {
						const parentGridElement = itemPriceElement.closest(WSAIO.product_parent_grid_selector);
						if (parentGridElement) {
							const priceFieldElement = parentGridElement.querySelector('.item_wsaio_price_field');
							if (priceFieldElement) {
								priceFieldElement.value = WSAIO.encode(discounted_percentage);
							}
						}
					}
				}, 100);
				setTimeout(function() {
						const itemPriceElement = document.querySelector(params.item_price_selector);
						if (itemPriceElement) {
							const parentQuickView = itemPriceElement.closest(WSAIO.quickView_parent_Selector);
							if (parentQuickView) {
								const priceFieldElement = parentQuickView.querySelector('.item_wsaio_price_field');
								if (priceFieldElement) {
									priceFieldElement.value = WSAIO.encode(discounted_percentage);
								}
							}
						}
					}, 100);
			}
		var compare_at_price = Number(WS.mF(WS.selected_variant.price));
		if (WS.general_settings.show_compare_at_price) {
		  compare_at_price = Number(WS.mF(WS.selected_variant.compare_at_price));
		}
		if (isNaN(WS.selected_variant.compare_at_price) || (Number(WS.selected_variant.compare_at_price) <= Number(WS.selected_variant.price))) {
		  compare_at_price = 0;
		  if ((Number(price) - Number(discount)) < Number(price)) {
			compare_at_price = Number(price).toFixed(2);
		  }
		}
		
		var html = WS.hcsr_price_html;
		var saved_price_html = WS.saved_price_in_grid_html;
		
		if (WS.template === 'product') {
		  html = WS.product_price_html, saved_price_html = WS.saved_price_html;
		}
		if(html.indexOf('%compare_at_price%') == -1){
            html = '<del class="money" style="padding-right:10px;">%compare_at_price%</del>' + html; 
        }
		var total_saved = WS.saved_amount(compare_at_price, regular_price);
		saved_price_html = saved_price_html
		.replace(new RegExp("%saved_amount:price%", "gi"), WS.formatMoney(Number(total_saved.price)))
		.replace(new RegExp("%saved_amount:percentage%", "gi"), total_saved.percentage);
		if((total_saved.price).indexOf('-') == -1 && (total_saved.percentage).indexOf('-') == -1){
		WS.alterHTML(saved_price_html, WS.product_saved_amount_selector.replace("%id%", WS.selected_product.id));
		}
		WS.product_regular_discount.total_saved = total_saved;
		WS.product_regular_discount.regular_price = (Number(price) - Number(discount)).toFixed(2);
		WS.product_regular_discount.compare_at_price = Number(compare_at_price).toFixed(2);
		WSAIO.applied_rgDiscount_price = (Number(price) - Number(discount)).toFixed(2);
		var actual_regularPrice = 0;
        var excluded_actual_regularPrice = 0;
		if(WSAIO.exclude_VAT != 0 && WSAIO.check_eligible_customer()){
            var exclude_value = (WSAIO.exclude_VAT/100) + 1;
            if(typeof QOF_page !== 'undefined' && QOF_page && (typeof WSAIO.QOF_version == 'undefined' || WSAIO.QOF_version == 1)){
              regular_price = WS.formatMoney(((Number(price) - Number(discount))/exclude_value)*100);
			  WSAIO.applied_rgDiscount_price = ((Number(price) - Number(discount))/exclude_value)*100;
              compare_at_price = WS.formatMoney(((Number(compare_at_price))/exclude_value)*100);
			  excluded_actual_regularPrice = WS.formatMoney(((Number(price) - Number(discount))/exclude_value)*100);
			  actual_regularPrice = WS.formatMoney((Number(price) - Number(discount))*100)
              }else{
            regular_price = WS.formatMoney(((Number(price) - Number(discount))/exclude_value));
			WSAIO.applied_rgDiscount_price = ((Number(price) - Number(discount))/exclude_value);
            compare_at_price = WS.formatMoney(((Number(compare_at_price))/exclude_value));
			excluded_actual_regularPrice = WS.formatMoney(((Number(price) - Number(discount))/exclude_value));
			actual_regularPrice = WS.formatMoney(Number(price) - Number(discount))
            }
          }else{
              if(typeof QOF_page !== 'undefined' && QOF_page && (typeof WSAIO.QOF_version == 'undefined' || WSAIO.QOF_version == 1)){
                  regular_price = WS.formatMoney((Number(price) - Number(discount))*100);
				  WSAIO.applied_rgDiscount_price = (Number(price) - Number(discount))*100;
                  compare_at_price = WS.formatMoney(Number(compare_at_price)*100);
              }else{
                  regular_price = WS.formatMoney((Number(price) - Number(discount)));
				  WSAIO.applied_rgDiscount_price = (Number(price) - Number(discount));
                  compare_at_price = WS.formatMoney(Number(compare_at_price));
              }
       
          }
        if(WSAIO.applied_rgDiscount_price != 0){
          WSAIO.rd_or_regularPrice = WSAIO.applied_rgDiscount_price;
          }
		const selector = `.moq_v_disc.wsaio-MOQqt-${WS.selected_variant.id}`;
		const elements = document.querySelectorAll(selector);

		if (elements.length > 0) {
			elements.forEach(element => {
				element.innerHTML = regular_price;
			});
		}
		
		if (Number(compare_at_price) < 1 || Number(WS.product_regular_discount.compare_at_price == 0) || (Number(WS.product_regular_discount.compare_at_price) < Number(WS.product_regular_discount.regular_price))) {
		  compare_at_price = "";
		}
		if (!WS.general_settings.compare_at_price) {
		  compare_at_price = "";
		}
		try {
		  compare_at_price = compare_at_price.replace("$", "$@");
		  regular_price = regular_price.replace("$", "$@");
		} catch (e) {
		  log(e)
		}

		if(typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO.formatMoney('0').indexOf(Shopify.currency.active) == -1){
            regular_price = regular_price+' '+Shopify.currency.active;
            actual_regularPrice = actual_regularPrice+' '+Shopify.currency.active;
            excluded_actual_regularPrice = excluded_actual_regularPrice+' '+Shopify.currency.active;
            if(compare_at_price != ""){
                compare_at_price = compare_at_price+' '+Shopify.currency.active;
            }
        }

   
		if(typeof QOF_page !== 'undefined' && QOF_page && (typeof WSAIO.QOF_version == 'undefined' || WSAIO.QOF_version == 1.1)){
			html = `<div class="wsaio_sale_price pri" style=" line-height: 1.2;color: #403b37 !important; "> <span class="money wsaio-crossout" style=" text-decoration: line-through; font-size: 12px; display: block; "> ${compare_at_price} </span> <span class="money wsaio-sale" style=" font-size: 12px; "> ${regular_price} </span> </div>`;
		}else{
		html = html.replace(new RegExp("%regular_price%", "gi"), regular_price)
		.replace(new RegExp("%compare_at_price%", "gi"), compare_at_price);
		if (WS.landingTemplate !== "product" && WS.landingTemplate !== "cart") {
		  html = html
		  .replace(new RegExp("%regular_price%", "gi"), regular_price)
		  .replace(new RegExp("%compare_at_price%", "gi"), compare_at_price);
		}
		}
		try {
			if (price_selector) {
				price_selector.forEach(el => {
                    if (el) {
                        el.classList.remove("wsdapp");
                    }
                });
			}
		} catch (e) {}
		try {
		  html = html.replace(/@/g, '');
		} catch (e) {
		  log(e);
		}
		
		html = remove_emptyElement(html);

			if (price_selector) {
				if (WSAIO.exclude_VAT !== 0 && 
					WSAIO.check_eligible_customer() && 
					typeof WSAIO.excludePrice_design !== 'undefined' && 
					WSAIO.excludePrice_design === 'without-crossout') {
					if (!WS.general_settings.compare_at_price) { 
						actual_regularPrice = ""; 
					}
					const vatHtml = `
						<div class="wsaio_vat_price"> 
							<div class="money">${actual_regularPrice}</div> 
							<div class="money">${excluded_actual_regularPrice}<span class="wsaio_excl" style="font-size:12px;padding-left: 4px;">(Excl. Tax)</span></div> 
						</div>
					`;
					price_selector.forEach(el => {
                        if (!el || el.classList.contains("wsdapp")) return;
                        el.innerHTML = vatHtml; 
                    });
					
				} else {
					price_selector.forEach(el => {
                        if (!el || el.classList.contains("wsdapp")) return;
                        el.innerHTML = html; 
                    });
					
				}
				price_selector.forEach(el => {
                    if (el) {
                        el.classList.add("wsdapp");
			}
                });
			if(compare_at_price == ''){
					price_selector.forEach(el => {
						if (el) {
							el.classList.add("wsnocompare");
						}
					});
			}
		}
		document.querySelector('modal-dialog[open]')?.querySelectorAll('.price__container').forEach(function(e){e.style.display='none';})
		WS.saleClock(WS.product_regular_discount, WS.selected_product, "rd");
	  }
	  // response back
	  if (typeof callback === 'function') {
		callback({
		  product_regular_discount: WS.product_regular_discount,
		  regular_discounts: WS.product_rd_obj,
		  product: WS.selected_product,
		  variant: WS.selected_variant,
		  ws_discount: discount
		});
	  }
	  if (typeof WS.callback === 'function') {
		WS.callback({
		  product_regular_discount: WS.product_regular_discount,
		  regular_discounts: WS.product_rd_obj,
		  product: WS.selected_product,
		  variant: WS.selected_variant,
		  ws_discount: discount
		});
	  }
	};
  
	WSAIO.cartLevelDiscount = function () {
	  var is_cld = false;
	  if (WSAIO.cart_ld_discounts && WSAIO.cart_ld_discounts.length) {
		for (var cld_index = 0; cld_index < WSAIO.cart_ld_discounts.length; cld_index++) {
		  var rule_item = WSAIO.cart_ld_discounts[cld_index];
		  if (rule_item.state != 'published') continue;
		  if (WS.checkCustomer(rule_item.customer_group, rule_item.tags, rule_item.tags_excluded) === false) continue;
		  is_cld = true;
		  break;
		}
	  }
	  return is_cld;
	}
  
	WSAIO.Volume_disocunted_price = function(qty,type="standard"){
      var return_data = null;
      var reg_price = null,comp_price = null;
	  if(typeof current_product != 'undefined' && current_product != null){
	  var selected_variant_index = current_product.variants.findIndex(function (a) {
		return a.id == selected_variant_id
	  });
	  var Total_quantity = qty;
	  var compare_row = 0;
	  var sel = document.querySelectorAll('.wsaio_' + current_product.id + '.wsaio_' + selected_variant_id);
	  if(selected_variant_index == -1) return false;
	  WSAIO.productDiscount({
		template:'product',
		item_price_selector: document.querySelector('.demo'),
		product_id: current_product.id,
		product_handle: current_product.handle,
		variant_id: current_product.variants[selected_variant_index].id,
		variant_sku: current_product.variants[selected_variant_index].sku,
		variant_price: current_product.variants[selected_variant_index].price,
		variant_compare_at_price: current_product.variants[selected_variant_index].compare_at_price
	  },function(ee){
		if(ee.volume_discount == undefined) return false;
		var volume_applied = ee.volume_discount.quantity_breaks.length;
		var volume_table_Values = [];
  
		if(volume_applied > 0){
		  volume_table_Values = ee.volume_discount.quantity_breaks;
		  volume_table_Values = volume_table_Values.filter(function(elem,i){
			return elem.value != '' || elem.value != 0;
	      });  
		  if(volume_table_Values.length > 0 && Total_quantity >= Number(volume_table_Values[0].qty)){
			for (let e = 0; e < volume_table_Values.length; e++) {
				const currentValue = volume_table_Values[e];
				if (Total_quantity >= Number(currentValue.qty) && Number(currentValue.value) !== 0 && currentValue.value !== '') {
					compare_row = e;
				}
			}
            document.querySelectorAll('.wholesale-grid-table').forEach(element => {
				element.classList.remove('active_row');
			});
           const selector = '.wsaio_vdRow_' + 
							current_product.variants[selected_variant_index].id + 
							'_' + 
							volume_table_Values[compare_row].qty;
			if(document.querySelector(selector) != null){
			document.querySelector(selector).classList.add('active_row');
			}
			
			var compare = 0;
			var Volume_applied_price = 0;
			var actual_regularPrice = 0;
			var excluded_actual_regularPrice = 0;
              var check_compare = 0, check_applied_discount = 0, acutal_variant_compare = 0;
              if(WSAIO.exclude_VAT != 0 && WSAIO.check_eligible_customer()){
                var exclude_value = (WSAIO.exclude_VAT/100) + 1;
                Volume_applied_price = WS.formatMoney(((Number(current_product.variants[selected_variant_index].price/100)-Number(WSAIO.get_discount(current_product.variants[selected_variant_index].price/100,volume_table_Values[compare_row].type,volume_table_Values[compare_row].value)))/exclude_value));
                 reg_price = ((Number(current_product.variants[selected_variant_index].price/100)-Number(WSAIO.get_discount(current_product.variants[selected_variant_index].price/100,volume_table_Values[compare_row].type,volume_table_Values[compare_row].value)))/exclude_value);
                compare = WS.formatMoney(((current_product.variants[selected_variant_index].price)/exclude_value)/100);
                acutal_variant_compare = WS.formatMoney(((current_product.variants[selected_variant_index].compare_at_price)/exclude_value)/100);
                comp_price = ((current_product.variants[selected_variant_index].price)/exclude_value)/100;
                check_compare = ((current_product.variants[selected_variant_index].price)/exclude_value)/100;
                check_applied_discount = (Number(current_product.variants[selected_variant_index].price/100)-Number(WSAIO.get_discount(current_product.variants[selected_variant_index].price/100,volume_table_Values[compare_row].type,volume_table_Values[compare_row].value)))/exclude_value;
                actual_regularPrice = WS.formatMoney(((Number(current_product.variants[selected_variant_index].price/100)-Number(WSAIO.get_discount(current_product.variants[selected_variant_index].price/100,volume_table_Values[compare_row].type,volume_table_Values[compare_row].value)))))
                excluded_actual_regularPrice = WS.formatMoney(((Number(current_product.variants[selected_variant_index].price/100)-Number(WSAIO.get_discount(current_product.variants[selected_variant_index].price/100,volume_table_Values[compare_row].type,volume_table_Values[compare_row].value)))/exclude_value))
              }else{
				var price = Number(current_product.variants[selected_variant_index].price/100);
				// if customer exampt true, then subtract international tax from original price
				
				if(WSAIO.customer.id != null && WSAIO.customer.tax_exempt && WSAIO.selected_variant_taxable){
					if(typeof WSAIO.tax_settings !== "undefined" && WSAIO.tax_settings && typeof WSAIO.tax_settings.taxes_included !== "undefined" && WSAIO.tax_settings.taxes_included === true && typeof WSAIO.tax_settings.auto_configure_tax_inclusivity != 'undefined' && WSAIO.tax_settings.auto_configure_tax_inclusivity && typeof WSAIO.auto_vat_enable != 'undefined' &&  WSAIO.auto_vat_enable){
							price = price/(1+WSAIO.tax_settings.presentment.tax);
					}
				}
				
				Volume_applied_price = WS.formatMoney((price-Number(WSAIO.get_discount(current_product.variants[selected_variant_index].price/100,volume_table_Values[compare_row].type,volume_table_Values[compare_row].value))));
                reg_price = ((price-Number(WSAIO.get_discount(current_product.variants[selected_variant_index].price/100,volume_table_Values[compare_row].type,volume_table_Values[compare_row].value))));
                compare = WS.formatMoney((current_product.variants[selected_variant_index].price)/100);
                acutal_variant_compare = ((current_product.variants[selected_variant_index].compare_at_price)/100);
                comp_price = (current_product.variants[selected_variant_index].price)/100;
                check_compare = (current_product.variants[selected_variant_index].price)/100;
                check_applied_discount = (Number(current_product.variants[selected_variant_index].price/100)-Number(WSAIO.get_discount(current_product.variants[selected_variant_index].price/100,volume_table_Values[compare_row].type,volume_table_Values[compare_row].value)));
                if(Volume_applied_price == compare && current_product.variants[selected_variant_index].compare_at_price != undefined){
                  compare = WS.formatMoney(((current_product.variants[selected_variant_index].compare_at_price)/100).toFixed(2));
                  check_compare = (current_product.variants[selected_variant_index].compare_at_price)/100;
                }
              }
		
              var html = WSAIO.product_price_html;
              if (!WS.general_settings.compare_at_price || Volume_applied_price == compare || check_applied_discount > check_compare || ((Number(acutal_variant_compare) != 0 && acutal_variant_compare < reg_price) || (comp_price < reg_price))) {
                compare = "";
                html = WSAIO.remove_comparePrice(html);
              }
			 
             if(WSAIO.general_settings.show_compare_at_price && WS.general_settings.compare_at_price && acutal_variant_compare != 0 && ((Number(acutal_variant_compare) != 0 && acutal_variant_compare > reg_price) || (comp_price > reg_price))){
                  compare = WS.formatMoney(acutal_variant_compare);
                }
			
			if(typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO.formatMoney('0').indexOf(Shopify.currency.active) == -1){
                Volume_applied_price = Volume_applied_price+' '+Shopify.currency.active;
                actual_regularPrice = actual_regularPrice+' '+Shopify.currency.active;
                excluded_actual_regularPrice = excluded_actual_regularPrice+' '+Shopify.currency.active;
                    if(compare != ""){
                        compare = compare+' '+Shopify.currency.active;
                    }
              }			
			
			html = html.replace(new RegExp("%regular_price%", "gi"), Volume_applied_price)
			.replace(new RegExp("%compare_at_price%", "gi"), compare);
            if(WSAIO.exclude_VAT != 0 && WSAIO.check_eligible_customer() && typeof WSAIO.excludePrice_design != 'undefined' && WSAIO.excludePrice_design == 'without-crossout'){
                if (!WS.general_settings.compare_at_price) { actual_regularPrice = ""  }
                html = '<div class="wsaio_vat_price"> <div class="money">'+actual_regularPrice+'</div> <div class="money">'+excluded_actual_regularPrice+'<span class="wsaio_excl" style="font-size:12px;padding-left: 4px;">(Excl. Tax)</span> </div> </div>'
                 html =  remove_emptyElement(html);
				if (sel.length > 0) {
					sel.forEach(function(el) {
						el.innerHTML = html;
					});
				}
             }else{
				 html =  remove_emptyElement(html);
			   	if (sel.length > 0) {
					sel.forEach(function(el) {
						el.innerHTML = html;
					});
				}
             }
		  }else{
  
			if(ee.regular_discount.ws_discount != 0){
				var compare = 0;
				var Volume_applied_price = 0;
                var actual_regularPrice = 0;
                var excluded_actual_regularPrice = 0;
				var html = WSAIO.product_price_html;
				var check_compare = 0, check_applied_discount = 0, acutal_variant_compare = 0;
				if(WSAIO.exclude_VAT != 0 && WSAIO.check_eligible_customer()){
				  var exclude_value = (WSAIO.exclude_VAT/100) + 1;
				  Volume_applied_price = WS.formatMoney(((ee.regular_discount.product_regular_discount.regular_price)/exclude_value));
                  reg_price = ((ee.regular_discount.product_regular_discount.regular_price)/exclude_value);
				  compare = WS.formatMoney((((current_product.variants[selected_variant_index].price)/100)/exclude_value));
                  comp_price = (((current_product.variants[selected_variant_index].price)/100)/exclude_value);
				  check_compare = (((current_product.variants[selected_variant_index].price)/100)/exclude_value);
				  check_applied_discount = ((ee.regular_discount.product_regular_discount.regular_price)/exclude_value);
                  actual_regularPrice = WS.formatMoney(((ee.regular_discount.product_regular_discount.regular_price)))
                  excluded_actual_regularPrice = WS.formatMoney(((ee.regular_discount.product_regular_discount.regular_price)/exclude_value))
                  acutal_variant_compare = (((current_product.variants[selected_variant_index].compare_at_price)/100)/exclude_value);
                }else{
				  Volume_applied_price = WS.formatMoney((ee.regular_discount.product_regular_discount.regular_price));
                  reg_price = ((ee.regular_discount.product_regular_discount.regular_price));
				  compare = WS.formatMoney(((current_product.variants[selected_variant_index].price)/100));
                  comp_price = ((current_product.variants[selected_variant_index].price)/100);
				  check_compare = (current_product.variants[selected_variant_index].price)/100;
				  check_applied_discount = (ee.regular_discount.product_regular_discount.regular_price);
                  acutal_variant_compare = ((current_product.variants[selected_variant_index].compare_at_price)/100);
				}
				
				if (!WS.general_settings.compare_at_price || Volume_applied_price == compare || check_compare < check_applied_discount || (((Number(acutal_variant_compare) != 0 && acutal_variant_compare < reg_price)) || (comp_price < reg_price))) {
				  compare = "";
                  html = WSAIO.remove_comparePrice(html);
				}
				 
                if(WSAIO.general_settings.show_compare_at_price && WS.general_settings.compare_at_price && acutal_variant_compare != 0 && (((Number(acutal_variant_compare) != 0 && acutal_variant_compare > reg_price)) || (comp_price > reg_price))){
                  compare = WS.formatMoney(acutal_variant_compare);
                }
              
				if(typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO.formatMoney('0').indexOf(Shopify.currency.active) == -1){
					Volume_applied_price = Volume_applied_price+' '+Shopify.currency.active;
                actual_regularPrice = actual_regularPrice+' '+Shopify.currency.active;
                excluded_actual_regularPrice = excluded_actual_regularPrice+' '+Shopify.currency.active;
                    if(compare != ""){
							compare = compare+' '+Shopify.currency.active;
						}
				  }
			  html = html.replace(new RegExp("%regular_price%", "gi"), Volume_applied_price)
			  .replace(new RegExp("%compare_at_price%", "gi"), compare);
			    if(WSAIO.exclude_VAT != 0 && WSAIO.check_eligible_customer() && typeof WSAIO.excludePrice_design != 'undefined' && WSAIO.excludePrice_design == 'without-crossout'){
                    if (!WS.general_settings.compare_at_price) { actual_regularPrice = ""  }
                    html = '<div class="wsaio_vat_price"> <div class="money">'+actual_regularPrice+'</div> <div class="money">'+excluded_actual_regularPrice+'<span class="wsaio_excl" style="font-size:12px;padding-left: 4px;">(Excl. Tax)</span> </div> </div>'
                      	if (sel.length > 0) {
							 html =  remove_emptyElement(html);
							sel.forEach(function(el) {
								el.innerHTML = html;
							});
						}
                }else{
                     if (sel.length > 0) {
						   html =  remove_emptyElement(html);
							sel.forEach(function(el) {
								el.innerHTML = html;
							});
						}
                }
			}else{
                var compare = 0;
                var Volume_applied_price = 0;
                var html = WSAIO.product_price_original_html;
				Volume_applied_price = WS.formatMoney(((ee.regular_discount.variant.price)/100).toFixed(2));
                reg_price = (((ee.regular_discount.variant.price)/100).toFixed(2));
				compare = WS.formatMoney(((current_product.variants[selected_variant_index].compare_at_price)/100).toFixed(2));
                comp_price = (((current_product.variants[selected_variant_index].compare_at_price)/100).toFixed(2));
				if (!WS.general_settings.compare_at_price || current_product.variants[selected_variant_index].compare_at_price == null || current_product.variants[selected_variant_index].compare_at_price == 0 || Volume_applied_price == compare) {
					compare = "";
                    html = WSAIO.remove_comparePrice(html);
					}
				if(typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO.formatMoney('0').indexOf(Shopify.currency.active) == -1){
					Volume_applied_price = Volume_applied_price+' '+Shopify.currency.active;
						if(compare != ""){
							compare = compare+' '+Shopify.currency.active;
						}
				}    
				if(html != undefined){
				html =  remove_emptyElement(html);
			  html = html.replace(new RegExp("%regular_price%", "gi"), Volume_applied_price)
			  .replace(new RegExp("%compare_at_price%", "gi"), compare);
										if (sel.length > 0) {
							sel.forEach(function(el) {
								el.innerHTML = html;
							});
						}
				}
			
			}
		  }
		   if (sel.length > 0 && compare == '') {
							sel.forEach(function(el) {
								el.classList.add("wsnocompare");
							});
				  }else if(sel.length > 0){
	                        sel.forEach(function(el) {
								el.classList.remove("wsnocompare");
							});
				  }
		}
	  });
	  }
				if(WSAIO.general_settings.discount_method == 'coupon_code' && (typeof WSAIO.enable_lineCouponCode != 'undefined' && WSAIO.enable_lineCouponCode)){
					if(window.cart_data == undefined) window.cart_data = WSAIO.cart_object;
					var already_exist_item = cart_data.items.find(function(e){
						return e.id == selected_variant_id
					});
					const productIdentifier = '.wsaio_' + current_product.id;
					const productElement = document.querySelector(productIdentifier);
					const parent_selector = productElement ? productElement.closest(WSAIO.product_parent_grid_selector) : null;
					const quick_parent_selector = productElement ? productElement.closest(WSAIO.quickView_parent_Selector) : null;

					if (already_exist_item === undefined) {
						if (typeof current_product !== 'undefined' && current_product !== null && quick_parent_selector !== null) {
							const quickPriceField = quick_parent_selector.querySelector('.item_wsaio_price_field');

							if (quickPriceField === null) {
								const targetElement = quick_parent_selector.querySelector('[name="id"]');
								
								if (targetElement) {
									const newElementHTML = '<input type="hidden" class="item_wsaio_price_field" name="properties[_Wholesale_All_In_One__Discount_ID]">';
									targetElement.insertAdjacentHTML('beforebegin', newElementHTML);
								}
							}
						}

						if (typeof current_product !== 'undefined' && current_product !== null && parent_selector !== null) {
							const parentPriceField = parent_selector.querySelector('.item_wsaio_price_field');

							if (parentPriceField === null) {
								const targetForm = parent_selector.querySelector('form[action^="/cart/add"]');

								if (targetForm) {
									const newElementHTML = '<input type="hidden" class="item_wsaio_price_field" name="properties[_Wholesale_All_In_One__Discount_ID]">';
									targetForm.insertAdjacentHTML('beforeend', newElementHTML);
								}
							}
						}

						if (reg_price !== null && reg_price !== 0 && comp_price !== null && comp_price !== 0) {
							const discounted_percentage = 100 - ((Number(reg_price) / Number(comp_price)) * 100);
							
							const finalIdentifier = '.wsaio_' + current_product.id + '.wsaio_' + selected_variant_id;
							const finalElement = document.querySelector(finalIdentifier);
							
							if (finalElement) {
								const finalParent = finalElement.closest(WSAIO.product_parent_grid_selector);

								if (finalParent) {
									const finalPriceField = finalParent.querySelector('.item_wsaio_price_field');
									
									if (finalPriceField) {
										finalPriceField.value = WSAIO.encode(discounted_percentage);
									}
								}
							}
						}
					}
				}
            return_data = reg_price+'!!'+comp_price;
            return return_data;
	}
  
  
	WSAIO.variantOriginalPrice = function () {
	  if (WSAIO.debugger) debugger;
	  var regular_price = WS.formatMoney(WS.selected_variant.price/100);
	  var compare_at_price = WS.formatMoney(WS.selected_variant.compare_at_price/100);
	  var html = WS.hcsr_price_original_html;
	  if (WS.template === 'product') {
		html = WS.product_price_original_html;
	  }
	  if (Number(WS.selected_variant.price) > Number(WS.selected_variant.compare_at_price)) {
		compare_at_price = "";
	  }
	  if (WS.selected_variant.compare_at_price == null) {
		compare_at_price = "";
	  }
	  if (Number(WS.selected_variant.compare_at_price) < 1) {
		compare_at_price = "";
	  }
	  if (!WS.general_settings.compare_at_price) {
		compare_at_price = "";
        html = WSAIO.remove_comparePrice(html);
	  }
	  if(Number(WS.selected_variant.price) == Number(WS.selected_variant.compare_at_price)){
		compare_at_price = "";
	  }

       let price_selector = [];

        if (typeof WS.product_price_selector === 'string') {
            price_selector = document.querySelectorAll(WS.product_price_selector);

        } else if (WS.product_price_selector instanceof Element) {
            price_selector = [WS.product_price_selector];

        } else if (WS.product_price_selector?.length) {
            price_selector = Array.from(WS.product_price_selector);
        }


	  if (compare_at_price == "") {
		try {
		if (price_selector) {
				price_selector.forEach(el => {
                    if (el) {
                        el.classList.add("empty");
                    }
		});
			}
          html = WSAIO.remove_comparePrice(html);
		} catch (e) {}
	  } else {
		try {
		 if (price_selector) {
				price_selector.forEach(el => {
                    if (el) {
                        el.classList.remove("empty");
                    }
		});
			}
		} catch (e) {}
	  }
  
	  try {
		compare_at_price = compare_at_price.replace("$", "$@");
		regular_price = regular_price.replace("$", "$@");
	  } catch (e) {
		log(e)
	  }

	  if(typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO.formatMoney('0').indexOf(Shopify.currency.active) == -1){
        regular_price = regular_price+' '+Shopify.currency.active;
        if(compare_at_price != ""){
            compare_at_price = compare_at_price+' '+Shopify.currency.active;
        }
    }
	  if(html == undefined) return false;
	  html = html.replace(new RegExp("%regular_price%", "gi"), regular_price).replace(new RegExp("%compare_at_price%", "gi"), compare_at_price);
	  try {
		html = html.replace(/@/g, '');
	  } catch (e) {
		log(e);
	  }
	  if (price_selector && WS.selected_product) {
        price_selector.forEach(el => {
                        if (!el) return;
                        el.innerHTML = html; 
		});
	  } else {
		isError("Selected variant price was not defined. Reference: WSAIO.selected_variant.price");
	  }
	};
  
	WSAIO.get_discount = function (price, type, value) {
	  if (WSAIO.debugger) debugger;
	  if(type == 'fixed_price' && (value == '' || value == 'NaN')) value = price;
      if(type != "percentage") value = WSAIO.calculate_tax_price_adjustments(value);     
	  if (type !== "percentage" && value && WS.Currency && (WS.Currency.rates && WS.Currency.storeCurrency)) {
		if (WS.ccr && !isNaN(WS.ccr)) {
		  value = Number(Number(Number(value) * Number(WS.ccr)));
		} else {
		  value = WS.Currency.convert(value, WS.Currency.storeCurrency, WS.Currency.selectedCurrency);
		}
	  }
	  var d = 0;
	  switch (type) {
		case "percentage":
			d = ((Number(price) * Number(value)) / 100);
		  break;
		case "percentage_increase":
			d = - (((Number(price) * Number(value)) / 100)/Shopify.currency.rate);
		  break;
		case "price_increase":
			d = -(Number(value));
		  break;
		case "price_discount":
		  if (Number(price) < Number(value)) {
			d = Number(price);
		  } else {
			d = Number(value);
		  }
		  break;
		case "fixed_price":
		  if (Number(price) <= Number(value)) {
			d = Number(price) - Number(value);
		  } else {
			d = Number(price) - Number(value);
		  }
		  break;
		default:
		  log("Invalid discount type. Valid values are percentage, price_discount and fixed_price.");
		  break;
	  }
	  return Number(d);
	};
  
	window.HandleQty = function(){
		var selector = WSAIO.current_product_qty_input_selector;
		var btnSelector = WSAIO.current_product_qty_btn_selector;
		var changeListener = function(e){
		  HandleQty.change(e.target);
		};
		var descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value");
		var originalSet = descriptor.set;
	
		descriptor.set = function(value){
			originalSet.apply(this, arguments);
		  HandleQty.change(this);
		};
		var btnListener = function(e){
			const input = e.target.parentElement.querySelector(selector);
			if (!input) return;
			setTimeout(() => {
				HandleQty.change(input);
			}, 0);
		};

		var init_module = function(){
		  var elements = document.querySelectorAll(selector);
			elements.forEach(el => {
			el.removeEventListener("change", changeListener);
			el.addEventListener("change", changeListener);
			Object.defineProperty(el, "value", descriptor);
			});
			var btns = document.querySelectorAll(btnSelector);
			btns.forEach(btn => {
				btn.removeEventListener("click", btnListener);
				btn.addEventListener("click", btnListener);
			});
		};
		return {
			change: function(el){
				if(el && el.tagName == 'SELECT'){
                    WSAIO.Volume_disocunted_price(el.options[el.selectedIndex].getAttribute('value'))
                }else{
				WSAIO.Volume_disocunted_price(el.value);
                }
		  },
			init: init_module
		};

	}();

	  HandleQty.init();
  
	
	
	
	
	WSAIO.check_eligible_customer = function(){
	  var check_tag = false;
	  var tagss = WSAIO.exclude_VAT_for.toLowerCase().split(',');
	  if(WSAIO.exclude_VAT_for != ''){
		tagss.forEach(function(tagValue) {
			WSAIO.customer.tags.forEach(function(customerTag) {
				const customer_tag = customerTag.toLowerCase();
				if (customer_tag === tagValue) {
					check_tag = true;
				}
			});
		});
	  }else{
		check_tag = true;
	  }
	  return check_tag;
	}
  
	WSAIO.get_custom_price = function (rule, vd) {
		if (WS.selected_variant.price) {
			var price = Number(WS.mF(WS.selected_variant.price));
			var discount = WS.get_discount(price, vd.type, vd.value);
			if(WSAIO.customer.id != null && WSAIO.customer.tax_exempt && WSAIO.selected_variant_taxable){
				if(typeof WSAIO.tax_settings !== "undefined" && WSAIO.tax_settings && typeof WSAIO.tax_settings.taxes_included !== "undefined" && WSAIO.tax_settings.taxes_included === true && typeof WSAIO.tax_settings.auto_configure_tax_inclusivity != 'undefined' && WSAIO.tax_settings.auto_configure_tax_inclusivity && typeof WSAIO.auto_vat_enable != 'undefined' &&  WSAIO.auto_vat_enable){
						price = Number(WS.mF(WS.selected_variant.price))/(1+WSAIO.tax_settings.presentment.tax);
				}
			}
			var wholesale_price = Number(price) - Number(discount);
			try {
				wholesale_price = Number(wholesale_price).toFixed(2);
			} catch (e) {
				isError(e)
			}
			if(WSAIO.exclude_VAT != 0 && WSAIO.check_eligible_customer()){
				var exclude_value = (WSAIO.exclude_VAT/100) + 1;
				wholesale_price = (wholesale_price/exclude_value);
			}
			if(typeof QOF_page !== 'undefined' && QOF_page && (typeof WSAIO.QOF_version == 'undefined' || WSAIO.QOF_version == 1)){
				return (wholesale_price*100);
			}else{
				return (wholesale_price);
			}
			
		} 
	  };
  
	WSAIO.get_price = function (rule, vd) {
	  if (WSAIO.debugger) debugger;
	  if (WS.selected_variant.price) {
		var price = Number(WS.mF(WS.selected_variant.price));
		var discount = WS.get_discount(price, vd.type, vd.value);
		// if customer exampt true, then subtract international tax from original price
		if(WSAIO.customer.id != null && WSAIO.customer.tax_exempt && WSAIO.selected_variant_taxable){
			if(typeof WSAIO.tax_settings !== "undefined" && WSAIO.tax_settings && typeof WSAIO.tax_settings.taxes_included !== "undefined" && WSAIO.tax_settings.taxes_included === true && typeof WSAIO.tax_settings.auto_configure_tax_inclusivity != 'undefined' && WSAIO.tax_settings.auto_configure_tax_inclusivity && typeof WSAIO.auto_vat_enable != 'undefined' &&  WSAIO.auto_vat_enable){
					price = Number(WS.mF(WS.selected_variant.price))/(1+WSAIO.tax_settings.presentment.tax);
			}
		}
		var wholesale_price = Number(price) - Number(discount);
		try {
		  wholesale_price = Number(wholesale_price).toFixed(2);
		} catch (e) {
		  isError(e)
		}
		if(WSAIO.exclude_VAT != 0 && WSAIO.check_eligible_customer()){
		  var exclude_value = (WSAIO.exclude_VAT/100) + 1;
		  wholesale_price = (wholesale_price/exclude_value);
		}
		if(typeof QOF_page !== 'undefined' && QOF_page && (typeof WSAIO.QOF_version == 'undefined' || WSAIO.QOF_version == 1)){
		  return WS.formatMoney(wholesale_price*100, WS.shopInfo.money_format);
	  }else{
		  return WS.formatMoney(wholesale_price, WS.shopInfo.money_format);
	  }
	  
	} else {
		isError("Selected variant price was not defined. Reference: WSAIO.selected_variant.price");
	  }
	};
  
	WSAIO.get_price_in_percent = function (rule, vd) {
	  if (WSAIO.debugger) debugger;
	  if (WS.selected_variant.price) {
		var price = Number(WS.mF(WS.selected_variant.price));
		var discount = WS.get_discount(price, vd.type, vd.value);
		var perc = Math.round(100 - ((Number(price) - Number(discount)) / Number(price)) * 100);
		return perc.toString() + '%';
	  } else {
		isError("Selected variant price was not defined. Reference: WSAIO.selected_variant.price")
	  }
	};
  
	WSAIO.saved_amount = function (original_price, discount_price) {
	  if (WSAIO.debugger) debugger;
	  if (original_price === null || discount_price === null || isNaN(original_price) || isNaN(discount_price)) {
		return {
		  percentage: "0%",
		  price: "0"
		};
	  };
	  var price = original_price - discount_price,
		  percentage = 100 - (discount_price / original_price) * 100;
	  return {
		percentage: Math.round(percentage) + "%",
		price: Number(price).toFixed(2)
	  };
	};
  
	WSAIO.volumeDiscountPriority = function () {
	  if (WS.productRd && WS.productRd.length && WS.productVd && WS.productVd.length) {
		try {
		  if (WS.productRd.findIndex(function (x) {
			return x.customer_group === 'has_tag'
		  }) > -1 && WS.productVd.findIndex(function (x) {
			return x.customer_group == 'has_tag'
		  }) === -1) {
			WS.productVd = [];
		  }
		} catch (e) {
		  isError(e);
		}
		try {
		  if (WS.productRd.length > 0 && WS.productRd.findIndex(function (x) {
			return x.customer_group === 'all'
		  }) === -1 && WS.productVd.findIndex(function (x) {
			return x.customer_group == 'all'
		  }) > -1) {
			WS.productVd = [];
		  }
		} catch (e) {
		  isError(e);
		}
	  }
	};
  
  WSAIO.append_single_qty_price = function (rule, params) {
    var check_qty = parseInt(rule.volume_discount[0].qty,10);
    if ('undefined' !== typeof rule.volume_discount && rule.volume_discount.length > 0 && WSAIO.applied_rgDiscount_price == 0 && check_qty == 1) {
      if(typeof QOF_page !== 'undefined' && QOF_page && (typeof WSAIO.QOF_version == 'undefined' || WSAIO.QOF_version == 1.1)){
        html = `<div class="wsaio_sale_price pri" style=" line-height: 1.2;color: #403b37 !important; "> <span class="money wsaio-sale" style=" font-size: 12px; "> ${WSAIO.formatMoney(WS.get_custom_price(rule, rule.volume_discount[0]))} </span> </div>`;
      }else{
        var html = WSAIO.hcsr_price_html;
        var regular_price = WS.get_custom_price(rule, rule.volume_discount[0]);
        var compare_at_price = (params.variant_price)/100;
       
        if (WS.general_settings.show_compare_at_price) {
          compare_at_price = (params.variant_compare_at_price)/100;
        }

        if(parseFloat(regular_price) == parseFloat(compare_at_price) || parseFloat(regular_price) > parseFloat(compare_at_price)) return;
        html = html.replace(new RegExp("%regular_price%", "gi"), WSAIO.formatMoney(regular_price)).replace(new RegExp("%compare_at_price%", "gi"), WSAIO.formatMoney(compare_at_price));
		  
		  }
         
       let price_selector = [];
        if (typeof params.item_price_selector === 'string') {
                price_selector = document.querySelectorAll(params.item_price_selector);
            } else if (params.item_price_selector instanceof Element) {
                price_selector = [params.item_price_selector];
            } else if (params.item_price_selector?.length) {
                price_selector = Array.from(params.item_price_selector);
        }
		price_selector.forEach(element => {
			element.innerHTML = html;
		});
     }
  }
  
	// Product page Tables grid
	WSAIO.detailed_grid_table = function (rule, params) {
	  if (WSAIO.debugger) debugger;
	  if ('undefined' !== typeof rule.volume_discount && rule.volume_discount.length > 0) {
				var table_rows = "",table_description = "";
				if(typeof params.volume_table_heading != 'undefined'){
				table_description = params.volume_table_heading;
				}
		
				WSAIO.append_single_qty_price(rule, params);
				if(typeof WSAIO.show_volumeRange != 'undefined' && WSAIO.show_volumeRange){
					var lowest_price = 0,highest_price = 0;
					lowest_price = WS.get_custom_price(rule, rule.volume_discount[rule.volume_discount.length-1]);
					if(WSAIO.applied_rgDiscount_price != 0){
							if(WSAIO.applied_rgDiscount_price < WS.get_custom_price(rule, rule.volume_discount[0])){
								highest_price = WS.get_custom_price(rule, rule.volume_discount[0]);
							}else{
								highest_price = WSAIO.applied_rgDiscount_price;
							}
					}else{
						if(rule.volume_discount[0].qty == 1){
							highest_price = WS.get_custom_price(rule, rule.volume_discount[0]);
						}else{
							highest_price = (params.variant_price)/100;
						}
					}
					var html = WSAIO.hcsr_price_html;
					html = html.replace(new RegExp("%regular_price%", "gi"), WSAIO.formatMoney(lowest_price)+' - '+WSAIO.formatMoney(highest_price)).replace(new RegExp("%compare_at_price%", "gi"), '');
					document.querySelectorAll(params.item_price_selector).forEach(element => {
						element.innerHTML = 'As low as' + html;
					});
				}

				if(parseInt(rule.volume_discount[0].qty,10) > 0 && parseInt(rule.volume_discount[0].qty,10) != 1 && WSAIO.rd_or_regularPrice != 0){
						var rd_pric = WSAIO.rd_or_regularPrice;
								table_rows += '<tr class="wholesale-grid-table custom-table wsaio_vdRow_'+params.variant_id+'_'+1+' active_row">' +
								'<td>1</td>' +
						'<td>' + WSAIO.formatMoney(rd_pric) + WS.Lang.each_item + '</td>' +
								'</tr>';
					}
					for (var ff = 0; ff < rule.volume_discount.length; ff++) {
					var vd = rule.volume_discount[ff];
					if (Number(vd.qty) > 0 && vd.value != '' && WS.get_price(rule, vd) != undefined ) {
						table_rows += '<tr class="wholesale-grid-table custom-table wsaio_vdRow_'+params.variant_id+'_'+vd.qty+'">' +
						'<td>' + vd.qty + '</td>' +
						'<td>' + WS.get_price(rule, vd) + WS.Lang.each_item + '</td>' +
						'</tr>';
					}
					}
					if(table_description != ''){
						table_rows += '<tr class="wholesale-grid-table custom-table">' +
						'<td colspan="4" style="font-size: 12px; font-style: italic;background-color: #f8f8f8; padding: 3px 10px;">'+'Note: '
						+ table_description  
						+'</td>' +
						'</tr>';
					}
					var table = '<table id="wsaio-volume-discount--table" class="wholesale-table">' +
						'<thead><tr>' +
						'<th>' + WS.Lang.buy + ' ' + WS.Lang.quantity + '</th>' +
						'<th>' + WS.Lang.price + '</th>' +
						'</tr></thead>' +
						'<tbody>' + table_rows + '</tbody>' +
						'</table>';
				
					if (table_rows !== "") {
				
						if(document.querySelector('#Quick-order-form') == null){

							var itemPriceElement;

							if (typeof params.item_price_selector === 'string') {
								itemPriceElement = document.querySelector(params.item_price_selector);
								} else if (params.item_price_selector instanceof Element) {
								itemPriceElement = params.item_price_selector;
								} else if (params.item_price_selector?.length) {
								itemPriceElement = params.item_price_selector[0]; // first element only
							}
							
							if (params.template === 'collection' &&  WSAIO.template !== 'collection' && itemPriceElement?.closest(WSAIO.collection_items_each_selector)?.querySelector(WSAIO.product_inner_qb_table_selector) === null) {
								return false;
							}
							
							const baseSelector = `.wsaio_${params.product_id}.wsaio_${params.variant_id}`;
							const baseElements = document.querySelectorAll(baseSelector);
                            const parentGrids = new Set();
                            baseElements.forEach(baseEl => {
                            const parents = baseEl.closest ? baseEl.closest(WSAIO.product_parent_grid_selector)  : null;
                            if (parents) parentGrids.add(parents);
							});

                            if (parentGrids.size && !document.querySelector('quick-order-list')) {
                                parentGrids.forEach(parentGrid => {
                                    parentGrid.querySelectorAll('.wholesale-table').forEach(el => el.remove());
                                    const innerTargets =
                                    parentGrid.querySelectorAll(WSAIO.product_inner_qb_table_selector);
                                    innerTargets.forEach(target => {
                                    target.insertAdjacentHTML('afterend', table);
                                    });
                                });
								}

							const moqElementSelector = ".moq_v_disc.wsaio-MOQqt-" + params.variant_id;
							const moqElement = document.querySelector(moqElementSelector);
							if(!document.querySelector('quick-order-list')){
							document.querySelectorAll(moqElementSelector + ' + .wsaio_volume_div').forEach(el => el.remove());
							}
							
							if (moqElement && moqElement.nextElementSibling?.matches('.wsaio_volume_div') === false) {
								if (productParent) {
									productParent.querySelectorAll('.wholesale-table').forEach(el => el.remove());
								}
								const volumeDivHTML = ` <span style="z-index: 9999; font-size: 12px; cursor: pointer; display: block; margin: auto;text-align: center;" class="wsaio_volume_div"> Volume Discount <svg width="15" height="15" viewbox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="position: absolute;"> <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v2h-2zm0 4h2v6h-2z" fill="currentColor"></path> </svg> <span style="bottom: 26px; left: 0px;">${table}</span> </span> `;
								moqElement.insertAdjacentHTML('afterend', volumeDivHTML);
							}
						} else {
					
							WSAIO.displayTable(table, '.wsaio-qt-' + params.product_id + ':same', true); 
							WSAIO.displayTable(table, '.wsaio-vqt-' + params.variant_id + ':same', true); 
						}

						if (document.querySelector('quick-order-list')) {
							
							const qolBaseSelector = '.wsaio_' + params.product_id;
							const qolProductParent = document.querySelector(qolBaseSelector)?.closest(WSAIO.product_parent_grid_selector);

							if (qolProductParent?.querySelector('quick-add-bulk')) {
								const qolElement = document.querySelector(qolBaseSelector);
								
								qolElement?.nextElementSibling?.matches('.wholesale-table') && qolElement.nextElementSibling.remove();
								
								if (qolElement && qolElement.nextElementSibling?.matches('.wsaio_volume_div') === false) {
									const qolVolumeDivHTML = ` <span style="z-index: 9999; font-size: 12px; cursor: pointer; display: block; margin: auto;" class="wsaio_volume_div"> Volume Discount <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="position: absolute;"> <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v2h-2zm0 4h2v6h-2z" fill="currentColor"></path> </svg> <span style="bottom: 26px; left: 0px;">${table}</span> </span> `;
									qolElement.insertAdjacentHTML('afterend', qolVolumeDivHTML);
								}
							}
							WSAIO.displayTable(table, '.wsaio_volume_div .wsaio-vqt-' + params.variant_id + ':same', true);
							
							const variantQtElement = document.querySelector('.wsaio-vqt-' + params.variant_id);
							const volumeDivParent = variantQtElement?.closest('.wsaio_volume_div');
							if (volumeDivParent) {
								volumeDivParent.style.display = 'block';
							}
						}
					} else {
						if (document.querySelector('#Quick-order-form') === null && document.querySelector('.quick-add-modal__content--bulk') === null) {
							
							const baseSelector = '.wsaio_' + params.product_id + '.wsaio_' + params.variant_id;
							const productParent = document.querySelector(baseSelector)?.closest(WSAIO.product_parent_grid_selector);
							const innerTableTarget = productParent?.querySelector(WSAIO.product_inner_qb_table_selector);
							if (innerTableTarget) {
								innerTableTarget.nextElementSibling?.matches('.wholesale-table') && innerTableTarget.nextElementSibling.remove();
							}
						}
				}
	        } else {
			  const baseSelector = '.wsaio_' + params.product_id + '.wsaio_' + params.variant_id;
			  const productParent = document.querySelector(baseSelector)?.closest(WSAIO.product_parent_grid_selector);

				if (productParent) {
					const innerTableTarget = productParent.querySelector(WSAIO.product_inner_qb_table_selector);
					if (innerTableTarget) {
						let currentSibling = innerTableTarget.nextElementSibling;
						
						while (currentSibling) {
							if (currentSibling.matches('.wholesale-table')) {
								currentSibling.remove();
							}
							currentSibling = currentSibling.nextElementSibling;
						}
					}
				}
		     isError("Volume discount was not configured.");
	       }
	};
  
	WSAIO.basic_grid_table = function (rule, params) {
	  if (WSAIO.debugger) debugger;
	  if ('undefined' !== typeof rule.volume_discount && rule.volume_discount.length > 0) {
		var table_rows = "",table_description = "";
		if(typeof params.volume_table_heading != 'undefined'){
			table_description = params.volume_table_heading;
		}

     WSAIO.append_single_qty_price(rule, params);

        if(parseInt(rule.volume_discount[0].qty,10) > 0 && parseInt(rule.volume_discount[0].qty,10) != 1 && WSAIO.rd_or_regularPrice != 0){
            table_rows += '<tr class="wholesale-grid-table custom-table wsaio_vdRow_'+params.variant_id+'_'+1+' active_row">' +
            '<td>1</td>' +
            '<td>' + WSAIO.formatMoney(WSAIO.rd_or_regularPrice) + WS.Lang.each_item + '</td>' +
            '</tr>';
          }
		rule.volume_discount.forEach(function (vd, i) {
			if (Number(vd.qty) > 0 && vd.value != '' && WS.get_price(rule, vd) != undefined) {
			table_rows += '<tr class="wholesale-grid-table custom-table wsaio_vdRow_'+params.variant_id+'_'+Number(vd.qty)+'">' +
			  '<td>' + vd.qty + '</td>' +
			  '<td>' + WS.get_price(rule, vd) + WS.Lang.each_item + '</td>' +
			  '</tr>';
		  }
		});
		if(table_description != ''){
            table_rows += '<tr class="wholesale-grid-table custom-table">' +
            '<td colspan="4" style="font-size: 12px; font-style: italic;background-color: #f8f8f8; padding: 3px 10px;">'+'Note: '
             + table_description  
            +'</td>' +
            '</tr>';
        }
		var table = '<table id="wsaio-volume-discount--table" class="wholesale-table">' +
			'<thead><tr>' +
			'<th>' + WS.Lang.quantity + '</th>' +
			'<th>' + WS.Lang.price + '</th>' +
			'</tr></thead>' +
			'<tbody>' + table_rows + '</tbody>' +
			'</table>';
		if (table_rows != "") {
		   if(document.querySelector('#Quick-order-form') === null){
			if (params.template === 'collection' && 
				WSAIO.template !== 'collection' && 
				WSAIO.price_selector_format(params.item_price_selector)?.closest(WSAIO.collection_items_each_selector)?.querySelector(WSAIO.product_inner_qb_table_selector) === null) {
				return false;
			}
                            const baseSelector = `.wsaio_${params.product_id}.wsaio_${params.variant_id}`;
                            const baseElements = document.querySelectorAll(baseSelector);
                            const parentGrids = new Set();
                            baseElements.forEach(baseEl => {
                            const parents = baseEl.closest ? baseEl.closest(WSAIO.product_parent_grid_selector)  : null;
                            if (parents) parentGrids.add(parents);
                            });

                            if (parentGrids.size && !document.querySelector('quick-order-list')) {
                                parentGrids.forEach(parentGrid => {
                                    parentGrid.querySelectorAll('.wholesale-table').forEach(el => el.remove());
                                    const innerTargets =
                                    parentGrid.querySelectorAll(WSAIO.product_inner_qb_table_selector);
                                    innerTargets.forEach(target => {
                                    target.insertAdjacentHTML('afterend', table);
                                    });
								});
							}

		  }else{
			  WS.displayTable(table, '.wsaio-qt-'+params.product_id+':same', !0)  
			  WS.displayTable(table, '.wsaio-vqt-'+params.variant_id+':same', !0)
		  }
		} else {
		  if(document.querySelector('#Quick-order-form') === null){
			const tables = document.querySelectorAll('.wholesale-table');
			tables.forEach(table => {
				table.remove();
			});
		  }
		}
	  } else {
		const tables = document.querySelectorAll('.wholesale-table');
			tables.forEach(table => {
				table.remove();
			});
		isError("Volume discount was not configured.");
	  }
	};
  
	WSAIO.grid_range_table = function (rule, params) {
	  if (WSAIO.debugger) debugger;
	  if ('undefined' !== typeof rule.volume_discount && rule.volume_discount.length > 0) {
		var table_rows = "",table_description = "";
		if(typeof params.volume_table_heading != 'undefined'){
			table_description = params.volume_table_heading;
		}

     WSAIO.append_single_qty_price(rule, params);

        if(parseInt(rule.volume_discount[0].qty,10) > 0 && parseInt(rule.volume_discount[0].qty,10) != 1 && WSAIO.rd_or_regularPrice != 0){
            table_rows += '<tr class="wholesale-grid-table custom-table wsaio_vdRow_'+params.variant_id+'_'+1+' active_row">' +
			  '<td>1</td>' +
			  '<td>' + (Number(rule.volume_discount[0].qty)-1) + '</td>' +
			  '<td>' + WSAIO.formatMoney(WSAIO.rd_or_regularPrice) + WS.Lang.each_item + '</td>' +
			  '</tr>';
          }
		rule.volume_discount.forEach(function (vd, i) {
			if (Number(vd.qty) > 0 && vd.value != '' && WS.get_price(rule, vd) != undefined) {
			var next_qty = WS.Lang.range_so_on;
			if (rule.volume_discount[i + 1]) {
			  next_qty = Number(rule.volume_discount[i + 1].qty) - 1;
			}
			table_rows += '<tr class="wholesale-grid-table custom-table wsaio_vdRow_'+params.variant_id+'_'+vd.qty+'">' +
			  '<td>' + vd.qty + '</td>' +
			  '<td>' + next_qty + '</td>' +
			  '<td>' + WS.get_price(rule, vd) + WS.Lang.each_item + '</td>' +
			  '</tr>';
		  }
		});
		if(table_description != ''){
            table_rows += '<tr class="wholesale-grid-table custom-table">' +
            '<td colspan="4" style="font-size: 12px; font-style: italic;background-color: #f8f8f8; padding: 3px 10px;">'+'Note: '
             + table_description  
            +'</td>' +
            '</tr>';
        }
		var table = '<table id="wsaio-volume-discount--table" class="wholesale-table">' +
			'<thead><tr>' +
			'<th>' + WS.Lang.minimum_quantity + '</th>' +
			'<th>' + WS.Lang.maximum_quantity + '</th>' +
			'<th>' + WS.Lang.price + '</th>' +
			'</tr></thead>' +
			'<tbody>' + table_rows + '</tbody>' +
			'</table>';
		if (table_rows != "") {
		    if(document.querySelector('#Quick-order-form') === null){
			if (params.template === 'collection' && 
				WSAIO.template !== 'collection' && 
				WSAIO.price_selector_format(params.item_price_selector)?.closest(WSAIO.collection_items_each_selector)?.querySelector(WSAIO.product_inner_qb_table_selector) === null) {
				return false;
			}
            const baseSelector = `.wsaio_${params.product_id}.wsaio_${params.variant_id}`;
            const baseElements = document.querySelectorAll(baseSelector);
            const parentGrids = new Set();
            baseElements.forEach(baseEl => {
            const parents = baseEl.closest ? baseEl.closest(WSAIO.product_parent_grid_selector)  : null;
            if (parents) parentGrids.add(parents);
            });

            if (parentGrids.size && !document.querySelector('quick-order-list')) {
                parentGrids.forEach(parentGrid => {
                    parentGrid.querySelectorAll('.wholesale-table').forEach(el => el.remove());
                    const innerTargets =
                    parentGrid.querySelectorAll(WSAIO.product_inner_qb_table_selector);
                    innerTargets.forEach(target => {
                    target.insertAdjacentHTML('afterend', table);
								});
                });
				}
		  }else{
			  WS.displayTable(table, '.wsaio-qt-'+params.product_id+':same', !0)  
			  WS.displayTable(table, '.wsaio-vqt-'+params.variant_id+':same', !0)
		  }
		} else {
		  if(document.querySelector('#Quick-order-form') === null){
			const tables = document.querySelectorAll('.wholesale-table');
			tables.forEach(table => {
				table.remove();
			});
		  }
		}
	  } else {
		const tables = document.querySelectorAll('.wholesale-table');
			tables.forEach(table => {
				table.remove();
			});
		isError("Volume discount was not configured.");
	  }
	};
  
	WSAIO.detailed_grid_percent_table = function (rule, params) {
	  if (WSAIO.debugger) debugger;
	  if ('undefined' !== typeof rule.volume_discount && rule.volume_discount.length > 0) {
		var table_rows = "",table_description = "";
		if(typeof params.volume_table_heading != 'undefined'){
			table_description = params.volume_table_heading;
		}

     WSAIO.append_single_qty_price(rule, params);
 var hide_percentage_column = false;
         if(parseInt(rule.volume_discount[0].qty,10) > 0 && parseInt(rule.volume_discount[0].qty,10) != 1 && WSAIO.rd_or_regularPrice != 0){
			if(WSAIO.rd_or_regularPrice > (WSAIO.selected_variant.price/100)) hide_percentage_column = true;
           table_rows += '<tr class="wholesale-grid-table custom-table wsaio_vdRow_'+params.variant_id+'_'+1+' active_row">' +
			  '<td>1</td>' +
			  '<td>' + WSAIO.formatMoney(WSAIO.rd_or_regularPrice) + WS.Lang.each_item + '</td>' +
			  '<td class="v_percentage_column">' + Math.round(100-(((WSAIO.rd_or_regularPrice)/(WSAIO.selected_variant.price/100))*100)).toString()+'%' + ' ' + WS.Lang.off + '</td>' +
			  '</tr>';
          }
		 
		rule.volume_discount.forEach(function (vd, i) {
			if (Number(vd.qty) > 0 && vd.value != '' && WS.get_price(rule, vd) != undefined) {
			if(WS.get_price_in_percent(rule, vd).indexOf('-') > -1) hide_percentage_column = true;
			table_rows += '<tr class="wholesale-grid-table custom-table  wsaio_vdRow_'+params.variant_id+'_'+Number(vd.qty)+'">' +
			  '<td>' + vd.qty + '</td>' +
			  '<td>' + WS.get_price(rule, vd) + WS.Lang.each_item + '</td>' +
			  '<td class="v_percentage_column">' + WS.get_price_in_percent(rule, vd) + ' ' + WS.Lang.off + '</td>' +
			  '</tr>';
		  }
		});
        if(table_description != ''){
            table_rows += '<tr class="wholesale-grid-table custom-table">' +
            '<td colspan="4" style="font-size: 12px; font-style: italic;background-color: #f8f8f8; padding: 3px 10px;">'+'Note: '
             + table_description  
            +'</td>' +
            '</tr>';
        }
		var table = '<table id="wsaio-volume-discount--table" class="wholesale-table ' + (hide_percentage_column ? 'hide_coloumn' : '') + '">' +
			'<thead><tr>' +
			'<th>' + WS.Lang.quantity + '</th>' +
			'<th>' + WS.Lang.price + '</th>' +
			'<th class="v_percentage_column">' + WS.Lang.discount + '</th>' +
			'</tr></thead>' +
			'<tbody>' + table_rows + '</tbody>' +
			'</table>';
		if (table_rows != "") {
		   if(document.querySelector('#Quick-order-form') === null){
			if (params.template === 'collection' && 
				WSAIO.template !== 'collection' && 
				WSAIO.price_selector_format(params.item_price_selector)?.closest(WSAIO.collection_items_each_selector)?.querySelector(WSAIO.product_inner_qb_table_selector) === null) {
				return false;
			}
            const baseSelector = `.wsaio_${params.product_id}.wsaio_${params.variant_id}`;
            const baseElements = document.querySelectorAll(baseSelector);
            const parentGrids = new Set();
            baseElements.forEach(baseEl => {
            const parents = baseEl.closest ? baseEl.closest(WSAIO.product_parent_grid_selector)  : null;
            if (parents) parentGrids.add(parents);
            });

            if (parentGrids.size && !document.querySelector('quick-order-list')) {
                parentGrids.forEach(parentGrid => {
                    parentGrid.querySelectorAll('.wholesale-table').forEach(el => el.remove());
                    const innerTargets =
                    parentGrid.querySelectorAll(WSAIO.product_inner_qb_table_selector);
                    innerTargets.forEach(target => {
                    target.insertAdjacentHTML('afterend', table);
								});
                });
				}
		  }else{
			  WS.displayTable(table, '.wsaio-qt-'+params.product_id+':same', !0)  
			  WS.displayTable(table, '.wsaio-vqt-'+params.variant_id+':same', !0)
		  }
		} else {
		 if(document.querySelector('#Quick-order-form') === null){
			const tables = document.querySelectorAll('.wholesale-table');
			tables.forEach(table => {
				table.remove();
			});
		  }
		}
	  } else {
		const tables = document.querySelectorAll('.wholesale-table');
			tables.forEach(table => {
				table.remove();
			});
		isError("Volume discount was not configured.");
	  }
	};
  
	WSAIO.percent_grid_table = function (rule, params) {
	  if (WSAIO.debugger) debugger;
	  if ('undefined' !== typeof rule.volume_discount && rule.volume_discount.length > 0) {
		var table_rows = "",table_description = "";
		if(typeof params.volume_table_heading != 'undefined'){
			table_description = params.volume_table_heading;
		}

     WSAIO.append_single_qty_price(rule, params);
var hide_percentage_column = false;
            if(parseInt(rule.volume_discount[0].qty,10) > 0 && parseInt(rule.volume_discount[0].qty,10) != 1 && WSAIO.rd_or_regularPrice != 0){
				if(WSAIO.rd_or_regularPrice > (WSAIO.selected_variant.price/100)) hide_percentage_column = true;
            table_rows += '<tr class="wholesale-grid-table custom-table wsaio_vdRow_'+params.variant_id+'_'+1+' active_row">' +
            '<td>' + WS.Lang.buy + ' '+'1</td>' +
             '<td>' + Math.round((100-(((WSAIO.rd_or_regularPrice)/(WSAIO.selected_variant.price/100))*100))).toString()+'%' + ' ' + WS.Lang.off + '</td>' +
            '</tr>';
          }
		   
		rule.volume_discount.forEach(function (vd, i) {
			if (Number(vd.qty) > 0 && vd.value != '' && WS.get_price_in_percent(rule, vd) != undefined) {
					if(WS.get_price_in_percent(rule, vd).indexOf('-') > -1) hide_percentage_column = true;
			  table_rows += '<tr class="wholesale-grid-table custom-table wsaio_vdRow_'+params.variant_id+'_'+Number(vd.qty)+'">' +
				'<td>' + WS.Lang.buy + ' ' + vd.qty + '</td>' +
				'<td>' + WS.get_price_in_percent(rule, vd) + ' ' + WS.Lang.off + '</td>' +
				'</tr>';
			}
		});
		if(hide_percentage_column){
			WS.detailed_grid_percent_table(rule, params);
			return false;
		}
        if(table_description != ''){
            table_rows += '<tr class="wholesale-grid-table custom-table">' +
            '<td colspan="4" style="font-size: 12px; font-style: italic;background-color: #f8f8f8; padding: 3px 10px;">'+'Note: '
             + table_description  
            +'</td>' +
            '</tr>';
        }
		var table = '<table id="wsaio-volume-discount--table" class="wholesale-table">' +
			'<thead><tr>' +
			'<th>' + WS.Lang.quantity + '</th>' +
			'<th>' + WS.Lang.discount + '</th>' +
			'</tr></thead>' +
			'<tbody>' + table_rows + '</tbody>' +
			'</table>';
		if (table_rows != "") {
           
		    if(document.querySelector('#Quick-order-form') === null){
			if (params.template === 'collection' && 
				WSAIO.template !== 'collection' && 
				WSAIO.price_selector_format(params.item_price_selector)?.closest(WSAIO.collection_items_each_selector)?.querySelector(WSAIO.product_inner_qb_table_selector) === null) {
				return false;
			}
            const baseSelector = `.wsaio_${params.product_id}.wsaio_${params.variant_id}`;
            const baseElements = document.querySelectorAll(baseSelector);
            const parentGrids = new Set();
            baseElements.forEach(baseEl => {
            const parents = baseEl.closest ? baseEl.closest(WSAIO.product_parent_grid_selector)  : null;
            if (parents) parentGrids.add(parents);
            });

            if (parentGrids.size && !document.querySelector('quick-order-list')) {
                parentGrids.forEach(parentGrid => {
                    parentGrid.querySelectorAll('.wholesale-table').forEach(el => el.remove());
                    const innerTargets =
                    parentGrid.querySelectorAll(WSAIO.product_inner_qb_table_selector);
                    innerTargets.forEach(target => {
                    target.insertAdjacentHTML('afterend', table);
								});
                });
				}
		  }else{
			  WS.displayTable(table, '.wsaio-qt-'+params.product_id+':same', !0)  
			  WS.displayTable(table, '.wsaio-vqt-'+params.variant_id+':same', !0)
		  }
		} else {
		  if(document.querySelector('#Quick-order-form') === null){
			const tables = document.querySelectorAll('.wholesale-table');
			tables.forEach(table => {
				table.remove();
			});
		  }
		}
	  } else {
		const tables = document.querySelectorAll('.wholesale-table');
			tables.forEach(table => {
				table.remove();
			});
		isError("Volume discount was not configured.");
	  }
	};
  
	WSAIO.grid_range_alternate_table = function (rule, params) {
	  if (WSAIO.debugger) debugger;
	  if ('undefined' !== typeof rule.volume_discount && rule.volume_discount.length > 0) {
		var table_rows = "",table_description = "";
		if(typeof params.volume_table_heading != 'undefined'){
			table_description = params.volume_table_heading;
		}

     WSAIO.append_single_qty_price(rule, params);

        if(parseInt(rule.volume_discount[0].qty) > 0 && parseInt(rule.volume_discount[0].qty) != 1 && WSAIO.rd_or_regularPrice != 0){
          table_rows += '<tr class="wholesale-grid-table custom-table custom-table wsaio_vdRow_'+params.variant_id+'_'+1+' active_row">' +
			  '<td>1' +  WS.Lang.range_seperator + (Number(rule.volume_discount[0].qty) - 1) + '</td>' +
			  '<td>' + WSAIO.formatMoney(WSAIO.rd_or_regularPrice) + WS.Lang.each_item + '</td>' +
			  '</tr>';
        }
		rule.volume_discount.forEach(function (vd, i) {
			if (Number(vd.qty) > 0 && vd.value != '' && WS.get_price(rule, vd) != undefined) {
			var next_qty = WS.Lang.range_so_on;
			if (rule.volume_discount[i + 1]) {
			  next_qty = Number(rule.volume_discount[i + 1].qty) - 1;
			}
			table_rows += '<tr class="wholesale-grid-table custom-table custom-table wsaio_vdRow_'+params.variant_id+'_'+Number(vd.qty)+'">' +
			  '<td>' + vd.qty + WS.Lang.range_seperator + next_qty + '</td>' +
			  '<td>' + WS.get_price(rule, vd) + WS.Lang.each_item + '</td>' +
			  '</tr>';
		  }
		});
        if(table_description != ''){
            table_rows += '<tr class="wholesale-grid-table custom-table">' +
            '<td colspan="4" style="font-size: 12px; font-style: italic;background-color: #f8f8f8; padding: 3px 10px;">'+'Note: '
             + table_description  
            +'</td>' +
            '</tr>';
        }
		var table = '<table id="wsaio-volume-discount--table" class="wholesale-table">' +
			'<thead><tr>' +
			'<th>' + WS.Lang.quantity + '</th>' +
			'<th>' + WS.Lang.price + '</th>' +
			'</tr></thead>' +
			'<tbody>' + table_rows + '</tbody>' +
			'</table>';
		if (table_rows != "") {
		    if(document.querySelector('#Quick-order-form') === null){
			if (params.template === 'collection' && 
				WSAIO.template !== 'collection' && 
				WSAIO.price_selector_format(params.item_price_selector)?.closest(WSAIO.collection_items_each_selector)?.querySelector(WSAIO.product_inner_qb_table_selector) === null) {
				return false;
			}
            const baseSelector = `.wsaio_${params.product_id}.wsaio_${params.variant_id}`;
            const baseElements = document.querySelectorAll(baseSelector);
            const parentGrids = new Set();
            baseElements.forEach(baseEl => {
            const parents = baseEl.closest ? baseEl.closest(WSAIO.product_parent_grid_selector)  : null;
            if (parents) parentGrids.add(parents);
            });

            if (parentGrids.size && !document.querySelector('quick-order-list')) {
                parentGrids.forEach(parentGrid => {
                    parentGrid.querySelectorAll('.wholesale-table').forEach(el => el.remove());
                    const innerTargets =
                    parentGrid.querySelectorAll(WSAIO.product_inner_qb_table_selector);
                    innerTargets.forEach(target => {
                    target.insertAdjacentHTML('afterend', table);
								});
								});
				}
		  }else{
			  WS.displayTable(table, '.wsaio-qt-'+params.product_id+':same', !0)  
			  WS.displayTable(table, '.wsaio-vqt-'+params.variant_id+':same', !0)
		  }
		} else {
		  if(document.querySelector('#Quick-order-form') === null){
			const tables = document.querySelectorAll('.wholesale-table');
			tables.forEach(table => {
				table.remove();
			});
		  }
		}
	  } else {
		const tables = document.querySelectorAll('.wholesale-table');
			tables.forEach(table => {
				table.remove();
			});
		isError("Volume discount was not configured.");
	  }
	};
  
	WSAIO.fetchCart = function (callback) {
	  var url_string = WSAIO.local_param+"cart.js";
	  if(typeof Shopify.currency.active != 'undefined' && Shopify.currency.active != null && Shopify.currency.active != '' && typeof window.token_enable == 'undefined'){
		url_string = url_string+'?currency='+Shopify.currency.active;
	  }
	  WS.ajax({
		type: 'GET',
		url: url_string,
		cache: false,
		dataType: 'json',
		success: function (cart_obj) {
		  var ws_cart_items = [];
		  if (cart_obj && cart_obj.items && cart_obj.items.length > 0) {
			cart_obj.items.forEach(function (item, i) {
			  try {
				delete item.product_description;
				delete item.featured_image;
				delete item.url;
				delete item.options_with_values;
				delete item.variant_options;
				delete item.product_description;
			  } catch (error) {
				log(error);
			  }
			  ws_cart_items.push(item);
			});
			cart_obj.items = ws_cart_items;
		  }
		  try {
			"undefined" === typeof window.waioMOC && (window.waioMOC = {});
			"undefined" === typeof waioMOC.cart && (waioMOC.cart = {});
			try {
			  waioMOC.cart["item_count"] = cart_obj.item_count;
              waioMOC.cart["total_weight"] = cart_obj.total_weight;
			} catch (e) {}
		  } catch (e) {}
		  if ("function" === typeof callback) {
			callback(null, cart_obj);
		  }
		},
		error: function (err) {
		  if ("function" === typeof callback) {
			callback(err, null);
		  }
		}
	  });
	};
  

	WSAIO.check_lineItem_properties = function(){
		try{
			const pattern = /\b[A-Z]{4}\d{2}\d{2}\d{4}\b/;
			if(WSAIO.general_settings.discount_method == 'coupon_code' && (typeof WSAIO.enable_lineCouponCode != 'undefined' && WSAIO.enable_lineCouponCode)){
					const itemss = WSAIO.custom_id_price.split(',');
					function update_itm(itemId, newPrice, qty){
							const requestData = {
								id: itemId,
								quantity: qty,
								properties: {
									"_Wholesale_All_In_One__Discount_ID": WSAIO.encode(newPrice)
								}
							};

							fetch('/cart/change.js', {
								method: 'POST',
								headers: {
									'Content-Type': 'application/json',
									'Accept': 'application/json' 
								},
								body: JSON.stringify(requestData) 
							})
							.then(response => {
								if (!response.ok) {
									throw new Error('Network response was not ok: ' + response.statusText);
								}
								return response.json();
							})
							.then(data => {
								//console.log('Cart updated successfully:', data);
							})
							.catch(error => {
								//console.error('There was a problem with the fetch operation:', error);
							});
					};


          for (const item of itemss) {
						var [itemId, newPrice, qty, type] = item.split('_');
			
						const existingItem = cart_data.items.find(cartItem => cartItem.id === parseInt(itemId,10));
						const existingPrice = existingItem?.properties?._Wholesale_All_In_One__Discount_ID;
						var discounted_percentage = ((parseFloat(newPrice)/(parseFloat(existingItem.price)/100))*100);
						if(type == 'price' || type == 'fixed'){
							const original_price = ((parseFloat(existingItem.price)/Shopify.currency.rate).toFixed(0))*Shopify.currency.rate;
							discounted_percentage = (100-((((parseFloat(original_price)/100)-parseFloat(newPrice))/(parseFloat(original_price)/100))*100))
						} 
						
						if (existingPrice === WSAIO.encode(discounted_percentage)) {
							continue; // Skip if the price hasn't changed
						}
			
						// Send requests in batches
						update_itm(itemId, discounted_percentage, qty);
					}

          // calculate automatic discount
          var automatic_percentage = 0;
          if(cart_data.cart_level_discount_applications[0] != undefined && cart_data.cart_level_discount_applications[0].value != undefined && typeof WSAIO.general_settings.preventAutomaticDiscounts != 'undefined' && WSAIO.general_settings.preventAutomaticDiscounts){
               var discount_info = cart_data.cart_level_discount_applications[0]; 
               if(!pattern.test(discount_info.title)){
                  if(discount_info.value_type == 'percentage'){
                      automatic_percentage = automatic_percentage + Number(discount_info.value);
                  }else{
                      var rg_price = preDiscountData.checkout_price_from_original_total_price;
                      var final_percent = (Number(discount_info.value)/Number(rg_price))*100;
                      automatic_percentage = automatic_percentage + final_percent;
                  }
                }else{
                  for (const key in cart_data.attributes) {
                    if(key.indexOf('_automatic') > -1){
                         automatic_percentage = Number(WSAIO.decrypt(key.split('_automatic_')[1]));
                          break;
                      }
                  }
                }
          }

					var ct_value = 0;
					if(WSAIO.general_settings.discount_method == 'coupon_code'){
						if(
							typeof preDiscountData.cart_level_discount != 'undefined'
							&& 
							typeof preDiscountData.cart_level_discount.discount_type != 'undefined'
						){
							const ct_type = preDiscountData.cart_level_discount.discount_type;
							var ct_value = preDiscountData.cart_level_discount.discount_value;
							if(ct_type != 'percentage'){
								ct_value = (Number(ct_value)/Number(preDiscountData.checkout_price_from_original_total_price))*100;
							}
						}
            
            ct_value = ct_value + automatic_percentage;
						if(ct_value == 0){
							var ct_percentage = '';
						}else{
							var ct_percentage = WSAIO.encode(ct_value);
						}
       
						if(typeof WSAIO.cart_object.attributes._WSAIO_cart_discount != 'undefined' || ct_percentage != '' || automatic_percentage != 0){
              var discount_percent = {};
              if(ct_percentage != ''){
               discount_percent = {"_WSAIO_cart_discount": ct_percentage};
									}
              if(automatic_percentage != 0){
                discount_percent = {"_WSAIO_cart_discount": ct_percentage,[`_automatic_${WSAIO.encode(automatic_percentage)}`]: ct_percentage};
								}
            
                fetch('/cart/update.js', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                      attributes: discount_percent
                  })
							})
						}
				    }

			
						} 
						
			const parents = document.querySelectorAll(WSAIO.cart_items_each_selector);
			
			// Use a for loop instead of forEach
			for(let i = 0; i < parents.length; i++) {
				const parent = parents[i];
			const matchingChildren = Array.from(parent.querySelectorAll('*')).filter(child => 
				pattern.test(child.textContent.trim())
			);
			if (matchingChildren.length > 0) {
				const lastMatchingChild = matchingChildren[matchingChildren.length - 1];
				var tagName = lastMatchingChild.tagName.toLowerCase();
					
				// Function to append the style to the head
				function appendStyleToHead(css) {
					let styleElement = document.getElementById('dynamic-style');
					if (!styleElement) {
						styleElement = document.createElement('style');
						styleElement.innerHTML = css;
						styleElement.id = 'dynamic-style';
						document.head.appendChild(styleElement);
					}
				
				}
				const css = `
					${tagName}.${Array.from(lastMatchingChild.classList).join('.')} {
						display: none !important;
					}
				`;
				
				appendStyleToHead(css);
				lastMatchingChild.style.display = 'none';
					break;  // Exit the loop when matchingChildren.length > 0
			}
			}
		}catch(e){}
	}
  
	WSAIO.checkout = function () {
	  if (WSAIO.debugger) debugger;
	  if(WSAIO.isWholesaleCustomer() === false || (window.ZapietCheckoutEnabled === false && typeof ZapietWidgetConfig != 'undefined' && Object.keys(ZapietWidgetConfig).length != 0)){
		if (typeof callback === "function") {
		  return callback({
			error: "Invalid customer"
		  });
		} else {
		  return "Invalid customer";
		}
	  }
	  sessionStorage.setItem('isCheckoutvisited', 'true');
		const selectors16 = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector + ',' + WSAIO.netTerm_checkout_selector;
		const selectors166 = selectors16.split(',');
		const cleanSelectors16 = selectors166.map(sel => sel.trim()).filter(Boolean);
		document.querySelectorAll(cleanSelectors16).forEach(element => {
			element.classList.add('checkout-disabled');
			element.setAttribute('disabled', 'disabled');
			element.style.pointerEvents = 'none';
			element.style.cursor = 'progress';
		});
	  
      if(WSAIO.general_settings.discount_method == 'coupon_code' && (typeof WSAIO.enable_lineCouponCode != 'undefined' && WSAIO.enable_lineCouponCode)){
		  WSAIO.showCheckoutLoader();
					const sendRequest = (itemId, newPriceEncoded, qty) => {
						return new Promise((resolve) => {
							fetch('/cart/change.js', {
								method: 'POST',
								headers: {
									'Content-Type': 'application/json'
								},
								body: JSON.stringify({
									id: itemId,
									quantity: qty,
									properties: { "_Wholesale_All_In_One__Discount_ID": newPriceEncoded }
								})
							})
							.then(response => {
								resolve(response.json()); 
							})
							.catch(() => {
								resolve(); 
							});
						});
					};
					const updatePrices = async () => {
					const itemss = WSAIO.custom_id_price.split(',');
					const promises = [];
					const maxRequests = 1;
					const interval = 500;
					for (const item of itemss) {
						var [itemId, newPrice, qty, type] = item.split('_');

						const existingItem = cart_data.items.find(cartItem => cartItem.id === parseInt(itemId,10));
						const existingPrice = existingItem?.properties?._Wholesale_All_In_One__Discount_ID;
						var discounted_percentage = ((parseFloat(newPrice) / (parseFloat(existingItem.price) / 100)) * 100);
						
						if (type == 'price' || type == 'fixed') {
							const original_price = (parseFloat(existingItem.price) / Shopify.currency.rate).toFixed(0) * Shopify.currency.rate;
							discounted_percentage = (100 - ((((parseFloat(original_price) / 100) - parseFloat(newPrice)) / (parseFloat(original_price) / 100)) * 100));
						} 
						const newPriceEncoded = WSAIO.encode(discounted_percentage);
						
						if (existingPrice === newPriceEncoded) {
							continue;
						}

						// --- Send requests in batches ---
						promises.push(sendRequest(itemId, newPriceEncoded, qty));
						if (promises.length >= maxRequests) {
							await Promise.all(promises);
							promises.length = 0;
							await new Promise(resolve => setTimeout(resolve, interval)); 
						}
					}
					if (promises.length) {
						await Promise.all(promises);
					}
				};
				if (typeof WSAIO.fetchCartNative === 'function') {
					WSAIO.fetchCartNative()
						.then(async (cart) => {
							await updatePrices(); 
							proceedCheckout();
						})
						.catch(async (error) => {
							await updatePrices(); 
							proceedCheckout();
						});
				} else {
					(async () => {
						await updatePrices(); 
						proceedCheckout();
					})();
				}
         }else{
        proceedCheckout();
       }

    function proceedCheckout(){
				function mapObject(obj, callback) {
					return Object.entries(obj).map(([key, value]) => callback(value, key));
				}

	
				function elementExists(selector) {
					return document.querySelector(selector) !== null;
				}


				function getCheckedRadioValue(selector) {
					const radio = document.querySelector(selector);
					return radio ? radio.value : null;
				}

				function getElementValue(selector) {
					const element = document.querySelector(selector);
					return element ? element.value : '';
				}

				function checkSubscriptionAndProceed(error, cart) {
					if (error) {
						return isError(error);
					}

					function go_checkout() {
						WSAIO.showCheckoutLoader();
						
						if ((WSAIO.disable_checkout && (typeof WSAIO.allow_normal_checkout__OC !== 'undefined' && WSAIO.allow_normal_checkout__OC))) {
							return WS.redirectToURL('/checkout');
						}

						const note_attr = mapObject(cart.attributes, (val, i) => ({
							name: i,
							value: val
						}));

						const poFieldSelector = '.po_field';
						if (WSAIO.PO_field_enable && getElementValue(poFieldSelector) !== '') {
							const po_value = getElementValue(poFieldSelector) || '';
							note_attr.push({
								"name": 'Purchase Order (PO) Number',
								"value": po_value
							});
						}

						let shopify_discounts = '';
						
						cart.items.forEach(indx => {
							if (indx.discounts && indx.discounts.length > 0) {
								indx.discounts.forEach(discount => {
									if (shopify_discounts.indexOf(discount.title) === -1) {
										if (shopify_discounts !== '') {
											shopify_discounts += ' , ';
										}
										shopify_discounts += discount.title;
									}
								});
							}
						});

						if (shopify_discounts !== '') {
							note_attr.push({
								"name": 'Shopify Automatic Discount',
								"value": shopify_discounts
							});
						}

						let custom_ship_line = {};
						const deliveryPickupSelector = '.wsaio_delivery_pickup';
						const radioSelector = '[name="wsaio_delivery_method"]:checked';
						
						if (WSAIO.shipping_pickup_option && elementExists(deliveryPickupSelector)) {
							if (getCheckedRadioValue(radioSelector) === 'pickup') {
								custom_ship_line = {
									custom: true,
									price: "0",
									title: "Pickup Order"
								};
							}
						}

						const reqdata = {
							custom_shipping_line: custom_ship_line,
							note_attributes: note_attr,
							custom_line_items: [],
							cart: cart,
							shopInfo: WS.shopInfo,
							customer: WS.customer,
							user_mode: WS.user_mode,
							currency: WS.shopInfo.currency,
							discount_code_application: WSAIO.DiscountCode.application,
							products_with_collections: (WSAIO.cart_relevent_collectionID() || []),
							missing_products_with_collections:(WSAIO.check_missing_collection_ids() || [])
						};

						if (WSAIO.all_discount_tags && WSAIO.all_discount_tags.length > 0) {
							try {
								if (typeof WSAIO.wholesale_app_tags === 'undefined' || (WSAIO.wholesale_app_tags.indexOf('app') > -1)) {
									WSAIO.all_discount_tags.push("wsaio-app");
								}
								reqdata["tags"] = WSAIO.all_discount_tags.toString();
							} catch (e) { log(e) }
						} else {
							if (typeof WSAIO.wholesale_app_tags === 'undefined' || (WSAIO.wholesale_app_tags.indexOf('app') > -1)) {
								reqdata["tags"] = "wsaio-app";
							}
						}
						
						const cartNoteValue = getElementValue(WSAIO.cart_note_selector);
						if (cart.note === null || cart.note !== cartNoteValue) {
							reqdata["note"] = cartNoteValue;
						}

						if (WS.variant_sku_are_same) { reqdata["variant_sku_are_same"] = WS.variant_sku_are_same; }
						if (WS.coupon_expires_after_hours) { reqdata["coupon_expires_after_hours"] = WS.coupon_expires_after_hours; }
						if (typeof window.company_data !== 'undefined') { reqdata["company"] = window.company_data; }

						const hasSellingPlan = cart.items.some(item => item.selling_plan_allocation);
						if (hasSellingPlan) { reqdata["hasSubscription"] = true; }

						if (WS.auto_delete_api) {
							try {
								const draftOrderInfo = localStorage.getItem("draft_order_info");
								if (draftOrderInfo !== null) {
									reqdata["prev_draft_order_info"] = JSON.parse(draftOrderInfo);
								}
							} catch (e) { log(e) }

							try {
								const priceRuleInfo = localStorage.getItem("price_rule_info");
								if (priceRuleInfo !== null) {
									reqdata["prev_price_rule_info"] = JSON.parse(priceRuleInfo);
								}
							} catch (e) { log(e) }
						}

						if (WSAIO.shopify_markets_pro_enabled && (typeof Shopify !== "undefined" && typeof Shopify.currency !== "undefined" && Shopify.currency.active !== WSAIO.shopInfo.currency)) {
							if (!WS.customer || !WS.customer.addresses || WS.customer.addresses[0] === undefined) {
								WS.customer = { "addresses": [{ "country": WSAIO.shop_country }] };
							}
							if (WS.customer && WS.customer.addresses && WS.customer.addresses[0]) {
								reqdata["shipping_address"] = WS.customer.addresses[0];
								reqdata["billing_address"] = WS.customer.addresses[0];
							}
						}
						
						if (WS.ccr) { reqdata["ccr"] = WS.ccr; }
						if (typeof WSAIO.multiple_markets_available !== 'undefined') { reqdata["multiple_markets_available"] = WSAIO.multiple_markets_available; }

						WS.checkoutRequest(reqdata, function (error, response) {
							const allCheckoutSelectors = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector + ',' + WSAIO.netTerm_checkout_selector;
							const basicCheckoutSelectors = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector;
							setTimeout(function() {
								const loaderElement = document.querySelectorAll('.wsaio_loader_checkout');
								if (loaderElement) {
									loaderElement.forEach(function(ele){
											ele.style.display = 'none';
									})

								}
								const selectors13 = basicCheckoutSelectors.split(',');
								const cleanSelectors13 = selectors13.map(sel => sel.trim()).filter(Boolean);
								document.querySelectorAll(cleanSelectors13).forEach(el => el.classList.remove('wsaio_hideCheckout'));
								
								const selectorss = allCheckoutSelectors.split(',');
								const cleanSelectorsss = selectorss.map(sel => sel.trim()).filter(Boolean);
								document.querySelectorAll(cleanSelectorsss).forEach(element => {
									element.classList.remove('checkout-disabled');
									element.removeAttribute('disabled');
									element.style.pointerEvents = 'auto';
									element.style.cursor = 'pointer';
								});
                WSAIO.preCheckout();
							}, 3000);

							if (response?.isError && response.error?.errors) {
								const error_msg = response.error.errors[0].message;
								if (error_msg && error_msg.indexOf('Managed Markets orders') > -1) {
									WSAIO.shopify_markets_pro_enabled = true;
									if (typeof recheckout_marketPro === 'undefined') recheckout_marketPro = 0; 
									
									if (recheckout_marketPro < 1) {
										recheckout_marketPro++;
										WSAIO.checkout(); 
										return;
									}
								}
							}

							if (response?.wholesale_errors?.length > 0) {
								for (const err of response.wholesale_errors) {
									if (err.key === 'email') {
										if (document.querySelector('.wsaioserver_error') === null) {
											    const selectors = WSAIO.checkout_message_selector.split(',');
												const cleanSelectors = selectors.map(sel => sel.trim()).filter(Boolean);
                                                document.querySelectorAll('.wsaioserver_errordiv').forEach(function(e){e.remove();});
												cleanSelectors.forEach(target => {
													const targetElements = document.querySelectorAll(target);
													targetElements.forEach(targetele => {
															const container = document.createElement('div');
															container.classList.add('wsaioserver_errordiv');
															container.innerHTML = '<div class="wsaioserver_error" style="color:red !important;font-size:12px !important;">Email contains an invalid domain name. Retry to place an order without a discount.</div>';
															if(container.innerHTML.trim() !== ""){
															targetele.insertAdjacentElement('afterend', container);
															}
														})
												})
											const selectors13 = allCheckoutSelectors.split(',');
											const cleanSelectors13 = selectors13.map(sel => sel.trim()).filter(Boolean);
											document.querySelectorAll(cleanSelectors13).forEach(element => {
													element.classList.remove('checkout-disabled');
													element.removeAttribute('disabled');
													element.style.pointerEvents = 'auto';
													element.style.cursor = 'pointer';
											});
											return; 
										} else {
											return WS.redirectToURL('/checkout');
										}
									}
								}
							}
							
							if (response && response.checkout_url === null) {
								return WS.redirectToURL('/checkout?wholesale=error');
							}
							
							if (error) {
								log(error);
								const selectors13 = allCheckoutSelectors.split(',');
									const cleanSelectors13 = selectors13.map(sel => sel.trim()).filter(Boolean);
									document.querySelectorAll(cleanSelectors13).forEach(element => {
										element.classList.remove('checkout-disabled');
										element.removeAttribute('disabled');
										element.style.pointerEvents = 'auto';
										element.style.cursor = 'pointer';
								});
								return WS.redirectToURL('/checkout?wholesale=error');
							} else {
								if (typeof WS.callback === 'function') {
									WS.callback(response);
								}
								
								let redirectUrl = response.checkout_url;
								let concate_parameter = '/?';
								if (redirectUrl.indexOf('/?') > -1) { concate_parameter = '&'; }
								
								try {
									if (Shopify.locale !== '' && typeof response.discount_code === 'undefined') {
										redirectUrl = redirectUrl + concate_parameter + 'locale=' + Shopify.locale;
									} else if (Shopify.locale !== '' && typeof response.discount_code !== 'undefined') {
										redirectUrl = redirectUrl.replace('?discount=', '?locale=' + Shopify.locale + '&discount=');
									}
								} catch (er) { console.warn(er); }
								
								try {
									if (WS.customer.id === null && window.ZapietCheckoutEnabled && typeof ZapietWidgetConfig !== 'undefined' && Object.keys(ZapietWidgetConfig).length !== 0) {
										const checkout_params = Zapiet.Widget.getCheckoutParams();
										const searchParams = new URLSearchParams(checkout_params).toString();
										if (redirectUrl.indexOf('/?') === -1) {
											redirectUrl += '/?';
										} else if (redirectUrl.slice(-1) !== '&') {
											redirectUrl += '&';
										}
										redirectUrl += searchParams;
									}
								} catch (err) { console.warn(err); }

								if (redirectUrl.indexOf('/?') > -1) { concate_parameter = '&'; }
								
								if (response && redirectUrl) {
									try {
										if (response.draft_order_info) {
											redirectUrl = redirectUrl + concate_parameter + 'step=contact_information';
										}
									} catch (e) { console.warn(e); }
									
									try {
										const urlParts = redirectUrl.split('//');
										if (urlParts.length > 1) {
											const domainPath = urlParts[1];
											const domain = domainPath.split('/')[0];
											redirectUrl = redirectUrl.replace(domain, window.location.hostname);
										}
									} catch (e) { console.warn(e); }

									return WS.redirectToURL(redirectUrl);
								} else {
									const selectors13 = allCheckoutSelectors.split(',');
										const cleanSelectors13 = selectors13.map(sel => sel.trim()).filter(Boolean);
										document.querySelectorAll(cleanSelectors13).forEach(element => {
											element.classList.remove('checkout-disabled');
											element.removeAttribute('disabled');
											element.style.pointerEvents = 'auto';
											element.style.cursor = 'pointer';
									});
									return WS.redirectToURL('/checkout?wholesale=error');
								}
							}
						});
					}

					if (WSAIO.subscription_selector !== 'false' && WSAIO.subscription_selector !== '') {
						let isAllow = true;
						try {
							const shouldStop = cart.items.some(_item => {
								let subscriptionValue;

								if (WSAIO.subscription_selector.indexOf(',') === -1) {
									// Single selector case
									subscriptionValue = _item[WSAIO.subscription_selector];
									if (subscriptionValue != null) { 
										isAllow = false;
										WS.redirectToURL('/checkout');
										return true; 
									}
								} else {
									const [selct1, selct2] = WSAIO.subscription_selector.split(',');
									const _item1 = _item[selct1];
									
									if (_item1 && _item1[selct2] != null) { 
										isAllow = false;
										WS.redirectToURL('/checkout');
										return true; 
									}
								}
								return false; 
							});

							if (!shouldStop) {
								const isDiscountActive = parseFloat(WSAIO.discount_response.wholesale_total_discount) > 0 || WSAIO.discount_response.price_overridden;
								const isShippingActive = typeof WSAIO.discount_response.shipping !== 'undefined' && WSAIO.discount_response.shipping.apply_shipping_charges;

								if (isAllow && (isDiscountActive || isShippingActive)) {
									go_checkout();
								} else {
									return WS.redirectToURL('/checkout');
								}
							}
						} catch (eee) { log(eee); }
					} else {
						const isDiscountActive = parseFloat(WSAIO.discount_response.wholesale_total_discount) > 0 || WSAIO.discount_response.price_overridden;
						const isShippingActive = typeof WSAIO.discount_response.shipping !== 'undefined' && WSAIO.discount_response.shipping.apply_shipping_charges;
						
						if (isDiscountActive || isShippingActive) {
							go_checkout();
						} else {
							return WS.redirectToURL('/checkout');
						}
					}
				}
				WS.fetchCart(checkSubscriptionAndProceed);
    }
	};
	WSAIO.getDiscountCode = function (callback) {
	  if (WSAIO["debugger"]) {
		debugger;
	  }
	  WSAIO.fetchCart(function (error, cart) {
		if (error) {
		  return log(error);
		}
		var note_attr = [];
		var dcreqdata = {
		  note_attributes: note_attr,
		  cart: cart,
		  tags: "wsaio-app",
		  note: document.querySelector('[name="note"]').value,
		  shopInfo: WSAIO.shopInfo,
		  customer: WSAIO.customer,
		  user_mode: WSAIO.user_mode,
		  currency: WSAIO.shopInfo.currency,
		  custom_line_items: [],
		  discount_code_application: WSAIO.DiscountCode.application,
		  products_with_collections: (WSAIO.cart_relevent_collectionID() || [])
		};
		if (WS.variant_sku_are_same) {
		  dcreqdata["variant_sku_are_same"] = WS.variant_sku_are_same;
		}
		if (WS.coupon_expires_after_hours) {
		  dcreqdata["coupon_expires_after_hours"] = WS.coupon_expires_after_hours;
		}
		if (WS.auto_delete_api) {
		  if (localStorage.getItem("draft_order_info") != null) {
			try {
			  dcreqdata["prev_draft_order_info"] = JSON.parse(localStorage.getItem("draft_order_info"));
			} catch (e) {
			  log(e)
			}
		  }
		  if (localStorage.getItem("price_rule_info") != null) {
			try {
			  dcreqdata["prev_price_rule_info"] = JSON.parse(localStorage.getItem("price_rule_info"));
			} catch (e) {
			  log(e)
			}
		  }
		}
		if (WS.ccr) {
		  dcreqdata["ccr"] = WS.ccr;
		}
		WSAIO.checkoutRequest(dcreqdata, callback);
	  });
	};
  
    WSAIO.replaceCheckout = function(val){
      // Your existing element data
        const elementData = {
          attributes: [
            '[data-confirm="ck_lumise"]',
            '[name="icartCheckout"]',
            '[data-ocu-checkout="true"]'
          ],
          classes: [
            'js_add_ld',
            'rebuy-cart__checkout-button',
            'mu-custom-btn',
            'mu-checkout-button',
            'amp-cart__footer-checkout-button',
            'mdc-ripple-surface',
            'ymq-cart-app-checkout-button',
            'upcart-checkout-button',
					    'hs-checkout-purchase'
          ],
          id: [
            'mu-checkout-button'
          ]
        };

			function isInvalidAttribute(attributeName) {
				// Define patterns for invalid or framework-specific attributes
				const invalidPatterns = [
					/^@/,                // Attributes starting with "@" (Vue.js)
					/^v-on:/,            // Vue.js event bindings like "v-on:click"
					/^ng-/,              // AngularJS attributes like "ng-click"
					/^data-v-/,          // Vue.js scoped data attributes like "data-v-xxxx"
					/^on\w+$/,           // Standard HTML event handlers like "onclick", "onmouseover"
					/^.*_.*$/,            // Attributes that contain underscores (you can refine this)
				];
				return invalidPatterns.some(pattern => pattern.test(attributeName));
			}

		// Find all the checkout buttons based on the selector
			const elements = document.querySelectorAll(WSAIO.checkout_selector);
        const matchResults = [];
			// Iterate through each element to check for matches
			elements.forEach(element => {
				if (element.tagName.toLowerCase() === 'meta') {
					return; // Skip this element
				}
				const elementClasses = element.className.split(' ');
			const elementAttributes = Array.from(element.attributes).map(attr => ({
				name: attr.name,
				value: attr.value
			}));
				const elementId = element.id || '';

				const classMatch = elementClasses.some(cls => elementData.classes.includes(cls));
				const attributeMatch = elementAttributes.some(attr => {
                return elementData.attributes.some(elemAttr => {
					const [selectorName, selectorValue] = elemAttr.match(/\[([^\]]+)=["']([^"']+)["']\]/).slice(1);
					return attr.name === selectorName && attr.value === selectorValue;
                });
            });
				const idMatch = elementData.id.includes(elementId);

			// Store the result of matching criteria
            matchResults.push({
				element,
                classMatch,
                attributeMatch,
                idMatch
            });
        });

			// Update the subtotal button(s)
                const btn_subtotal = document.querySelectorAll('.waio_btn_subtotal');
                btn_subtotal.forEach(bt => {
			       bt.textContent = WS.formatMoney(Number(val), WS.shopInfo.money_format);
                });
				

            // Function to process each result and return a Promise
            function processResult(result) {
                return new Promise((resolve, reject) => {
			if (result.classMatch || result.attributeMatch || result.idMatch) {
					// Get the parent element of the matching element
					const parent = result.element.parentNode;

					if (parent) {
						// Create a new element of the same type as the original one
						const newElement = document.createElement(result.element.tagName.toLowerCase());

						// Copy valid attributes from the original element to the new one
						Array.from(result.element.attributes).forEach(attr => {
							if (!isInvalidAttribute(attr.name)) {
								newElement.setAttribute(attr.name, attr.value);
					}
				});

						// Add content to the new element (for example, a span with checkout and subtotal)
						newElement.innerHTML = '<span>Checkout </span><span style="padding-left: 8px;display:none;" class="waio_btn_subtotal"> - ' +
					WS.formatMoney(Number(val), WS.shopInfo.money_format) + '</span>';

                            // Replace the original element with the new one
						parent.replaceChild(newElement, result.element);
                        }
                    }
                    resolve();  // Resolve the Promise once processing is done
                });
            }
                      
            // Process all results asynchronously
            const promises = matchResults.map(result => processResult(result));

            // Once all processing is done, call the checkout event listener functions
            Promise.all(promises).then(() => {
						WSAIO.run_checkout();
				WSAIO.checkoutEventListner();
        });

    }
  
	WSAIO.preloadCheckout = function () {
	  if (WSAIO.debugger) debugger;
	  if (WSAIO.isWholesaleCustomer() === false) {
		if (typeof callback === "function") {
		  return callback({
			error: "Invalid customer"
		  });
		} else {
		  return "Invalid customer";
		}
	  }
	  window.cart_data = WSAIO.cart_object;
	  var cart = WSAIO.cart_object;
	  var preqdata = {
		cart: cart,
		shopInfo: WS.shopInfo,
		customer: WS.customer,
		user_mode: WS.user_mode,
		discount_code_application: WSAIO.DiscountCode.application,
		products_with_collections: (WSAIO.cart_relevent_collectionID() || []),
		missing_products_with_collections:(WSAIO.check_missing_collection_ids() || [])
	  };
	  if (WS.variant_sku_are_same) {
		preqdata["variant_sku_are_same"] = WS.variant_sku_are_same;
	  }
	  if(typeof WSAIO.wholesale_app_tags != 'undefined' && WSAIO.wholesale_app_tags.indexOf('all') > -1){
        preqdata["fields"] = 'all';
      }
	  if (WS.auto_delete_api) {
		if (localStorage.getItem("draft_order_info") != null) {
		  try {
			preqdata["prev_draft_order_info"] = JSON.parse(localStorage.getItem("draft_order_info"));
		  } catch (e) {
			log(e)
		  }
		}
		if (localStorage.getItem("price_rule_info") != null) {
		  try {
			preqdata["prev_price_rule_info"] = JSON.parse(localStorage.getItem("price_rule_info"));
		  } catch (e) {
			log(e)
		  }
		}
	  }
	  WS.preCheckoutRequest(preqdata, function (error, response) {
		if (error) {
		  log(error);
		} else {
		  if (typeof WS.callback === 'function') {
			WS.callback(response);
		  }
		  WS.discount_response=response;
		  try{ 
			if(typeof WSAIO.pre_response != 'undefined' && typeof WSAIO.pre_response === 'function'){
			  WSAIO.pre_response(response);
			}
		  }catch(e){}
		  serverLogging(response);
		}
	  });
	};
	WSAIO.preCheckout = function () {
		const elementsToRemove = '.wsaio_coupon_box, .wsaio_coupon_link, .wsaio--Cart_ld__Message, .wsaio_loader_checkout';
		document.querySelectorAll(elementsToRemove).forEach(element => {
			element.remove();
		});
		const selectorsToHide = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector + ',' + WSAIO.netTerm_checkout_selector;
		document.querySelectorAll(selectorsToHide).forEach(element => {
			element.classList.add('wsaio_hideCheckout');
		});
		const selectorsForLoader = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector;
		const loaderHTML = '<div class="wsaio_loader_checkout wsaio_loader"> <div class="loading-spinner"></div> </div>';
		document.querySelectorAll(selectorsForLoader).forEach(element => {
			element.insertAdjacentHTML('afterend', loaderHTML);
		});
	  window.preDiscountData = [];
	  if (WSAIO.debugger) debugger;
	  if (WSAIO.isWholesaleCustomer() === false) {
		if(typeof WSAIO.run_checkout != 'undefined'){
            WSAIO.run_checkout();
        }
		if (typeof callback === "function") {
		  return callback({
			error: "Invalid customer"
		  });
		} else {
		  return "Invalid customer";
		}
	  }
	  WS.fetchCart(function (error, cart) {
		if (error) return isError(error);
		else {
			window.free_theme_cart_object = cart;
            if(typeof WSAIO.free_theme != 'undefined' && WSAIO.free_theme){
			if(document.querySelector('cart-drawer.active') == null){
				document.querySelectorAll('cart-items '+WSAIO.cart_items_each_selector).forEach(function(e,r){
					if(free_theme_cart_object.items[r] != undefined && e.querySelector('[name="updates[]"]') != null && parseInt(e.querySelector('[name="updates[]"]').value) != free_theme_cart_object.items[r].quantity){
						free_theme_cart_object.items[r].quantity = e.querySelector('[name="updates[]"]').value;
					}
				})
			}else{
				document.querySelectorAll('cart-drawer.active '+WSAIO.cart_items_each_selector).forEach(function(e,r){
					if(free_theme_cart_object.items[r] != undefined && e.querySelector('[name="updates[]"]') != null && parseInt(e.querySelector('[name="updates[]"]').value) != free_theme_cart_object.items[r].quantity){
						free_theme_cart_object.items[r].quantity = e.querySelector('[name="updates[]"]').value;
					}
				})
			}
			}
			if(typeof free_theme_cart_object != 'undefined' && typeof WSAIO.free_theme != 'undefined' && WSAIO.free_theme){
                window.cart_data = free_theme_cart_object;
			}else{
			window.cart_data = cart;
			}
				
		  var preqdata = {
			cart: cart_data,
			shopInfo: WS.shopInfo,
			customer: WS.customer,
			user_mode: WS.user_mode,
			discount_code_application: WSAIO.DiscountCode.application,
			products_with_collections: (WSAIO.cart_relevent_collectionID() || []),
			missing_products_with_collections:(WSAIO.check_missing_collection_ids() || [])
		  };
		  if (WS.variant_sku_are_same) {
			preqdata["variant_sku_are_same"] = WS.variant_sku_are_same;
		  }
		  if(typeof WSAIO.wholesale_app_tags != 'undefined' && WSAIO.wholesale_app_tags.indexOf('all') > -1){
            preqdata["fields"] = 'all';
          }
		  if (WS.auto_delete_api) {
			if (localStorage.getItem("draft_order_info") != null) {
			  try {
				preqdata["prev_draft_order_info"] = JSON.parse(localStorage.getItem("draft_order_info"));
			  } catch (e) {
				log(e)
			  }
			}
			if (localStorage.getItem("price_rule_info") != null) {
			  try {
				preqdata["prev_price_rule_info"] = JSON.parse(localStorage.getItem("price_rule_info"));
			  } catch (e) {
				log(e)
			  }
			}
		  }
		  WS.preCheckoutRequest(preqdata, function (error, response) {
			if (error) {
				log(error);
				if(typeof WSAIO.cartQuantityControllers != 'undefined' && typeof WSAIO.checkout_restriction != 'undefined'){ WSAIO.checkout_restriction(); WSAIO.cartQuantityControllers([],function(e){setTimeout(function(){WSAIO.run_checkout()},1000)});}else{WSAIO.run_checkout()}
			  } else {
			  if (typeof WS.callback === 'function') {
				WS.callback(response);
			  }
			  WS.discount_response=response;
			  WS.preCheckoutResponse(response);
			  if(typeof WSAIO.cartQuantityControllers != 'undefined' && typeof WSAIO.checkout_restriction != 'undefined'){ WSAIO.checkout_restriction(); WSAIO.cartQuantityControllers([],function(e){setTimeout(function(){WSAIO.run_checkout()},1000)});}else{WSAIO.run_checkout()}
			  serverLogging(response);
			}
		  });
		}
	  });
	};
  
	WSAIO.preCheckout_without_fetch = function () {
	  window.preDiscountData = [];
	  if (WSAIO.debugger) debugger;
	  if (WSAIO.isWholesaleCustomer() === false) {
		if(typeof WSAIO.run_checkout != 'undefined'){
            WSAIO.run_checkout();
        }
		if (typeof callback === "function") {
		  return callback({
			error: "Invalid customer"
		  });
		} else {
		  return "Invalid customer";
		}
	  }
	
		window.free_theme_cart_object = cart_data;
		if(document.querySelector('cart-drawer.active') == null){
			document.querySelectorAll('cart-items '+WSAIO.cart_items_each_selector).forEach(function(e,r){
				if(e.querySelector('[name="updates[]"]') != null && parseInt(e.querySelector('[name="updates[]"]').value,10) != free_theme_cart_object.items[r].quantity){
					free_theme_cart_object.items[r].quantity = e.querySelector('[name="updates[]"]').value;
				}
			})
		}else{
			document.querySelectorAll('cart-drawer.active '+WSAIO.cart_items_each_selector).forEach(function(e,r){
				if(e.querySelector('[name="updates[]"]') != null && parseInt(e.querySelector('[name="updates[]"]').value,10) != free_theme_cart_object.items[r].quantity){
					free_theme_cart_object.items[r].quantity = e.querySelector('[name="updates[]"]').value;
				}
			})
		}
		if(typeof free_theme_cart_object != 'undefined'){
			window.cart_data = free_theme_cart_object;
		}else{
			window.cart_data = cart_data;
		}
			
		  var preqdata = {
			cart: cart_data,
			shopInfo: WS.shopInfo,
			customer: WS.customer,
			user_mode: WS.user_mode,
			discount_code_application: WSAIO.DiscountCode.application,
			products_with_collections: (WSAIO.cart_relevent_collectionID() || []),
			missing_products_with_collections:(WSAIO.check_missing_collection_ids() || [])
		  };
		  if (WS.variant_sku_are_same) {
			preqdata["variant_sku_are_same"] = WS.variant_sku_are_same;
		  }
		  if(typeof WSAIO.wholesale_app_tags != 'undefined' && WSAIO.wholesale_app_tags.indexOf('all') > -1){
            preqdata["fields"] = 'all';
          }
		  if (WS.auto_delete_api) {
			if (localStorage.getItem("draft_order_info") != null) {
			  try {
				preqdata["prev_draft_order_info"] = JSON.parse(localStorage.getItem("draft_order_info"));
			  } catch (e) {
				log(e)
			  }
			}
			if (localStorage.getItem("price_rule_info") != null) {
			  try {
				preqdata["prev_price_rule_info"] = JSON.parse(localStorage.getItem("price_rule_info"));
			  } catch (e) {
				log(e)
			  }
			}
		  }
		  WS.preCheckoutRequest(preqdata, function (error, response) {
			if (error) {
				log(error);
				if(typeof WSAIO.cartQuantityControllers != 'undefined' && typeof WSAIO.checkout_restriction != 'undefined'){ WSAIO.checkout_restriction(); WSAIO.cartQuantityControllers([],function(e){setTimeout(function(){WSAIO.run_checkout()},1000)});}else{WSAIO.run_checkout()}
			  } else {
			  if (typeof WS.callback === 'function') {
				WS.callback(response);
			  }
			    WS.fetchCart(function (error, cart) {window.cart_data=cart;WS.preCheckoutResponse(response);})
			  WS.discount_response=response;
			  WS.preCheckoutResponse(response);
			  if(typeof WSAIO.cartQuantityControllers != 'undefined' && typeof WSAIO.checkout_restriction != 'undefined'){ WSAIO.checkout_restriction(); WSAIO.cartQuantityControllers([],function(e){setTimeout(function(){WSAIO.run_checkout()},1000)});}else{WSAIO.run_checkout()}
			  serverLogging(response);
			}
		  });
		
	};
    window.only_orderLimit = window.only_orderLimit || false;
	if(window.only_orderLimit != undefined && window.only_orderLimit == true){
		WSAIO.preCheckout = function (){
			if(typeof WSAIO.run_checkout != 'undefined'){
			  WSAIO.showCheckoutLoader()
			   fetch(WSAIO.local_param + 'cart.json', {
                      method: 'GET',
                      credentials: 'same-origin'
                  })
                  .then(response => response.json())
                  .then(e => {
				window.cart_data = e;
				  try {
				  "undefined" === typeof window.waioMOC && (window.waioMOC = {});
				  "undefined" === typeof waioMOC.cart && (waioMOC.cart = {});
				  try {                                       
					waioMOC.cart["item_count"] = e.item_count;
					waioMOC.cart["original_total_price"] = e.original_total_price;
					WSAIO.order_control()
					if(typeof WSAIO.cartQuantityControllers != 'undefined' && typeof WSAIO.checkout_restriction != 'undefined'){ WSAIO.checkout_restriction(); WSAIO.cartQuantityControllers([],function(e){setTimeout(function(){WSAIO.run_checkout()},500)});}else{WSAIO.run_checkout()}
				  } catch (e) {}
				  } catch (e) {}
			  })
			}
		  };
	}
	WSAIO.preCheckoutResponse = function (response) {  
	  window.preDiscountData = response;
	  try{ 
		if(typeof WSAIO.pre_response != 'undefined' && typeof WSAIO.pre_response === 'function'){
		  WSAIO.pre_response(response)
	    }
	  }catch(e){}
	  if (WSAIO.debugger) debugger;
		const fieldDivs = document.querySelectorAll(".po_field_div");
		if (fieldDivs.length > 0) {
			fieldDivs.forEach(element => {
				element.remove();
			});
		}
      try{
        if(WSAIO.PO_field_enable){
            if(WSAIO.PO_field_selector == ''){
                if( WS.discount_code_field_selector == ''){
                    WSAIO.PO_field_selector = WSAIO.subtotal_selector.split(':')[0];
                }else{
                    WSAIO.PO_field_selector = WS.discount_code_field_selector.split(':')[0];
                }
            }
		
			document.querySelectorAll('.Net_PO_field').forEach(element => {
				element.style.display = 'block'; 
			});
			const htmlToInsert = '<div class="po_field_div" style="max-width: 330px; width: 100%; margin-left: auto;padding: 10px 0px;"> <label style="text-align: left;"> Purchase Order (PO) Number </label> <input style="width: -webkit-fill-available;height: 40px;" type="text" class="po_field"/> </div> ';
            document.querySelectorAll(WSAIO.PO_field_selector).forEach(targetElement => {
				targetElement.insertAdjacentHTML('beforebegin', htmlToInsert);
			});
		}
      }catch(e){}
	  var i = 0;
	  if (response && response.final_discounted_products) {
		try {
		  for (i = 0; i < response.final_discounted_products.length; i++) {
			try {
			  WSAIO.all_discount_tags.push(response.final_discounted_products[i].appRule.applied_included_tag);
			} catch (e) {}
		  }
		} catch (e) {}
	  }
	  WSAIO.shipping_message_applied = false;
	  var module_involve = '';
	  if (response && response.shipping) {
		WS.applied_shipping = response.shipping;
		if (WS.applied_shipping.apply_shipping_charges) { //check if shipping applied
			WSAIO.shipping_message_applied = true;
			module_involve = 'shipping';
		  WS.alterHTML(WS.shipping_message_html.replace('%message%', WS.applied_shipping.final_ship_rule.message), WS.shipping_message_selector);
		}
	  }
	  if (response) {
		if(response.wholesale_total_discount > 0 || WSAIO.discount_response.price_overridden){
            module_involve = module_involve == '' ? 'discount' : 'discount_'+module_involve;
        }
        if(module_involve == '') module_involve = 'No';
        const attributes = window.cart_data.attributes;
        var key_noExist = true;
        if (attributes && attributes.WSAIO_APP && (attributes.WSAIO_APP === module_involve)) {
          key_noExist = false;
        }
		if(module_involve != '' && WSAIO.general_settings.discount_method != 'coupon_code' && key_noExist  && typeof WSAIO.enable_trackingNote != 'undefined' && WSAIO.enable_trackingNote){
          fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json', 
              },
              body: JSON.stringify({
                  attributes: {
                      WSAIO_APP: module_involve
                  }
              })
          })
        }
        if(typeof WSAIO.discount_response != 'undefined' && typeof WSAIO.discount_response.wholesale_total_discount != 'undefined' && parseFloat(WSAIO.discount_response.wholesale_total_discount) == 0 && ( typeof  WSAIO.discount_response.price_overridden != 'undefined' && !WSAIO.discount_response.price_overridden)){
            WSAIO.exclude_VAT = 0;
        }
		const spinners = document.querySelectorAll('.cart-item__totals .loading__spinner');
		const cart_wrapper = document.querySelector('cart-items-component');
		if ((spinners.length == 0 && cart_wrapper == null) || typeof WSAIO.free_theme == 'undefined') WS.setCartSubtotal(response.original_total_price, response.checkout_price_from_total_price);
		if (response.line_items) {
          const customIdPrice = response.line_items.map(item => `${item.variant_id}_${item.wholesale.discount_amount}_${item.quantity}_${item.wholesale.discount_type}`).join(',');
          WSAIO.custom_id_price = customIdPrice;
		  if(WSAIO.general_settings.discount_method == 'coupon_code'){WSAIO.check_lineItem_properties();}
		   if ((spinners.length == 0 && cart_wrapper == null) || typeof WSAIO.free_theme == 'undefined'){
	                 WS.setCartItemsPrice(response.line_items, response.checkout_price_from_total_price);
			     	WS.setCartSubtotal(response.original_total_price, response.checkout_price_from_total_price);
		   }else{
                var intr = setInterval(function(){
				const spinners = document.querySelectorAll(WSAIO.cart_items_each_selector);
				const allHidden = [...spinners].every(e => {
					const spinner = e.querySelector('.cart-item__totals .loading__spinner');
					return spinner && spinner.classList.contains('hidden');
				});
				const cartItemsEnabled = cart_wrapper && !cart_wrapper.classList.contains('cart-items-disabled');
				if (allHidden || cartItemsEnabled) {
					WS.setCartItemsPrice(response.line_items, response.checkout_price_from_total_price);
			     	WS.setCartSubtotal(response.original_total_price, response.checkout_price_from_total_price);
					clearInterval(intr)
				}
			})
		  }
          WSAIO.replaceCheckout(response.checkout_price_from_total_price);
		}
		if (Number(response.wholesale_total_discount) > 0) {
		  var total_saving = WS.cart_bulk_saving_html
		  .replace("%saved_amount%", WS.formatMoney(response.wholesale_total_discount));
		  WS.alterHTML(total_saving, WS.cart_bulk_saving_selector);
		}
	  }
	  if (response.original_total_price) {
		WS.cart_total = response.original_total_price;
		WS.cart_discounted_total = response.checkout_price_from_total_price;
	  }
	  if (response && response.cart_level_discount) {
		if (Number(response.cart_level_discount.cart_discount_amount) > 0) {
		  WSAIO.cart_level = response.cart_level_discount;
		  var cld_msg = WS.cart_ld_html
		  .replace(new RegExp("%discount%", "gi"), (WS.formatMoney(response.cart_level_discount.cart_discount_amount) || ""))
		  .replace(new RegExp("%discount%", "gi"), "");
			document.querySelectorAll('.wsaio--Cart_ld__Message').forEach(element => {
				element.remove();
			});
          if(WS.cart_ld_selector == ''){
			    const selectors = WSAIO.checkout_message_selector.split(',');
				const cleanSelectors = selectors.map(sel => sel.trim()).filter(Boolean);
                document.querySelectorAll('.wsaioserver_errordiv').forEach(function(e){e.remove();});
				cleanSelectors.forEach(target => {
					const targetElements = document.querySelectorAll(target);
					targetElements.forEach(targetele => {
						if(typeof cld_msg == 'string'){
								const container = document.createElement('div');
								container.classList.add('wsaioserver_errordiv');
								container.innerHTML = cld_msg;
								if(container.innerHTML.trim() !== ""){
								targetele.insertAdjacentElement('afterend', container);
			}
          }else{
							targetele.insertAdjacentElement('afterend', cld_msg.cloneNode(true));
			}
					})
				})
          }else{
            WS.alterHTML(cld_msg, WS.cart_ld_selector);
          }
		}
	  }
	};
  
	WSAIO.redirectToURL = function (url) {
	  if (WSAIO.debugger) debugger;
	  if (url) {
		window.location.href = url;
	  } else {
		isError("Redirect URL was not found!");
	  }
	};
  
	WSAIO.checkoutRequest = function (data, callback) {
		try{ 
			/* send presentment_currency if enabled */
            if(WSAIO.selectedCurrency() != '' && WSAIO.selectedCurrency() !== 'undefined'){
				var presentment_currency_rate = 0;
                if(typeof Shopify.currency !== "undefined" && (WSAIO.selectedCurrency() == Shopify.currency.active)){
                    presentment_currency_rate = parseFloat(Shopify.currency.rate) || 1;
                }else{
                    presentment_currency_rate =  parseFloat(window.Currency.rates[WSAIO.shopInfo.currency]/window.Currency.rates[WSAIO.selectedCurrency()]) || 1;			
                }	
                /* Append rate in payload to use in server */
					data['presentment_currency'] = {
					code: WSAIO.selectedCurrency(),
					rate: presentment_currency_rate
					};				
		   }
		   else{
				if(typeof Shopify !== "undefined" && typeof Shopify.currency !== "undefined"){
					var presentment_currency_rate = parseFloat(Shopify.currency.rate) || 1;
						/* Append rate in payload to use in server */
						data['presentment_currency'] = {
						code: Shopify.currency.active,
						rate: presentment_currency_rate
						};
				}
			}
			if(typeof Shopify !== "undefined" && typeof Shopify.country !== "undefined"){
                /* Append country in payload to use in server */
                data['presentment_country'] = Shopify.country;
            }

            if(typeof WSAIO.tax_settings !== "undefined" && ((typeof WSAIO.auto_vat_enable !== "undefined" && WSAIO.auto_vat_enable))){
                /* Append tax setting in payload to use in server */
				WSAIO.tax_settings.auto_configure_tax_inclusivity = true;
                data['tax_settings'] = WSAIO.tax_settings;
            }
				if((WSAIO.market_selected!= undefined && typeof WSAIO.customer.default_address.country_code != 'undefined' && WSAIO.market_selected != WSAIO.customer.default_address.country_code) && WSAIO.country_currency_code != undefined && typeof WSAIO.Currency.rates[WSAIO.shopInfo.currency] != 'undefined'){
				var rate = 0;
					var customer_currency = WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0];
				if(customer_currency == WSAIO.shopInfo.currency){
					data['presentment_currency'] = {
						code: WSAIO.shopInfo.currency,
						rate: 1
						};
						data['presentment_country'] = WSAIO.customer.default_address.country_code;
				}else{
					   if(WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0] == Shopify.currency.active){
						   rate = Shopify.currency.rate;
					} else{
						 if(WSAIO.shopInfo.currency == 'USD'){
						   conversion_fee = 1.015;
						 }else{
						   conversion_fee = 1.02;
						 }
						  rate = ((WSAIO.Currency.rates[WSAIO.shopInfo.currency]/WSAIO.Currency.rates[customer_currency])*conversion_fee)
					 }
					  data['presentment_currency'] = {
						  code: customer_currency,
						  rate: rate
						  };
						  data['presentment_country'] = WSAIO.customer.default_address.country_code;
				}
				
			}

		}catch(e){console.log('WSAIO currency rates undefined')}
		  WS.ajax({
		type: 'POST',
		url: WS.App.checkoutURL + WS.checkout_version,
		cache: false,
		data: data,
		success: function (result) {
		document.querySelectorAll(WS.checkout_selector).forEach(el => {
		el.disabled = false;
		});
		  try {
			if (result && result.price_rule_info) {
			  try {
				localStorage.setItem("price_rule_info", JSON.stringify(result.price_rule_info))
			  } catch (e) {
				log(e)
			  }
			}
			if (result && result.draft_order_info) {
			  try {
				localStorage.setItem("draft_order_info", JSON.stringify(result.draft_order_info))
			  } catch (e) {
				log(e)
			  }
			}
		  } catch (e) {
			log(e)
		  }
		  if ("function" === typeof callback) {
			callback(null, result);
		  }
		},
		error: function (err) {
		  if ("function" === typeof callback) {
			callback(err, null);
		  }
		}
	  });
	};
  
	WSAIO.preCheckoutRequest = function (data, callback) {
        try{ 
            /* send presentment_currency if enabled */
            if(WSAIO.selectedCurrency() != '' && WSAIO.selectedCurrency() !== 'undefined'){
				var presentment_currency_rate = 0;
                if(typeof Shopify.currency !== "undefined" && (WSAIO.selectedCurrency() == Shopify.currency.active)){
                    presentment_currency_rate = parseFloat(Shopify.currency.rate) || 1;
                }else{
                    presentment_currency_rate =  parseFloat(window.Currency.rates[WSAIO.shopInfo.currency]/window.Currency.rates[WSAIO.selectedCurrency()]) || 1;			
                }	
                /* Append rate in payload to use in server */
					data['presentment_currency'] = {
					code: WSAIO.selectedCurrency(),
					rate: presentment_currency_rate
					};				
		   }
           else{
                if(typeof Shopify !== "undefined" && typeof Shopify.currency !== "undefined"){
                    var presentment_currency_rate = parseFloat(Shopify.currency.rate) || 1;
                        /* Append rate in payload to use in server */
                        data['presentment_currency'] = {
                        code: Shopify.currency.active,
                        rate: presentment_currency_rate
                        };
                }
            }
			if(typeof Shopify !== "undefined" && typeof Shopify.country !== "undefined"){
                /* Append country in payload to use in server */
                data['presentment_country'] = Shopify.country;
            }
            if(typeof WSAIO.tax_settings !== "undefined" && typeof WSAIO.auto_vat_enable != 'undefined' &&  WSAIO.auto_vat_enable){
                /* Append tax setting in payload to use in server */
                WSAIO.tax_settings.auto_configure_tax_inclusivity = true;
                data['tax_settings'] = WSAIO.tax_settings;
            }
				if((WSAIO.market_selected!= undefined && typeof WSAIO.customer.default_address.country_code != 'undefined' && WSAIO.market_selected != WSAIO.customer.default_address.country_code) && WSAIO.country_currency_code != undefined && typeof WSAIO.Currency.rates[WSAIO.shopInfo.currency] != 'undefined'){
				var rate = 0;
					var customer_currency = WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0];
				if(customer_currency == WSAIO.shopInfo.currency){
					data['presentment_currency'] = {
						code: WSAIO.shopInfo.currency,
						rate: 1
						};
						data['presentment_country'] = WSAIO.customer.default_address.country_code;
				}else{
					   if(WSAIO.country_currency_code[WSAIO.customer.default_address.country_code].split('_')[0] == Shopify.currency.active){
						   rate = Shopify.currency.rate;
					} else{
						 if(WSAIO.shopInfo.currency == 'USD'){
						   conversion_fee = 1.015;
						 }else{
						   conversion_fee = 1.02;
						 }
						  rate = ((WSAIO.Currency.rates[WSAIO.shopInfo.currency]/WSAIO.Currency.rates[customer_currency])*conversion_fee)
					 }
					  data['presentment_currency'] = {
						  code: customer_currency,
						  rate: rate
						  };
						  data['presentment_country'] = WSAIO.customer.default_address.country_code;
				}
				
			}
        }catch(e){console.log('WSAIO currency rates undefined')}
        
	  WS.ajax({
		type: 'POST',
		url: WS.App.checkoutURL + WS.checkout_version + '/pre',
		cache: false,
		data: data,
		success: function (result) {
		  log(result);
		  if ("function" === typeof callback) {
			callback(null, result);
		  }
		},
		error: function (err) {
		  if ("function" === typeof callback) {
			callback(err, null);
		  }
		}
	  });
	};
  
	WSAIO.checkoutEventListner = function (params = null) {
		window.ZapietCheckoutEnabled = window.ZapietCheckoutEnabled || false;
		if(WSAIO.isWholesaleCustomer() === false || (window.ZapietCheckoutEnabled === false && typeof ZapietWidgetConfig != 'undefined' && Object.keys(ZapietWidgetConfig).length != 0)){
		return "Invalid customer";
		}
			function handleCheckoutClick(e) {
				const checkoutSelectors = WS.checkout_selector + ',' + WSAIO.duplicate_checkout_selector;
				const clickedElement = e.target.closest(checkoutSelectors);
				if (!clickedElement) return;
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();
				clickedElement.setAttribute("disabled", true); 
				clickedElement.querySelectorAll('[name="discount"], [name="clear_discount"]').forEach(input => {
					input.remove();
				});

				log("Wholesale All In One checkout is working.");
				let allow_checkout = true;
				document.querySelectorAll('.wsaio_delivery_error').forEach(el => el.remove()); 
				
				const deliveryPickupLength = document.querySelectorAll('.wsaio_delivery_pickup').length;
				const checkedDeliveryLength = document.querySelectorAll('[name="wsaio_delivery_method"]:checked').length;
				
				if (
					typeof WSAIO.shipping_pickup_option !== 'undefined' &&
					WSAIO.shipping_pickup_option &&
					deliveryPickupLength > 0 &&
					checkedDeliveryLength === 0
				) {
					allow_checkout = false;
				}
				
				if (allow_checkout) {
					WS.checkout();
				} else {
					const selectors = WSAIO.checkout_message_selector.split(',');
					const cleanSelectors = selectors.map(sel => sel.trim()).filter(Boolean);
                    document.querySelectorAll('.wsaio_deliverydiv').forEach(function(e){e.remove();});
					cleanSelectors.forEach(target => {
						const targetElements = document.querySelectorAll(target);
						targetElements.forEach(targetele => {
								const container = document.createElement('div');
								container.classList.add('wsaio_deliverydiv');
								container.innerHTML = '<span class="wsaio_delivery_error" style="color:red;font-size:14px;">Please Select Delivery Option</span>';
								if(container.innerHTML.trim() !== ""){
								targetele.insertAdjacentElement('beforebegin',container );
					}
							})
					})
				}
			}
			
			const checkoutSelectors = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector;
			const selectors13 = checkoutSelectors.split(',');
			const cleanSelectors13 = selectors13.map(sel => sel.trim()).filter(Boolean);
			document.querySelectorAll(cleanSelectors13).forEach(el => el.removeAttribute("disabled"));
            document.querySelectorAll(cleanSelectors13).forEach(el =>
					el.addEventListener('click', function(e) {
				const matchingElement = e.target.closest(checkoutSelectors);
				if (matchingElement) {
					handleCheckoutClick(e);
				}
			}))
	};
  
	WSAIO.setCartSubtotal = function (items_subtotal_price, checkout_subtotal) {
	  if (WSAIO.debugger) debugger;
	  if (typeof items_subtotal_price === 'undefined' || typeof checkout_subtotal === 'undefined') {
		return;
	  }
	  if (Number(items_subtotal_price) < 0 || Number(checkout_subtotal) < 0) {
		return;
	  }
	  var regular_price = WS.formatMoney(Number(checkout_subtotal), WS.shopInfo.money_format);
	  var compare_at_price = "";
	  if (Number(items_subtotal_price) > Number(checkout_subtotal)) {
		compare_at_price = WS.formatMoney(Number(items_subtotal_price), WS.shopInfo.money_format);
	  }
 
	  try {
		compare_at_price = compare_at_price.replace("$", "$@");
		regular_price = regular_price.replace("$", "$@");
	  } catch (e) {
		log(e)
	  }
  
		// change currency sign forcely based on market
		 regular_price = WSAIO.change_currency_sign(regular_price);
		 compare_at_price = WSAIO.change_currency_sign(compare_at_price);
  
		function show_Additional_Processing_fee(subtotal){
			var fee = 0;
			if(WSAIO.general_settings.additionalFee_value_type == 'fixed'){
				subtotal = subtotal + parseFloat(WSAIO.general_settings.additionalFee_value);
				fee = WSAIO_formatMoney(parseFloat(WSAIO.general_settings.additionalFee_value));
			}else{
				var p = ((parseFloat(WSAIO.general_settings.additionalFee_value)/100)*subtotal).toFixed(2);
				fee = WSAIO_formatMoney(parseFloat(p));
				subtotal = subtotal + parseFloat(p);
			}
			return subtotal;
		}
	  try {
		if (typeof WSAIO.enable_netTerm != 'undefined' && WSAIO.enable_netTerm) {
			if (WSAIO.NetTerm_version > 1 || document.querySelectorAll('.net_address_fields').length === 0) {
				try {
					var net_regular = WS.formatMoney(Number(checkout_subtotal));
					if(WSAIO.general_settings.additionalFee_enabled){
						var subt = show_Additional_Processing_fee(Number(checkout_subtotal));
						net_regular = WS.formatMoney(Number(subt));
					}
				} catch (c) {
					k(c);
				}
				  if(typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO.formatMoney('0').indexOf(Shopify.currency.active) == -1){
					  net_regular = WSAIO.change_currency_sign(net_regular);
					  }
				 const selector = '.net_prices.net--subtotal';
				const htmlContent = '<span class="net_subtotal_value" value="' + Number(checkout_subtotal) + '">' + net_regular + '</span>';
				document.querySelectorAll(selector).forEach(element => {
					element.innerHTML = htmlContent;
				});
				if (document.querySelectorAll('.NetTerm_div .net_cartLevel_div').length === 0 && Object.keys(WSAIO.cart_level).length === 0) {
						const htmlContent = `<div class="net_cartLevel_div" style="display: block !important;">
							<p>Order discount</p>
							<span style="display: flex ; width: 100% !important; margin: auto !important;">
								<span style="display: flex ; align-items: center;">
									<svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 14 14" focusable="false" aria-hidden="true" class="a8x1wu10 a8x1wuz _1fragem1y _1fragemof _1fragemkk _1fragemka _1fragemnm" style=" width: 15px; height: 13px; display: inline-block; fill: none; stroke: rgb(102, 102, 102); ">
										<path stroke-linecap="round" d="M7.284 1.402h4.964a.35.35 0 0 1 .35.35v4.964a.7.7 0 0 1-.205.495L7.49 12.115a.7.7 0 0 1-.99 0L1.885 7.5a.7.7 0 0 1 0-.99L6.79 1.607a.7.7 0 0 1 .495-.205Z" style=" !;!i;!; "></path>
										<circle cx="9.1" cy="4.9" r="0.7"></circle>
										<path stroke-linecap="round" stroke-linejoin="round" d="M9.102 4.897h-.005v.005h.005z"></path>
									</svg>
									<p style="padding-left: 3px; text-transform: uppercase;color: hsl(0, 0%, 40%) !important;">
										${WSAIO.cart_level.message} <span> </span>
									</p>
								</span>
								<p class="net_prices">- ${WS.formatMoney(Number(window.preDiscountData.cart_level_discount.cart_discount_amount))}</p>
							</span>
						</div>`;

						document.querySelectorAll('.NetTerm_div .applied_coupon_line').forEach(targetElement => {
							targetElement.insertAdjacentHTML('afterend', htmlContent);
						});
				}
				if (document.querySelectorAll('.net_mobile_div .net_cartLevel_div').length === 0 && Object.keys(WSAIO.cart_level).length > 0) {
					const htmlContent = `<div class="net_cartLevel_div" style="display: block !important;">
						<p>Order discount</p>
						<span style="display: flex ; width: 100% !important; margin: auto !important;">
							<span style="display: flex ; align-items: center;">
								<svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 14 14" focusable="false" aria-hidden="true" class="a8x1wu10 a8x1wuz _1fragem1y _1fragemof _1fragemkk _1fragemka _1fragemnm" style=" width: 15px; height: 13px; display: inline-block; fill: none; stroke: rgb(102, 102, 102); ">
									<path stroke-linecap="round" d="M7.284 1.402h4.964a.35.35 0 0 1 .35.35v4.964a.7.7 0 0 1-.205.495L7.49 12.115a.7.7 0 0 1-.99 0L1.885 7.5a.7.7 0 0 1 0-.99L6.79 1.607a.7.7 0 0 1 .495-.205Z" style=" !;!i;!; "></path>
									<circle cx="9.1" cy="4.9" r="0.7"></circle>
									<path stroke-linecap="round" stroke-linejoin="round" d="M9.102 4.897h-.005v.005h.005z"></path>
								</svg>
								<p style="padding-left: 3px; text-transform: uppercase;color: hsl(0, 0%, 40%) !important;">
									${WSAIO.cart_level.message} <span> </span>
								</p>
							</span>
							<p class="net_prices">- ${WS.formatMoney(Number(window.preDiscountData.cart_level_discount.cart_discount_amount))}</p>
						</span>
					</div>`;

					document.querySelectorAll('.net_mobile_div .applied_coupon_line').forEach(targetElement => {
						targetElement.insertAdjacentHTML('afterend', htmlContent);
					});
				}
				if(window.preDiscountData.isCouponCodeFieldEnabled != undefined && window.preDiscountData.isCouponCodeFieldEnabled){
					var coupon_field = document.querySelectorAll('.new_discount-code-forms');
					for (var i = 0; i < coupon_field.length; i++) {
						coupon_field[i].style.display = 'block';
					}
				}
			} else {
				try {
					var net_regulars = WS.formatMoney(Number(checkout_subtotal) * 100, WS.shopInfo.money_format);
					var net_regular = net_regulars.replace(/@/g, "");
					  var net_value = net_regular;
					  if(WSAIO.general_settings.additionalFee_enabled){
						var subt = show_Additional_Processing_fee(Number(checkout_subtotal) * 100);
						net_regular = WS.formatMoney(Number(subt) * 100, WS.shopInfo.money_format);
						net_value = Number(subt);
					}
				} catch (c) {
					console.log(c);
				}
				  if(typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO.formatMoney('0').indexOf(Shopify.currency.active) == -1){
					  net_regular = WSAIO.change_currency_sign(net_regular);
					  }
				const selector = '.net_prices.net--subtotal';
				const htmlContent = '<span class="net_subtotal_value" value="' + net_value + '" >' + net_regular + '</span>';
				document.querySelectorAll(selector).forEach(element => {
					element.innerHTML = htmlContent;
				});
			}
		}
	} catch (w) { }

    var html = WS.cart_subtotal_price_html;
	  if (!WS.general_settings.compare_at_price) {
		compare_at_price = "";
        html = WSAIO.remove_comparePrice(html);
	  }
	  if(html.indexOf('%compare_at_price%') == -1){
        html = '<del class="money" style="padding-right:10px;">%compare_at_price%</del>' +html ; 
       }  
	   
	   if(typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO.formatMoney('0').indexOf(Shopify.currency.active) == -1){
		  regular_price = WSAIO.price_with_unit(regular_price)
            if(compare_at_price != ""){
				  compare_at_price = WSAIO.price_with_unit(compare_at_price)
            }
      } 
      if(compare_at_price == ''){
        html = WSAIO.remove_comparePrice(html);
      }

	  html = html.replace("%regular_price%", regular_price)
	  .replace("%compare_at_price%", compare_at_price);
	  try {
		html = html.replace(/@/g, '');
	  } catch (e) {
		log(e);
	}
    document.querySelectorAll('.wsaio_delivery_pickup, .wsaio_delivery_error').forEach(element => {
		element.remove();
	});
	if(typeof WSAIO.shipping_pickup_option != 'undefined'
		 && WSAIO.shipping_pickup_option
		 && WSAIO.general_settings.discount_method == 'draft_order_if_eligible'
		 && WSAIO.shipping_message_applied
		 && (WSAIO.net_disable_default_checkout != 'undefined' && !WSAIO.net_disable_default_checkout)
	){
		document.querySelectorAll('.wsaio_delivery_pickup, .wsaio_delivery_error').forEach(element => {
			element.remove();
		});
		const deliveryFormHTML = `
		<form class="wsaio_delivery_pickup" style="display: block; text-align: left;">
			<h3 style="margin-bottom: 6px;">Select delivery method:</h3>
			<input type="radio" name="wsaio_delivery_method" id="wsaio_Shipping" value="shipping">
			<label for="wsaio_Shipping" style="cursor: pointer;">Shipping</label><br>
			<input type="radio" name="wsaio_delivery_method" id="wsaio_pickup" value="pickup">
			<label for="wsaio_pickup" style="cursor: pointer;">Pickup</label><br>
		</form>`;
		const selectors = WSAIO.checkout_message_selector.split(',');
		const cleanSelectors = selectors.map(sel => sel.trim()).filter(Boolean);
        document.querySelectorAll('.wsaio_deliverydiv').forEach(function(e){e.remove();});
		cleanSelectors.forEach(target => {
			const targetElements = document.querySelectorAll(target);
			targetElements.forEach(targetele => {
					if(typeof deliveryFormHTML == 'string'){
							const container = document.createElement('div');
							container.innerHTML = deliveryFormHTML;
							if(container.innerHTML.trim() !== ""){
							targetele.insertAdjacentElement('beforebegin', container);
		}
					}
				})
		})
		document.querySelectorAll('.wsaio_delivery_pickup input').forEach(input => {
			input.addEventListener('click', function(e) {
				const clickedValue = e.target.value;
				document.querySelectorAll(`[value="${clickedValue}"]`).forEach(el => {
					if (el.type === 'radio' || el.type === 'checkbox') {
						el.checked = true;
					}
				});
				document.querySelectorAll('.wsaio_delivery_error').forEach(errorEl => {
					errorEl.remove();
				});
				WSAIO.checkoutEventListner();
			});
		});
	}

	  WS.alterHTML(html, WS.subtotal_selector);

  };
  
	WSAIO.setCartItemsPrice = function (line_items,_subtotal) {
		if (WSAIO.debugger) debugger;
        WS.cart_items_each_selector = WS.cart_items_each_selector+',.net_item';
		var reg_single_price = 0, com_single_price = 0,reg_total_price = 0, com_total_price = 0, vat_subtotal = 0;
        var actual_regularPrice = 0;
        var excluded_actual_regularPrice = 0;
        var duplicates = line_items.filter((item, index, self) =>
            self.findIndex(i => i.variant_id === item.variant_id) !== index
        );
        var hasDuplicates = duplicates.length > 0;
		for (var itr = 0 ; itr < WS.cart_items_each_selector.split(',').length; itr++) {
			shuffle_cart_grid_loop(WS.cart_items_each_selector.split(',')[itr])
		}
		


		function shuffle_cart_grid_loop(_select){
		  try{ 
			  var Sorted_line_items = [];
				const selectElements = document.querySelectorAll(_select); 
				selectElements.forEach((item, index) => {
					const linkElement = item.querySelector('[href*="variant="]');
					const href = linkElement ? linkElement.getAttribute('href') : undefined;

					let variantId;

					if (typeof href !== 'undefined') {
						try {
							let parts = href.split('variant=');
							if (parts.length > 1) {
								variantId = parseInt(parts[1].split('&')[0],10);
							}
						} catch (e) {
							variantId = undefined;
						}
						if (typeof variantId !== 'undefined' && !isNaN(variantId)) {
							line_items.forEach((lineItem, _indx) => {
								if (lineItem.id === variantId) {
									lineItem.line = index; 
									if (Sorted_line_items.findIndex(e => e.id === variantId) === -1) {
										Sorted_line_items.push(lineItem);
									}
								}
							});
						}
					}
				});
			  if(!hasDuplicates && Sorted_line_items.length > 0){ line_items=Sorted_line_items}
          
			}catch(ee){console.warn(ee)}
		}
		var vat_subtotal = 0;
		var vat_applied = false;
		document.querySelectorAll('.vat_div').forEach(element => {
			element.remove();
		});
		for(var itr = 0 ; itr < WS.cart_items_each_selector.split(',').length; itr++){
		  cart_grid_loop(WS.cart_items_each_selector.split(',')[itr])
		}
		function cart_grid_loop(_selector){
			vat_subtotal = 0;
			actual_regularPrice = 0;
			excluded_actual_regularPrice = 0;
			const selectElements2 = document.querySelectorAll(_selector); 
			const promises = [];
			selectElements2.forEach((item, index) => {
					var _this = this;
					const itemPromise = new Promise((resolve) => {
					if(hasDuplicates){
						const linkEl = item.querySelector('[href*="variant="]');
						var Vid = null;
						if (linkEl && linkEl.getAttribute('href')) {
							let hrefValue = linkEl.getAttribute('href');
							if (hrefValue.includes("variant=")) {
								let afterVariant = hrefValue.split("variant=")[1];
								if (afterVariant) {
									Vid = parseInt(afterVariant.split("&")[0], 10);
								}
							}
						}
					}
					
					if(line_items && line_items.length > 0){
				var lineItemIndex = -1;
				try {
					if(hasDuplicates){
						lineItemIndex = line_items.findIndex(function(x){ return x.variant_id == Vid});
					}else{
					lineItemIndex = line_items.findIndex(function(x){ return x.line == index});
					}
				} catch (e) {}
				log("lineItemIndex",lineItemIndex);
				if(item){
					if(lineItemIndex > -1){
					var wsLineItem = line_items[lineItemIndex];
						const cart_item_total_selector = item.querySelectorAll(WS.cart_item_total_selector);
						const cart_item_price_selector = item.querySelectorAll(WS.cart_item_price_selector);
						const cart_item_saved_price_selector = item.querySelectorAll(WS.cart_item_saved_price_selector);
		
					log("cart_item_total_selector",cart_item_total_selector);
					log("cart_item_price_selector",cart_item_price_selector);
		
					if (typeof wsLineItem.wholesale !== 'undefined') {
						var wholesale = wsLineItem.wholesale;
						try {
						wholesale.item_subtotal_price = wholesale.item_subtotal_price.replace("$", "$@");
						wholesale.item_subtotal_compare_at_price = wholesale.item_subtotal_compare_at_price.replace("$", "$@");
						} catch (e) {
						log(e)
						}
						if(document.querySelector('.NetTerm_div') !== null) WSAIO.exclude_VAT = 0;
						if(WSAIO.exclude_VAT != 0 && WSAIO.check_eligible_customer()){
							var exclude_value = (WSAIO.exclude_VAT/100) + 1;
							vat_applied = true;
							reg_total_price = (wholesale.item_subtotal_price / exclude_value);
							com_total_price = (wholesale.item_subtotal_compare_at_price / exclude_value);
							vat_subtotal = vat_subtotal+parseFloat(reg_total_price);
							actual_regularPrice = WS.formatMoney( Number(wholesale.item_subtotal_price))
							excluded_actual_regularPrice = WS.formatMoney(Number(wholesale.item_subtotal_price / exclude_value))
						}else{
							reg_total_price = wholesale.item_subtotal_price;
							com_total_price = wholesale.item_subtotal_compare_at_price;
							vat_subtotal = vat_subtotal+parseFloat(wholesale.item_subtotal_price);
							actual_regularPrice = WS.formatMoney( Number(wholesale.item_subtotal_price));
							excluded_actual_regularPrice = 0;
						}
						
						try {
							if (typeof WSAIO.enable_netTerm != 'undefined' && WSAIO.enable_netTerm) {
								if (WSAIO.NetTerm_version > 1 || document.querySelector('.net_address_fields') === null) {
									try {
										var net_regular = reg_total_price;
										var net_compare = com_total_price;
										var net_selector = '.net-item-total-price-' + wsLineItem.key.replace(":", "_");
										net_regular = WS.formatMoney(Number(net_regular));
										net_compare = WS.formatMoney(Number(net_compare));
									} catch (c) {
										k(c);
									}
								} else {
									try {
										var net_regular = reg_total_price;
										var net_compare = com_total_price;
										var net_selector = '.net-item-total-price-' + wsLineItem.key.replace(":", "_");
										net_regular = WS.formatMoney(net_regular * 100);
										net_compare = WS.formatMoney(net_compare * 100);
									} catch (c) {
										console.log(c);
									}
								}
								if (!WS.general_settings.compare_at_price || net_compare == net_regular) {
									net_compare = "";
								}
								if(typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO.formatMoney('0').indexOf(Shopify.currency.active) == -1){
									net_regular = WSAIO.change_currency_sign(net_regular);
									if(net_compare != ""){
									net_compare = WSAIO.change_currency_sign(net_compare);
									}
								} 
								const netElements = document.querySelectorAll(net_selector);
								const newHtml = `<s>${net_compare}</s> <span class="order-discount">${net_regular}</span>`;
								netElements.forEach(element => {
									element.innerHTML = newHtml;
								});
							}
						} catch (w) { }
						if (!WS.general_settings.compare_at_price) {
							com_total_price = "";
						}
						var regular_price = WS.formatMoney(Number(reg_total_price));
						var compare_at_price = WS.formatMoney(Number(com_total_price));
						if(typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO.formatMoney('0').indexOf(Shopify.currency.active) == -1){
							regular_price = WSAIO.change_currency_sign(regular_price);
							actual_regularPrice = WSAIO.change_currency_sign(actual_regularPrice);
							excluded_actual_regularPrice = WSAIO.change_currency_sign(excluded_actual_regularPrice);
							if(compare_at_price != ""){
									compare_at_price = WSAIO.change_currency_sign(compare_at_price);
								}
							regular_price = WSAIO.price_with_unit(regular_price);
							actual_regularPrice = WSAIO.price_with_unit(actual_regularPrice);
							excluded_actual_regularPrice = WSAIO.price_with_unit(excluded_actual_regularPrice);
							if(compare_at_price != ""){
									compare_at_price = WSAIO.price_with_unit(compare_at_price);
								}
						}  
						var total_html = '';
						if (Number(reg_total_price) < Number(com_total_price)) {

							if(WS.cart_item_total_price_html.indexOf('%compare_at_price%') == -1){
								WS.cart_item_total_price_html = '<del class="money" style="padding-right:10px;">%compare_at_price%</del>' +WS.cart_item_total_price_html ; 
							}
							total_html = WS.cart_item_total_price_html;
							if (!WS.general_settings.compare_at_price) {
								total_html = WSAIO.remove_comparePrice(total_html);
							}
							total_html = total_html.replace("%regular_price%", regular_price)
							.replace("%compare_at_price%", compare_at_price);
					} else {
							WS.cart_item_total_price_html = WSAIO.remove_comparePrice(WS.cart_item_total_price_html);
						total_html = WS.cart_item_total_price_html
						.replace("%regular_price%",regular_price)
						.replace("%compare_at_price%", '');
				}
		
						try {
						total_html = total_html.replace(/@/g, '');
						} catch (e) {
						log(e);
						}
						
						try {
							if(WSAIO.exclude_VAT != 0 && WSAIO.check_eligible_customer() && typeof WSAIO.excludePrice_design != 'undefined' && WSAIO.excludePrice_design == 'without-crossout' && excluded_actual_regularPrice != 0){
								if (!WS.general_settings.compare_at_price) { actual_regularPrice = ""  }
								total_html = '<div class="wsaio_vat_price" style="text-align: left;"> <div class="money">'+actual_regularPrice+'</div> <div class="money">'+excluded_actual_regularPrice+'<span class="wsaio_excl" style="font-size:12px;padding-left: 4px;">(Excl. Tax)</span> </div> </div>'
								cart_item_total_selector.forEach(element => {
									element.innerHTML = total_html;;
								});
							}else{
								cart_item_total_selector.forEach(element => {
									element.innerHTML = total_html;
								});
							}
						} catch (e) {
						isError(e)
						}
		
						try {
						wholesale.regular_price = wholesale.regular_price.replace("$", "$@");
						wholesale.original_price = wholesale.original_price.replace("$", "$@");
						} catch (e) {
						log(e)
						}
						if (WSAIO.exclude_VAT != 0 && WSAIO.check_eligible_customer()) {
							var exclude_value = (WSAIO.exclude_VAT / 100) + 1;
							reg_single_price = (wholesale.regular_price / exclude_value);
							com_single_price= (wholesale.original_price / exclude_value);
							vat_applied = true;
							actual_regularPrice = WS.formatMoney(wholesale.regular_price)
							excluded_actual_regularPrice = WS.formatMoney(wholesale.regular_price / exclude_value)
						}else{
							reg_single_price = wholesale.regular_price;
							com_single_price= wholesale.original_price;
							actual_regularPrice = WS.formatMoney(wholesale.regular_price);
							excluded_actual_regularPrice = 0;
						}
						if (!WS.general_settings.compare_at_price) {
							com_single_price = "";
						}
						var regular_price = WS.formatMoney(Number(reg_single_price));
						var compare_at_price = WS.formatMoney(Number(com_single_price));
						if(typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO.formatMoney('0').indexOf(Shopify.currency.active) == -1){
							regular_price = WSAIO.change_currency_sign(regular_price);
							actual_regularPrice = WSAIO.change_currency_sign(actual_regularPrice);
							excluded_actual_regularPrice = WSAIO.change_currency_sign(excluded_actual_regularPrice);
								if(compare_at_price != ""){ 
									compare_at_price = WSAIO.change_currency_sign(compare_at_price);
								}
							regular_price = WSAIO.price_with_unit(regular_price);
							actual_regularPrice = WSAIO.price_with_unit(actual_regularPrice);
							excluded_actual_regularPrice = WSAIO.price_with_unit(excluded_actual_regularPrice);
								if(compare_at_price != ""){
									compare_at_price = WSAIO.price_with_unit(compare_at_price);
								}
						} 
						var single_price_html = '';
						if (Number(reg_single_price) < Number(com_single_price)) {
							if(WS.cart_item_price_html.indexOf('%compare_at_price%') == -1){
								WS.cart_item_price_html = '<del class="money" style="padding-right:10px;">%compare_at_price%</del>' +WS.cart_item_price_html ; 
							}
							single_price_html = WS.cart_item_price_html;
							if (!WS.general_settings.compare_at_price) {
								single_price_html = WSAIO.remove_comparePrice(single_price_html);
							}
							single_price_html = single_price_html.replace("%regular_price%", regular_price)
								.replace("%compare_at_price%", compare_at_price);
						} else {
							WS.cart_item_price_html = WSAIO.remove_comparePrice(WS.cart_item_price_html);
							single_price_html = WS.cart_item_price_html
								.replace("%regular_price%", regular_price)
								.replace("%compare_at_price%", '');
						}
		
		
						try {
						single_price_html = single_price_html.replace(/@/g, '');
						} catch (e) {
						log(e);
						}
						try {
							if(WSAIO.exclude_VAT != 0 && WSAIO.check_eligible_customer() && typeof WSAIO.excludePrice_design != 'undefined' && WSAIO.excludePrice_design == 'without-crossout' && excluded_actual_regularPrice != 0){
								if (!WS.general_settings.compare_at_price) { actual_regularPrice = ""  }
								single_price_html = '<div class="wsaio_vat_price"> <div class="money" style="display: block;">'+actual_regularPrice+'</div> <div class="money">'+excluded_actual_regularPrice+'<span class="wsaio_excl" style="font-size:12px;padding-left: 4px;">(Excl. Tax)</span> </div> </div>'
								cart_item_price_selector.forEach(element => {
									element.innerHTML = single_price_html;
								});
							}else{
								cart_item_price_selector.forEach(element => {
									element.innerHTML = single_price_html;
								});
							}
						} catch (e) {
						isError(e)
						}
						var html = WS.cart_item_saved_price_html.toString();
						var total_saved = {
						price: "",
						percentage: ""
						};
						if (wholesale && wholesale.saved_amount && wholesale.saved_amount.percentage) {
						total_saved.percentage = wholesale.saved_amount.percentage;
						}
						if (wholesale && wholesale.saved_amount && wholesale.saved_amount.price) {
						total_saved.price = wholesale.saved_amount.price;
						}
						html = html.replace(new RegExp("%saved_amount:price%", "gi"), WS.formatMoney(total_saved.price))
						.replace(new RegExp("%saved_amount:percentage%", "gi"), total_saved.percentage);
						try {
						cart_item_saved_price_selector.innerHTML = html;
						} catch (e) {
						isError(e)
						}
					}
		
					}
					else{
					log("Line item index not found. cart line number",index);
					}
				}
				else{
					isError("Item not found");
				}
				}
				else{
				isError("Critical Error. Precheckout line items are empty");
				}
			});
		});
		if (WSAIO.exclude_VAT != 0 && WSAIO.check_eligible_customer() && vat_applied) {
			if (document.querySelector('.vat_div') === null && document.querySelector('.net_address_fields') === null) {
				if(WSAIO.customer.tax_exempt && WSAIO.auto_vat_enable){
					const selector = WSAIO.subtotal_selector.replace(':same', '');
					const newHtml = `<span>Subtotal<span class="wsaio_excl" style="font-size:12px;padding-left: 4px;margin-right: 34px;">(Excl. Tax)</span>${WSAIO.formatMoney(vat_subtotal)}</span>`;
					const selectors = selector.split(',');
					const cleanSelectors = selectors.map(sel => sel.trim()).filter(Boolean);
					document.querySelectorAll('.vat_div').forEach(function(e){e.remove();});
					cleanSelectors.forEach(target => {
						const targetElements = document.querySelectorAll(target);
						targetElements.forEach(targetele => {
								targetele.innerHTML = newHtml;
						})
					})
				}else{
						const vatAmount = _subtotal - vat_subtotal;
						const newHtml = `
						<div class="vat_div">
							<div>
								Excluded Total 
								<span style="float: right;padding-left: 20px;">${WSAIO.formatMoney(vat_subtotal)}</span>
							</div> 
							<div>
								VAT 
								<span style="float: right;padding-left: 20px;">${WSAIO.formatMoney(vatAmount)}</span>
							</div> 
						</div>
						`;
if(typeof WSAIO.VAT_subtotal_selector != 'undefined'){
						const selectors = WSAIO.VAT_subtotal_selector.split(',');
						const cleanSelectors = selectors.map(sel => sel.trim()).filter(Boolean);
						document.querySelectorAll('.vat_div').forEach(function(e){e.remove();});
						cleanSelectors.forEach(target => {
							const targetElements = document.querySelectorAll(target);
							targetElements.forEach(targetele => {
								targetele.insertAdjacentHTML('beforebegin', newHtml);
							})
						})
						}
				}
			}else if(document.querySelector('.net_address_fields') === null && WSAIO.NetTerm_version > 1){
				var netTerm_subtotal = WSAIO.formatMoney(vat_subtotal);
				if(typeof WSAIO.show_currenyLabel_withPrice != 'undefined' && WSAIO.show_currenyLabel_withPrice && typeof Shopify.currency != 'undefined' && Shopify.currency.active != 'undefined' && WSAIO.formatMoney('0').indexOf(Shopify.currency.active) == -1){
				netTerm_subtotal = WSAIO.change_currency_sign(netTerm_subtotal);
				netTerm_subtotal = WSAIO.price_with_unit(netTerm_subtotal);
				}
				document.querySelectorAll('.net_prices.net--subtotal').forEach(element => {
					element.textContent = netTerm_subtotal;
				});

				const vatDeductValue = WSAIO.formatMoney((_subtotal - vat_subtotal));
				document.querySelectorAll('.net--vat_deduct').forEach(element => {
					element.textContent = vatDeductValue;
				});
				document.querySelectorAll('.applied_vat_line').forEach(element => {
					element.style.display = ''; 
				});
			}
		}
	}
	};
  
	WSAIO.productDiscount = function (params, callback) {
	  if (WSAIO.debugger) debugger;
	  if (WSAIO.isWholesaleCustomer() === false) {
		if (typeof callback === "function") {
		  return callback({
			error: "Invalid customer"
		  });
		} else {
		  return "Invalid customer";
		}
	  }
	  if (typeof params === 'undefined') {
		return isError("This action required some parameters.");
	  }
	  if (typeof params.product_id === 'undefined') {
		params.product_id = "default";
	  }
	  if (typeof params.product_handle === 'undefined') {
		params.product_handle = "default";
	  }
	  if (typeof params.variant_id === 'undefined') {
		params.variant_id = "default";
	  }
	  if (typeof params.variant_sku === 'undefined') {
		params.variant_sku = "default";
	  }
	  if (typeof params.variant_price === 'undefined') {
		params.variant_price = "default";
	  }
	  if (typeof params.variant_compare_at_price === 'undefined') {
		params.variant_compare_at_price = "default";
	  }
	  if (typeof params.collection_id === 'undefined') {
		params.collection_id = "default";
	  }
	  if (typeof params.product_parent_grid_selector === 'undefined') {
		params.product_parent_grid_selector = "default";
	  }
	  if (typeof params.remove_duplicate_table === 'undefined') {
		params.remove_duplicate_table = "default";
	  }
	  if (typeof params.template === 'undefined') {
		params.template = "default";
	  }
	  if(typeof params.template != 'undefined' && params.template === "product" ){
        WSAIO.buyNowEventListener()
      }
	  WSAIO.regularDiscount(params, function (regular_discount_response) {
		if (params.template === "product" || (params.template === "collection" && WSAIO.applied_rgDiscount_price == 0) || WS.landingTemplate === "product" || (window.location.href.indexOf('/pages/') > -1 && WS.landingTemplate === "collection") || params.apply_volume_discount === true || WSAIO.show_volumeRange) {
		  WSAIO.volumeDiscount(params, function (volume_discount_response) {
			if (typeof callback === "function") {
			  callback({
				regular_discount: regular_discount_response,
				volume_discount: volume_discount_response
			  });
			}
		  });
		} else if (WS.volume_discount_on_hcsr) {
		  WSAIO.volumeDiscount(params, function (volume_discount_response) {
			if (typeof callback === "function") {
			  callback({
				regular_discount: regular_discount_response,
				volume_discount: volume_discount_response
			  });
			}
		  });
		} else {
		  if (typeof callback === "function") {
			callback({
			  regular_discount: regular_discount_response,
			  volume_discount: "Not executed"
			});
		  }
		}
	  });
	};
  
	WSAIO.variantChange = function (product, variant) {
	  if (WSAIO.debugger) debugger;
	  if (WSAIO.isWholesaleCustomer() === false) {
		return "Invalid customer";
	  }
	  WS.productDiscount({
		item_price_selector: WS.product_price_selector,
		template: 'product',
		product_id: product.id,
		product_handle: product.handle,
		variant_id: variant.id,
		variant_sku: variant.sku,
		variant_price: variant.price,
		variant_compare_at_price: variant.compare_at_price
	  }, function (response) {
		console.log("vc response",response);
		setTimeout(function(){
				const isModalAbsent = document.querySelectorAll('.quick-add-modal__content--bulk').length === 0;

				if (typeof current_product !== 'undefined' && current_product !== null && isModalAbsent) {
					const startElementSelector = `.wsaio_${current_product.id}`;
					const startElement = document.querySelector(startElementSelector);

					if (startElement) {
						const parentGrid = startElement.closest(WSAIO.product_parent_grid_selector);

						if (parentGrid) {
							const qtyInput = parentGrid.querySelector(WSAIO.current_product_qty_input_selector);

							if (qtyInput) {
								if(qtyInput && qtyInput.tagName == 'SELECT'){
                                WSAIO.Volume_disocunted_price(qtyInput.options[qtyInput.selectedIndex].getAttribute('value'))
                                }else{
                                WSAIO.Volume_disocunted_price(qtyInput.value);
                                }
							}
						}
					}
				}
		},10);
		if(response && response.regular_discount && Number(response.regular_discount.ws_discount) != 0){
		  log("ws discount applied on this item");
		}
		else{
		  log("Set original price");
		  WS.variantOriginalPrice();
		}
	  });
	};
  
	WSAIO.selectedCurrency = function (el = null) {
		let selector = el || WS.currency_selector;
		let element = null;
		if (selector instanceof Element) {
			element = selector;
		} 
		else if (typeof selector === 'string' && selector.trim() !== '') {
			element = document.querySelector(selector);
		}
		
		return element ? element.value : '';
	};
  
  
	WSAIO.Currency.convert = function (amount, from, to) {
		var rates = WS.Currency.rates;
		try {
		  if(typeof Shopify !== "undefined" && typeof Shopify.currency !== "undefined"){
			  return amount*Shopify.currency.rate;  
		  }else{
			  return (amount * rates[from]) / rates[to];
		  }
		} catch (e) {
		  return e;
		}
	  };
  
	WSAIO.getProduct = function (handle, callback) {
		const url = WSAIO.local_param + 'products/' + handle + '.js';
		
		fetch(url)
			.then(response => {
				if (!response.ok) {
					throw new Error(`HTTP error! Status: ${response.status}`);
				}
				return response.json();
			})
			.then(product => {
				if (typeof callback === "function") {
					callback(product);
				}
			})
			.catch(error => {
				console.error('Error fetching product data:', error);
				if (typeof callback === "function") {
					callback(null, error); 
				}
			});

		return "Use callback function to get product";
	};
  
    // Equivalent Native JavaScript Code

		WSAIO.buy_it_now = function () {
			document.querySelectorAll(WS.buy_now_button_selector).forEach(button => {
				button.addEventListener("click", function (event) {
					
					event.preventDefault();
					event.stopImmediatePropagation(); 

					const _this = this; 
					
					_this.disabled = true; 
					
					const formElement = _this.closest("#main-product"); 
					const getParentGridValue = (selector, attribute = 'value') => {
						const parentGrid = formElement?.closest(WSAIO.product_parent_grid_selector);
						const targetElement = parentGrid?.querySelector(selector);
						
						if (!targetElement) return null;

						if (attribute === 'data-handle') {
							// Replaces: .attr("data-handle")
							return targetElement.getAttribute("data-handle");
						}
						// Replaces: .val()
						return targetElement.value;
					};

					const product_handle = getParentGridValue('[name="id"]', 'data-handle') || current_product.handle;
					const variant_id = getParentGridValue('[name="id"]');
					let product_quantity = getParentGridValue('[name="quantity"]') || 1;
                   
					 console.log('1111',product_handle,variant_id,product_quantity)  

					var variant_inventory_info = {};
					var inventory_issue = false;
					var available_qty = 0;
					
					// Existing JS logic remains the same...
					if(typeof WSAIO.default_product_variant != 'undefined' && WSAIO.default_product_variant.length > 0){
						variant_inventory_info = WSAIO.default_product_variant.find(function(e,r){return e.variant_id == variant_id})
					}
					if(variant_inventory_info != undefined && Object.keys(variant_inventory_info).length){
							if(variant_inventory_info.variant_inventory_management != undefined && variant_inventory_info.variant_inventory_management != ''){
								if(variant_inventory_info.variant_inventory_policy == 'deny'){
									if(parseInt(product_quantity,10) > parseInt(variant_inventory_info.variant_inventory_quantity,10)){
										inventory_issue = true;
										available_qty = variant_inventory_info.variant_inventory_quantity;
									}
								}
							}
					}
					
					if(inventory_issue){
						_this.disabled = false; 

						const errorElement = document.querySelector('.waioBUY_inventory_error');
						
						if (errorElement === null) {
							const wrapper = document.querySelector(WSAIO.shopify_payment_button_wrapper);
							if (wrapper) {
								const errorMessage = `<p class="waioBUY_inventory_error" style="font-size: 14px;color:red;">Only ${available_qty} item(s) are available. Please update the quantity and try again.</p>`;
								wrapper.insertAdjacentHTML('afterend', errorMessage);
							}
						}
						
						setTimeout(function(){	
							document.querySelectorAll('.waioBUY_inventory_error').forEach(el => el.remove());
						}, 4000);
						
						return false;
					}

					void 0 === product_quantity && (product_quantity = 1);
					WS.getProduct(product_handle, function (pr) {
						WS.buy_now_product = pr;
						proccedToBuyItNow();
					});
				
					function proccedToBuyItNow() {
						sessionStorage.setItem('isCheckoutvisited', 'true');
						if (typeof WS.buy_now_product !== 'undefined' && WS.buy_now_product !== null) {
							var product = WS.buy_now_product;
							if (product) {
									var selected_variant_index = product.variants.findIndex(function (a) {
										return a.id == variant_id
									}),
										variant = {};
									if (-1 < selected_variant_index) {
										variant = product.variants[selected_variant_index];
									}else if(current_variant != undefined){
										variant = current_variant;
										WSAIO.buy_now_product.variants.push(current_variant);
										product = WSAIO.buy_now_product;
										selected_variant_index = product.variants.findIndex(function (a) {
											return a.id == variant.id
										})
									}   
									try{
										WSAIO.productDiscount({
											template:'product',
										item_price_selector: document.querySelector('.demo'),
										product_id: WSAIO.buy_now_product.id,
										product_handle: WSAIO.buy_now_product.handle,
										variant_id: WSAIO.buy_now_product.variants[selected_variant_index].id,
										variant_sku: WSAIO.buy_now_product.variants[selected_variant_index].sku,
										variant_price: WSAIO.buy_now_product.variants[selected_variant_index].price,
										variant_compare_at_price: WSAIO.buy_now_product.variants[selected_variant_index].compare_at_price
									},function(ee){
										var volume_applied = ee.volume_discount.quantity_breaks.length;
										WSAIO.volume_values = [];
										if(volume_applied > 0){
										WSAIO.volume_values = ee.volume_discount.quantity_breaks;
										}
										if(parseFloat(ee.regular_discount.ws_discount) > 0){
										WSAIO.current_product_discountPrice = Number(variant.price)-parseFloat(ee.regular_discount.ws_discount)*100
										WSAIO.regular_price = Number(variant.price);
										}else{
										WSAIO.current_product_discountPrice =  Number(variant.price);
										WSAIO.regular_price = Number(variant.price);
										}
										});
									}catch(e){}

									var current_url = window.location.href;
									var is_subscriptionOption = false;
									const sellingPlanInput = document.querySelector('[name="selling_plan"]');
									if(sellingPlanInput && sellingPlanInput.value != ''){
										is_subscriptionOption = true;
									}

								    var selling_plan_id = null;
								
									const checkedSellingPlan = document.querySelector('[name="selling_plan"]:checked');
									if(checkedSellingPlan && checkedSellingPlan.value != ''){
										selling_plan_id = checkedSellingPlan.value;
									} 
									else if(sellingPlanInput && sellingPlanInput.value != ''){
										selling_plan_id = sellingPlanInput.value;
									}

									if(WSAIO.subscription_price != undefined && WSAIO.subscription_price != null){
									variant.price = WSAIO.subscription_price;
									}
									
									if(WSAIO.current_product_discountPrice == undefined){
									WSAIO.current_product_discountPrice = Number(variant.price);
									}  
							      	if (variant.available) { 
									   var line_price = Number(variant.price) * Number(product_quantity),
										cart = {
										attributes: {},
										cart_level_discount_applications: [],
										currency: WS.Currency.selectedCurrency || Shopify.currency.active || WS.shopInfo.currency,
										item_count: product_quantity,
										items: [{
											discounted_price: variant.price,
											discounts: [],
											featured_image: product.featured_image,
											final_line_price: line_price,
											final_price: variant.price,
											gift_card: !1,
											grams: variant.weight,
											handle: product.handle,
											id: variant.id,
											image: product.featured_image,
											key: "11309472350255:a5c7b76a76a9b8da2aa5dceab2c6b7ab",
											line_level_discount_allocations: [],
											line_price: line_price,
											options_with_values: [],
											original_line_price: line_price,
											original_price: variant.price,
											price: variant.price,
											product_description: "",
											product_has_only_default_variant: !1,
											product_id: product.id,
											product_title: product.title,
											product_type: product.type,
											properties: null,
											quantity: product_quantity,
											requires_shipping: variant.requires_shipping,
											sku: variant.sku,
											taxable: variant.taxable,
											title: product.title + " - " + variant.title,
											total_discount: 0,
											url: WSAIO.local_param + "products/" + product_handle + "?variant=" + variant.id,
											variant_id: variant.id,
											variant_options: variant.options,
											variant_title: variant.title,
											vendor: product.vendor
										}],
										items_subtotal_price: line_price,
										note: null,
										original_total_price: line_price,
										requires_shipping: variant.requires_shipping,
										token: "3cbccfbccb5ed48c66e4ced34048082d",
										total_discount: 0,
										total_price: line_price,
										total_weight: Number(variant.weight) * Number(product_quantity)
									};
									}else{
										isError("Variant is not available or missing variant");
										if(Shopify.routes.root.replaceAll('/','') != ''){
										   return WS.redirectToURL(WSAIO.local_param + 'cart/' + variant_id + ':' + product_quantity+ '?locale='+Shopify.routes.root.replaceAll('/',''));
										}else{
										   return WS.redirectToURL(WSAIO.local_param + 'cart/' + variant_id + ':' + product_quantity);
										}
									}
									var bnreqdata = {
									cart: cart,
									note: "",
									note_attributes: [],
									billing_address: {},
									shipping_address: {},
									shopInfo: WS.shopInfo,
									customer: WS.customer,
									user_mode: WS.user_mode,
									currency: WS.shopInfo.currency,
									custom_line_items: [],
									discount_code_application: WSAIO.DiscountCode.application
									};
									if(typeof WSAIO.wholesale_app_tags == 'undefined' || (typeof WSAIO.wholesale_app_tags != 'undefined' && WSAIO.wholesale_app_tags.indexOf('app') > -1) ){
										bnreqdata["tags"] = "wsaio-app,checkout-via-buy-now-button";
									}else{
										bnreqdata["tags"] = "checkout-via-buy-now-button";
									}
									if(typeof WSAIO.collection_ids_required != 'undefined' && WSAIO.collection_ids_required){
                                       bnreqdata["missing_products_with_collections"] = [product.id];
									}

									if (WS.variant_sku_are_same) {
									bnreqdata["variant_sku_are_same"] = WS.variant_sku_are_same;
									}
									if (WS.coupon_expires_after_hours) {
									bnreqdata["coupon_expires_after_hours"] = WS.coupon_expires_after_hours;
									}
									if(typeof window.company_data != 'undefined'){
										bnreqdata["company"] = window.company_data;
									}

									if(is_subscriptionOption && selling_plan_id != null && WSAIO.subscription_price != undefined && WSAIO.subscription_price != null){
										bnreqdata["hasSubscription"] = true;
									}

									if (WS.auto_delete_api) {
										if (localStorage.getItem("draft_order_info") != null) {
											try {
											bnreqdata["prev_draft_order_info"] = JSON.parse(localStorage.getItem("draft_order_info"));
											} catch (e) {
											log(e)
											}
										}
										if (localStorage.getItem("price_rule_info") != null) {
											try {
											bnreqdata["prev_price_rule_info"] = JSON.parse(localStorage.getItem("price_rule_info"));
											} catch (e) {
											log(e)
											}
										}
								    }
									const buyNowBtn = document.querySelectorAll(WSAIO.buy_now_button_selector);
									if (typeof MOQ_applied !== 'undefined' && MOQ_applied.length > 0) {
										const qty = Number(product_quantity);
										const inc = MOQ_applied[0]._qtyInc;
										const min = MOQ_applied[0]._qtyMin;
										const max = MOQ_applied[0]._qtyMax;

										
										if ((qty % inc) === 0 && qty >= min) {
											if (max !== 0 && qty <= max) {
												buyNowBtn.forEach(btn => {
													btn.classList.remove("checkout-disabled");
													btn.removeAttribute("disabled");
												});
												WSAIO.disable_buy_now_button_moq = false;
											} else {
												buyNowBtn.forEach(btn => {
													btn.classList.remove("checkout-disabled");
													btn.removeAttribute("disabled");
												});
												WSAIO.disable_buy_now_button_moq = false;
											}
										} else {
											if (WSAIO.buyNow_message !== '') {
											document.querySelectorAll('.waioMOQ_buy_message').forEach(el => el.remove());
											const wrapper = document.querySelector(WSAIO.shopify_payment_button_wrapper);
											if (wrapper) {
													const p = document.createElement("p");
													p.className = "waioMOQ_buy_message";
													p.style.fontSize = "14px";
													p.textContent = "Minimum Requirements not fulfilled";
													wrapper.insertAdjacentElement("afterend", p);
											}
										}
											buyNowBtn.forEach(btn => {
												btn.classList.add("checkout-disabled");
												btn.setAttribute("disabled", "disabled");
										});

										WSAIO.disable_buy_now_button_moq = true; 
											
										}
										
									}
											setTimeout(() => {
												buyNowBtn.forEach(btn => {
													btn.classList.remove("checkout-disabled");
													btn.removeAttribute("disabled");
											});
												document.querySelectorAll('.waio_buy_message, .waioMOQ_buy_message')
													.forEach(el => el.remove());
										}, 2500);
									setTimeout(function(){
										const buynowElement = document.querySelector(`.wsaio_${current_product.id}`)
											?.closest(WSAIO.product_parent_grid_selector)
											?.querySelector('.wsaio_buynow');
										if (buynowElement) {
											buynowElement.style.cssText = 'display:inline-block !important';
										}
									}, 10);
								   WSAIO.BuyNoworderControl(WSAIO.current_product_discountPrice,Number(product_quantity),WS.buy_now_button_selector,WSAIO.volume_values,WSAIO.regular_price,variant.id);
									if (WSAIO.disable_buy_now_button || WSAIO.disable_buy_now_button_moq) {
										if(WSAIO.disable_buy_now_button && !WSAIO.disable_buy_now_button_moq && (typeof WSAIO.allow_normal_checkout__OC != 'undefined' && WSAIO.allow_normal_checkout__OC)){
											return WS.redirectToURL(WSAIO.local_param + 'cart/' + variant_id + ':' + product_quantity);
										}else{
											return false;
										}
									}
									if (WS.ccr) {
									bnreqdata["ccr"] = WS.ccr;
									}
								    if(typeof WSAIO.shopify_markets_pro_enabled != 'undefined' && WSAIO.shopify_markets_pro_enabled && (typeof Shopify !== "undefined" && typeof Shopify.currency !== "undefined" && Shopify.currency.active != WSAIO.shopInfo.currency)){
										if(WSAIO.customer.addresses[0] == undefined){
											WS.customer = { "addresses": [{ "country": WSAIO.shop_country }] }
										}
										if (WS.customer && WS.customer.addresses && WS.customer.addresses[0]) {
											bnreqdata["shipping_address"] = WS.customer.addresses[0];
										}
										if(WS.customer && WS.customer.addresses && WS.customer.addresses[0]){
											bnreqdata["billing_address"] = WS.customer.addresses[0];
										}
									}

									if(typeof WSAIO.multiple_markets_available != 'undefined'){
										bnreqdata["multiple_markets_available"] = WSAIO.multiple_markets_available;
									}
									WS.checkoutRequest(bnreqdata, function (error, response) {
										setTimeout(function(){
											_this.prop("disabled", false);
										},3000)
										if(typeof response != 'undefined' &&  response.isError && response.error != null && response.error && response.error.errors){
													var error_msg = response.error.errors[0].message;
													if(typeof error_msg != 'undefined' && error_msg != null && error_msg != '' && error_msg.indexOf('Managed Markets orders') > -1){
														WSAIO.shopify_markets_pro_enabled = true;
														if(recheckout_marketPro < 1){
															recheckout_marketPro++;
															document.querySelectorAll(WS.buy_now_button_selector).forEach(element => {
																element.click();
															});
															return false;
														}
													}
											}
										if(typeof response.wholesale_errors != 'undefined' && response.wholesale_errors.length > 0){
											for(var error_key = 0; error_key < response.wholesale_errors.length; error_key++){
												if(response.wholesale_errors[error_key].key == 'email'){
													if(document.querySelector('.wsaioserver_error1') === null){
														
															const wrapper = document.querySelector(WSAIO.shopify_payment_button_wrapper);
														if (wrapper) {
															const serverError = '<div class="wsaioserver_error1" style="color:red !important;font-size:12px !important;">Email contains an invalid domain name. Retry to place an order without a discount.</div>';
															wrapper.insertAdjacentHTML('afterend', serverError);
														}
														document.querySelectorAll(WSAIO.buy_now_button_selector).forEach(btn => {
															btn.classList.remove('checkout-disabled');
															btn.disabled = false;
														});
														return false;
													}else{
														return WS.redirectToURL(WSAIO.local_param + 'cart/' + variant_id + ':' + product_quantity);
													}
												}
											}
										}

										if (error) {
											log(error);
											return WS.redirectToURL(WSAIO.local_param + 'cart/' + variant_id + ':' + product_quantity);
										} else {
											if (response && response.checkout_url && (response.checkout_url.indexOf("invoices") > -1)) {
											try{
												if(Shopify.routes.root.replaceAll('/','') != '' && typeof response.discount_code == 'undefined'){
												response.checkout_url = response.checkout_url+'?locale='+Shopify.routes.root.replaceAll('/','');
												}
											}catch(er){console.warn('er')}
											return WS.redirectToURL(response.checkout_url);
											} else if (response && WS.general_settings && (WS.general_settings.discount_method == "coupon_code" && response.discount_code)) {
													if(is_subscriptionOption && selling_plan_id != null && WSAIO.subscription_price != undefined && WSAIO.subscription_price != null){
														return WS.redirectToURL(WSAIO.local_param + 'cart/clear?return_to=/cart/add?items[][id]=' + variant_id + '%26items[][quantity]=' + product_quantity + '%26items[][selling_plan]=' + selling_plan_id + '%26return_to=/checkout'+'?discount=' + response.discount_code);
													}else{
															if(Shopify.routes.root.replaceAll('/','') != '' && typeof response.discount_code != 'undefined'){
																return WS.redirectToURL(WSAIO.local_param + 'cart/' + variant_id + ':' + product_quantity + '?locale='+Shopify.routes.root.replaceAll('/','')+'&discount=' + response.discount_code);
															}else{
																return WS.redirectToURL(WSAIO.local_param + 'cart/' + variant_id + ':' + product_quantity + '?discount=' + response.discount_code);
															}
													}
											} else {
												if(Shopify.routes.root.replaceAll('/','') != ''){
													return WS.redirectToURL(WSAIO.local_param + 'cart/' + variant_id + ':' + product_quantity+ '?locale='+Shopify.routes.root.replaceAll('/',''));
												}else{
													return WS.redirectToURL(WSAIO.local_param + 'cart/' + variant_id + ':' + product_quantity);
												}
											}
										}
									})
							}else{
								isError("Product object is missing");
								if(Shopify.routes.root.replaceAll('/','') != ''){
									return WS.redirectToURL(WSAIO.local_param + 'cart/' + variant_id + ':' + product_quantity+ '?locale='+Shopify.routes.root.replaceAll('/',''));
								}else{
									return WS.redirectToURL(WSAIO.local_param + 'cart/' + variant_id + ':' + product_quantity);
							    }
							}
						}else{
							if(Shopify.routes.root.replaceAll('/','') != ''){
							   return WS.redirectToURL(WSAIO.local_param + 'cart/' + variant_id + ':' + product_quantity+ '?locale='+Shopify.routes.root.replaceAll('/',''));
							}else{
							   return WS.redirectToURL(WSAIO.local_param + 'cart/' + variant_id + ':' + product_quantity);
							}
						}
					}
				});
			});
		};

		
	WSAIO.orderControl = function (min_price, el, message, disable_checkout_btn) {
	  "undefined" === typeof window.waioMOC && (window.waioMOC = {});
	  "undefined" === typeof waioMOC.cart && (waioMOC.cart = {});
	  if (typeof min_price !== "undefined" && min_price != null && !isNaN(min_price)) {
		try {
		  waioMOC.cart["original_total_price"] = min_price;
		} catch (e) {
		  isError(e);
		}
	  } else {
		isError("min price was not provided for buy now product");
	  }
	  if ("undefined" !== typeof min_price && null != min_price && !isNaN(min_price)) {
		try {
		  waioMOC.cart.original_total_price = min_price;
		} catch (e) {
		  isError(e);
		}
	  };
	  if(typeof WSAIO.disableCheckout === "function"){
		WSAIO.disableCheckout(disable_checkout_btn, message, el);
	  }
	  if(typeof WSAIO.order_control === "function"){
		WSAIO.order_control();
	  }
  
	  return WSAIO.disable_checkout;
	};
  
	WSAIO.DiscountCode.subscribe = function () {
  
  
		document.querySelectorAll('.wsaio_coupon_field input').forEach(inputElement => {
			inputElement.addEventListener('input', function() {
				
				const code = this.value.trim();
				const couponGroup = this.closest('.wsaio_coupon_group');
				if (couponGroup) {
					const button = couponGroup.querySelector('button');
					if (button) {
						if (code !== "") {
							button.classList.remove("ws-disabled");
							button.removeAttribute("disabled");
						} else {
							button.classList.add("ws-disabled");
							button.setAttribute("disabled", "disabled"); 
						}
					}
				}
			});
		});
  
		document.addEventListener('click', function(e) {
			if (e.target.matches('.wsaio_coupon_button')) {

				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();

				const button = e.target;
				
				const couponGroup = button.closest('.wsaio_coupon_group');
				
				if (couponGroup) {
					const inputElement = couponGroup.querySelector(".wsaio_coupon_field input");
					
					if (inputElement) {
						const code = inputElement.value.trim();
						if (code !== "") {
							inputElement.classList.remove("wsaio_error");
							WSAIO.DiscountCode.apply(code);
						} else {
							inputElement.classList.add("wsaio_error");
							inputElement.focus();
						}
					}
				}
			}
		});
	}
		
	WSAIO.DiscountCode.apply = function (_code) {
	  if (WSAIO.debugger) debugger;
	  $discount = this;
	  $discount.code = _code;
		document.querySelectorAll('.wsaio_coupon_box').forEach(element => {
			element.classList.add('wsaio_loading');
		});
	  WS.fetchCart(function (error, cart) {
		document.querySelectorAll('.wsaio_coupon_box').forEach(element => {
			element.classList.remove('wsaio_success', 'wsaio_error');
		});
		try {
		  WSAIO.cart_object = cart;
		} catch (e) {}
		if (error) {
		  return isError(error);
		} else {
		  var post_data = {
			cart: cart,
			shopInfo: WS.shopInfo,
			customer: WS.customer,
			coupon_code: _code,
			products_with_collections: (WSAIO.cart_relevent_collectionID() || [])
		  };
		  WS.ajax({
			type: "POST",
			url: WS.App.checkoutURL + '/discount-code',
			data: post_data,
			dataType: "json",
			success: function (result) {
			 document.querySelectorAll('.wsaio_coupon_box').forEach(element => {
				element.classList.remove('wsaio_loading');
			});
			  log(result);
			  try {
				delete result.log;
			  } catch (e) {	
				log(e)
			  }
			  if (typeof WS.callback === 'function') {
				WS.callback(result);
			  }
			  if (result && result.status === 1) {
				if (typeof result.wholesale_key !== 'undefined') {
				  $discount.application = result;
				  try{
				    const selector = '[href$="/pages/net-term-order"]';
					const newHref = '/pages/net-term-order?coupon=' + _code;

					document.querySelectorAll(selector).forEach(element => {
						element.setAttribute('href', newHref);
					});
				  } catch (e) { log(e) }
				  var wsac = {
					code: _code,
					shop: WS.shopInfo.shop,
				  };
				  if (WS.customer.id) {
					wsac["customer_id"] = WS.customer.id;
				  }
				  localStorage.setItem("ws-applied-coupon", JSON.stringify(wsac));
				} else {
				  $discount.application = undefined;
				}
				document.querySelectorAll('.wsaio_coupon_box').forEach(element => {
					element.classList.add('wsaio_success');
				});
			  } else {
				localStorage.removeItem("ws-applied-coupon");
				if ((result && result.status === 0 && result.message === 'Not found') || (WSAIO.customer.id !== null)) {
					document.querySelectorAll('.wsaio_error_msg').forEach(element => {
						element.textContent = 'Enter a valid discount code';
					});

					document.querySelectorAll('.wsaio_coupon_box').forEach(element => {
						element.classList.add('wsaio_error');
					});

				} else {
					const loginHtml = `<a href="${WSAIO.local_param}account" style="color:red;">Login</a> to apply discount code`;

					document.querySelectorAll('.wsaio_error_msg').forEach(element => {
						element.innerHTML = loginHtml;
					});

					document.querySelectorAll('.wsaio_coupon_box').forEach(element => {
						element.classList.add('wsaio_error');
					});
				}
				
			  }
			}
		  });
		}
	  });
	};
  
	WSAIO.signUpForm = function () {
	  if (WSAIO.debugger) debugger;
	  if (typeof WS.signup_form !== 'undefined') {
		try {
			0 < document.querySelectorAll(WS.signup_form_selector).length 
				? 
				document.querySelectorAll(WS.signup_form_selector).forEach(element => {
					element.innerHTML = WS.signup_form.form_html;
				})
				: 
				log("Sign Up form selector not found");
		} catch (e) {
		  isError(e)
		}
	  } else {
		log("We could not found Signup Form. Save signup form in the wholesale applicatipn dashboard and then refresh this page")
	  }
	};
  
	WSAIO.removeAllEvents = function (el) {
	  try {
		for (var i = 0; i < document.querySelectorAll(el).length; i++) {
		  var a = document.querySelectorAll(el)[i];
		  a.parentNode.replaceChild(a.cloneNode(true), a);
		}
	  } catch (e) {
		log(e)
	  }
	};
  
	WSAIO.registerEvent = function (el, type, callback) {
	  try {
		for (var i = 0; i < document.querySelectorAll(el).length; i++) {
		  var a = document.querySelectorAll(el)[i];
		  a.addEventListener(type, callback);
		}
	  } catch (e) {
		log(e)
	  }
	};
  
	WSAIO.buyNowEventListener = function () {
		if (WSAIO.isWholesaleCustomer() === false && (typeof waioMOC == 'undefined' || waioMOC.rules.length === 0)) {
		return "Invalid customer";
	  }
	  WS.addBuyNowBtnHTML();
	};
  
	
	WSAIO.addBuyNowBtnHTML = function () {
		var selected_variant_availablity = true;
        if(typeof current_product != 'undefined' && current_product != null){
           current_product.variants.find(function(e){
             const productElement = document.querySelector('.wsaio_' + current_product.id);
				if (productElement && productElement.closest(WSAIO.product_parent_grid_selector)) {
					const parent = productElement.closest(WSAIO.product_parent_grid_selector);
					const input = parent.querySelector('[name="id"]');
					if (input && input.value == e.id) {
						selected_variant_availablity = e.available;
					}
				}
           });
         }
	  var is_replace = false;
	  if(WSAIO.buy_now_btn_replace){
	  is_replace = true;
	  }
	  if((WSAIO.subscription_variant_selector != '' || WSAIO.subscription_variant_selector != 'false') && WSAIO.buy_now_btn_replace){
		let is_replace = true; 
		const selector = WSAIO.subscription_variant_selector;
		if (typeof selector === 'string' && selector.trim() !== '') {
			const subscriptionVariant = document.querySelector(selector);
			if (subscriptionVariant && subscriptionVariant.checked) {
				is_replace = false;
			}
		} 
	  }
	  if(!selected_variant_availablity){is_replace = false}
	  var is_append = setInterval(function(){
		if(typeof current_product != 'undefined' && current_product != null){
			if(WSAIO.isWholesaleCustomer() === false){
			    const dynamicClass = 'wsaio_' + current_product.id;
				document.querySelectorAll(WSAIO.product_price_selector).forEach(element => {
					element.classList.add(dynamicClass);
				});
			}
			if( is_replace == false){
					const startElement = document.querySelector('.wsaio_' + current_product.id);
					if (startElement) {
						const parentElement = startElement.closest(WSAIO.product_parent_grid_selector);
						if (parentElement) {
							const buyNowElement = parentElement.querySelector('.wsaio_buynow');
							if (buyNowElement) {
								buyNowElement.remove();
							}
						}
					}
			}

          if(WSAIO.general_settings.discount_method == 'coupon_code' && (typeof WSAIO.enable_lineCouponCode != 'undefined' && WSAIO.enable_lineCouponCode)){
					if(window.cart_data == undefined) window.cart_data = WSAIO.cart_object;
					var already_exist_item = cart_data.items.find(function(e){
					return e.id == selected_variant_id
					});
					if(already_exist_item != undefined){
					var isfound_property = cart_data.items.find(function(e){
						return e.properties['_Wholesale_All_In_One__Discount_ID'] == undefined
					});
					}
					if (isfound_property === undefined) {
						const baseSelector = '.wsaio_' + current_product.id;
						const parentSelector = document.querySelector(baseSelector)?.closest(WSAIO.product_parent_grid_selector);
						const quickParentSelector = document.querySelector(baseSelector)?.closest(WSAIO.quickView_parent_Selector);
						const productIsValid = typeof current_product !== 'undefined' && current_product !== null;
						if (productIsValid && quickParentSelector) {
							const isQuickViewFieldMissing = quickParentSelector.querySelector('.item_wsaio_price_field') === null;

							if (isQuickViewFieldMissing) {
								const targetElement = quickParentSelector.querySelector('[name="id"]');
								const newElementHTML = '<input type="hidden" class="item_wsaio_price_field" name="properties[_Wholesale_All_In_One__Discount_ID]">';

								if (targetElement) {
									targetElement.insertAdjacentHTML('beforebegin', newElementHTML);
								}
							}
						}
						if (productIsValid && parentSelector) {
							const isParentFieldMissing = parentSelector.querySelector('.item_wsaio_price_field') === null;

							if (isParentFieldMissing) {
								const targetForm = parentSelector.querySelector('form[action^="/cart/add"]');
								const newElementHTML = '<input type="hidden" class="item_wsaio_price_field" name="properties[_Wholesale_All_In_One__Discount_ID]">';
								
								if (targetForm) {
									targetForm.insertAdjacentHTML('beforeend', newElementHTML);
								}
							}
						}
					}
			}

		    const productElements = document.querySelectorAll('.wsaio_' + current_product.id);

			productElements.forEach(productEl => {
				const parentGrid = productEl.closest(WSAIO.product_parent_grid_selector);
				if (!parentGrid) return;

				const paymentWrapper = parentGrid.querySelector(WSAIO.shopify_payment_button_wrapper);
				if (!paymentWrapper) return;

				const buyNowButton = paymentWrapper.querySelector(WSAIO.buy_now_button_selector);
				if (buyNowButton) {
					// paymentWrapper.style.display = 'none';

					const hasBuyNow = parentGrid.querySelector('.wsaio_buynow');
					if (!hasBuyNow && is_replace) {
					const buyNowBtn = paymentWrapper.querySelector(WSAIO.buy_now_button_selector);
					const moreOptionsBtn = paymentWrapper.querySelector('.shopify-payment-button__more-options');

					if (buyNowBtn) {
						buyNowBtn.classList.add('wsaio_hide_btn');
						buyNowBtn.style.setProperty('display', 'none', 'important');
					}

					if (moreOptionsBtn) {
						moreOptionsBtn.classList.add('wsaio_hide_btn');
						moreOptionsBtn.style.setProperty('display', 'none', 'important');
					}
					paymentWrapper.insertAdjacentHTML('beforeend', WSAIO.buy_now_button_html);
					const customBuyNow = parentGrid.querySelector('.wsaio_buynow');
					if (customBuyNow) {
						customBuyNow.style.setProperty('display', 'inline-block', 'important');
					}

					} else {
					if (
						(WSAIO.buy_now_btn_replace === false || is_replace === false) &&
						selected_variant_availablity
					) {
						parentGrid.querySelectorAll('.wsaio_buynow').forEach(el => el.remove());

						const shopifyBuyNow = paymentWrapper.querySelector(WSAIO.buy_now_button_selector);
						const moreOptions = paymentWrapper.querySelector('.shopify-payment-button__more-options');

						if (shopifyBuyNow) shopifyBuyNow.classList.remove('wsaio_hide_btn');
						if (moreOptions) moreOptions.classList.remove('wsaio_hide_btn');

						const shopifyPaymentBtn = parentGrid.querySelector('.shopify-payment-button .shopify-payment-button__button');
						if (shopifyPaymentBtn) {
						shopifyPaymentBtn.style.setProperty('display', 'inline-block', 'important');
						}
					}
					}
					if (typeof WS !== 'undefined' && typeof WS.buy_it_now === 'function') {
					WS.buy_it_now();
					}

					if (typeof WSAIO.showBuy !== 'undefined' && typeof WSAIO.showBuy === 'function') {
					WSAIO.showBuy();
					}
					if (parentGrid.querySelector('.wsaio_buynow')) {
					paymentWrapper.querySelectorAll('button').forEach(btn => {
						const siblingDiv = btn.nextElementSibling;
						if (siblingDiv) {
						siblingDiv.querySelectorAll(WSAIO.buy_now_button_selector + ', button').forEach(subBtn => {
							subBtn.classList.add('wsaio_hide_btn');
							subBtn.style.setProperty('display', 'none', 'important');
						});
						}
					});
					}

					clearInterval(is_append);
				}
			});

		}else{
		  clearInterval(is_append)
		}
	  },100)
  
	  };
  
	document.addEventListener('DOMContentLoaded', function() {
		setTimeout(function() {
			WSAIO.buyNowEventListener();
			let selected_variant_availablity = true;
			if (typeof current_product !== 'undefined' && current_product !== null) {
				current_product.variants.forEach(e => {
					const productElement = document.querySelector('.wsaio_' + current_product.id);
					if (productElement) {
						const parentGrid = productElement.closest(WSAIO.product_parent_grid_selector);
						if (parentGrid) {
							const variantIdInput = parentGrid.querySelector('[name="id"]');
							
							if (variantIdInput && variantIdInput.value == e.id) {
								selected_variant_availablity = e.available;
							}
						}
					}
				});
			}
			if (selected_variant_availablity) {
				setTimeout(function() {
					try {
						const productElement = document.querySelector('.wsaio_' + current_product.id);
						if (productElement) {
							const parentGrid = productElement.closest(WSAIO.product_parent_grid_selector);
							if (parentGrid) {
								const paymentButton = parentGrid.querySelector(WSAIO.shopify_payment_button_wrapper);
								if (paymentButton) {
									paymentButton.style.display = 'block';
								}
							}
						}
					} catch (e) {
					}

					WSAIO.showBuyevent = function() {
						WSAIO.showBuy = function() {
							const productElement = document.querySelector('.wsaio_' + current_product.id);
							if (productElement) {
								const parentGrid = productElement.closest(WSAIO.product_parent_grid_selector);
								if (parentGrid) {
									const paymentButton = parentGrid.querySelector(WSAIO.shopify_payment_button_wrapper);
									if (paymentButton) {
										paymentButton.style.display = 'block';
									}
								}
							}
						};
					};

					if (typeof WSAIO.showBuyevent !== 'undefined') {
						WSAIO.showBuyevent();
					}
				}, 500);
			}
		}, 100);
	});
  WSAIO.DiscountCode.add = function () {
	if (true === WSAIO.general_settings.enable_additional_coupon_code) {
	  WS.DiscountCode.addForm();
	  WS.DiscountCode.subscribe(); // subscribe on click event
	}
  };
  
  WSAIO.cartDrawer = function (time) {
	const selectors = WSAIO.checkout_selector + ',' + WSAIO.duplicate_checkout_selector + ',' + WSAIO.netTerm_checkout_selector;
	const checkoutButtons = document.querySelectorAll(selectors);
	checkoutButtons.forEach(button => {
		button.classList.add('wsaio_hideCheckout');
		button.classList.add('checkout-disabled');
		button.setAttribute('disabled', 'disabled');
	});
	setTimeout(function(){
	  WS.checkoutEventListner(); 
	  WS.preCheckout(); 
	},time)
  };
	
 document.addEventListener('click', function(event) {
		const targetLink = event.target.closest('a[href*="quantity=0"]');
	if (targetLink) {
		WSAIO.cartDrawer(1500);
	}
  });
  
  
  if ('undefined' === typeof WSAIO.Currency.rates) {
	WSAIO.Currency.rates = {};
  }
  if ('undefined' === typeof WSAIO.Currency.selectedCurrency) {
	WSAIO.Currency.selectedCurrency = WS.selectedCurrency();
  }
  WSAIO.Currency.storeCurrency = WS.shopInfo.currency;
  if ("undefined" !== typeof window.Currency) {
	WSAIO.Currency.rates = window.Currency.rates;
  }
  
  WSAIO.estTime = function () {
	var tN = new Date();
	tN.setTime(tN.getTime() + tN.getTimezoneOffset() * 60 * 1000);
	var offset = -300,
		estDate = new Date(tN.getTime() + offset * 60 * 1000);
	return estDate.getTime();
  };
  
  WSAIO.getSchedule = function (schedule) {
  var timezone = 'EST';
  if(schedule && schedule.timezone != undefined && schedule.timezone != null && schedule.timezone != ''){
    timezone = schedule.timezone;
  }
  // Function to get the current time in UTC or EST
  function get_time_now() {
	  var tN = new Date();
    tN.setTime(tN.getTime() + tN.getTimezoneOffset() * 60 * 1000); // Convert local time to UTC

    if (timezone === "UTC") {
      return tN.getTime(); // UTC time
    } else if (timezone === "EST") {
      var offset = -300; // EST offset: UTC - 5 hours = -300 minutes
      var estDate = new Date(tN.getTime() + offset * 60 * 1000);
      return estDate.getTime(); // EST time
    } else {
      throw new Error("Invalid timezone specified");
    }
	}
  
  // Function to get the timezone offset
	function getTimezoneOffset() {
	  function z(n) {
      return (n < 10 ? '0' : '') + n;
	  }
	  var offset = new Date().getTimezoneOffset();
	  var sign = offset < 0 ? '+' : '-';
	  offset = Math.abs(offset);
	  return sign + z(offset / 60 | 0) + z(offset % 60);
	}
  
  // Function to format date and time
	function date_time_value(date, time) {
        // Parsing date to YYYY/MM/DD HH:MM:SS from YYYY-MM-DD HH:MM:SS
		var prevDate = date;
        if(typeof date === "string")date = date.replace(/-/g, "/");
	  var dateTimeValue = new Date(date);
	  if(dateTimeValue == 'Invalid Date'){
		dateTimeValue = new Date(prevDate);
	  }
	  if (typeof dateTimeValue === 'object') {
		try {
		  dateTimeValue = dateTimeValue.toString();
        if (typeof dateTimeValue === 'string' && timezone != undefined && timezone != 'UTC') {
			dateTimeValue = dateTimeValue.replace(getTimezoneOffset(), '+0000');
		  }
		} catch (e) {
		  log(e);
		}
	  }
	  try {
		dateTimeValue = new Date(dateTimeValue).toISOString();
	  } catch (e) {
		log(e);
	  }
	  try {
		dateTimeValue = dateTimeValue.split('T')[0] + " " + time;
	  } catch (e) {
		log(e);
	  }
	  return dateTimeValue;
	}
  
  // Function to calculate the difference between two dates
	function diff_in_schedule(date1, date2) {
        // Parsing date to YYYY/MM/DD HH:MM:SS from YYYY-MM-DD HH:MM:SS
        if(typeof date1 === "string")date1 = date1.replace(/-/g, "/");
        if(typeof date2 === "string")date2 = date2.replace(/-/g, "/");

	  date1 = new Date(date1);
	  date2 = new Date(date2);

		if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
		return 0;
	  }
	  if (typeof date1 !== 'object' || typeof date2 !== 'object') {
		return 0;
	  }
	  if (date1 > date2) {
		var result = diff_in_schedule(date2, date1);
		result.years = -result.years;
		result.months = -result.months;
		result.days = -result.days;
		result.hours = -result.hours;
		result.minutes = -result.minutes;
		result.seconds = -result.seconds;
		return result;
	  }
	  result = {
		years: date2.getYear() - date1.getYear(),
		months: date2.getMonth() - date1.getMonth(),
		days: date2.getDate() - date1.getDate(),
		hours: date2.getHours() - date1.getHours(),
		minutes: date2.getMinutes() - date1.getMinutes(),
		seconds: date2.getSeconds() - date1.getSeconds()
	  };
	  if (result.seconds < 0) {
		result.minutes--;
		result.seconds += 60;
	  }
	  if (result.minutes < 0) {
		result.hours--;
		result.minutes += 60;
	  }
	  if (result.hours < 0) {
		result.days--;
		result.hours += 24;
	  }
	  if (result.days < 0) {
		result.months--;
		var copy1 = new Date(date1.getTime());
		copy1.setDate(32);
		result.days = 32 - date1.getDate() - copy1.getDate() + date2.getDate();
	  }
	  if (result.months < 0) {
		result.years--;
		result.months += 12;
	  }
	  return result;
	}
	var end_schedule_difference = {
	  "years": 1,
	  "months": 1,
	  "days": 1,
	  "hours": 1,
	  "minutes": 1,
	  "seconds": 1
	},
		start_schedule_difference = {
		  "years": -1,
		  "months": -1,
		  "days": -1,
		  "hours": -1,
		  "minutes": -1,
		  "seconds": -1
  };

  // Get the current time based on the specified timezone (UTC or EST)
  var _time_now = get_time_now();

	if (schedule) {
	  if (schedule.start_date && schedule.start_time_est) {
		var schedule_started = date_time_value(schedule.start_date, schedule.start_time_est);
      start_schedule_difference = diff_in_schedule(_time_now, schedule_started);
		log("start_schedule_difference", start_schedule_difference);
	  }
	  if (schedule.end_date && schedule.end_time_est) {
      var schedule_ended = date_time_value(schedule.end_date, schedule.end_time_est);
      end_schedule_difference = diff_in_schedule(_time_now, schedule_ended);
		log("end_schedule_difference", end_schedule_difference);
	  }
	}
	return {
	  ends_in: end_schedule_difference,
	  started: start_schedule_difference,
	  current_time: _time_now
	};
  };
  
  WSAIO.saleClock = function (rule, product, mod) { //module -> rd OR vd
	if (rule && rule.schedule_active && rule.schedule) {
	  var _sch = WS.getSchedule(rule.schedule),
		  _show_clock = false;
	  if (_sch.ends_in) {
		if (
		  Number(_sch.ends_in.years) > 0 ||
		  Number(_sch.ends_in.months) > 0 ||
		  Number(_sch.ends_in.days) > 0 ||
		  Number(_sch.ends_in.hours) > 0 ||
		  Number(_sch.ends_in.minutes) > 0 ||
		  Number(_sch.ends_in.seconds) > 0
		) {
		  _show_clock = true;
		}
	  }
	  if (_show_clock && _sch.ends_in) {
		try {
		  _show_clock = WS.general_settings.sale_clock.show_sale_clock || false;
		} catch (e) {}
		if (_show_clock) {
		  WS.runClock(rule.schedule, product.id, mod);
		} else {
		  WS.removeClock(product.id);
		}
	  } else {
		WS.removeClock(product.id);
		log("Sale clock was disabled");
	  }
	} else {
	  log("No schedule found");
	}
  };
  
  WSAIO.removeClock = function (id) {
	    const selector = '.wsaio_sale_' + id;
		document.querySelectorAll(selector).forEach(element => {
			element.remove();
		});
  };
  
  WSAIO.runClock = function (schedule, id, mod) {
	var _type = 1;
	try {
	  _type = WS.general_settings.sale_clock.sale_clock_type;
	} catch (e) {
	  log(e);
	}
  
	function _runClock() {
	  var _ends = WS.getSchedule(schedule);
	  if (_ends.ends_in) {
		if (
		  Number(_ends.ends_in.years) > 0 ||
		  Number(_ends.ends_in.months) > 0 ||
		  Number(_ends.ends_in.days) > 0 ||
		  Number(_ends.ends_in.hours) > 0 ||
		  Number(_ends.ends_in.minutes) > 0 ||
		  Number(_ends.ends_in.seconds) > 0
		) {
		  function getStyledClock(msg) {
			var sty = WS.general_settings.sale_clock.style,
				__css = '';
			if (sty.font_size) {
			  __css += 'font-size:' + sty.font_size + 'px;';
			}
			if (sty.border_radius) {
			  __css += 'border-radius:' + sty.border_radius + 'px;';
			}
			if (sty.hex_bg_color) {
			  __css += 'background-color:' + sty.hex_bg_color + ';';
			}
			if (sty.hex_fg_color) {
			  __css += 'color:' + sty.hex_fg_color + ';';
			}
			if (sty.padding) {
			  __css += 'padding:' + sty.padding + ';';
			}
			if (sty.text_align) {
			  __css += 'text-align:' + sty.text_align + ';';
			}
			return '<div style="' + __css + '">' + msg + '</div>'
		  }
		  var _msg = WS.getClockTextByType(_ends.ends_in, schedule, _type),
			  show_time = "";
		  try {
			if(_msg == ''){
				show_time = 'Sale ends soon';
			}else{
			show_time = WS.general_settings.sale_clock.sale_clock_text1 + " " + _msg + " " + WS.general_settings.sale_clock.sale_clock_text2;
			}
		  } catch (e) {
			log(e);
		  }
		  if (show_time == "") {
			show_time = _msg;
		  }
		  WS.removeClock(id);
        if(WSAIO.product_saleClock_selector == ''){
          WSAIO.product_saleClock_selector = WSAIO.product_inner_qb_table_selector;
        }
       const selector = '.wsaio_' + id;
			const htmlContent = '<div class="wsaio_sale_' + id + '" style="margin:5px 0px;">' + getStyledClock(show_time) + '</div>';
			const startingElement = document.querySelector(selector);

			if (startingElement) {
				const productParent = startingElement.closest(WSAIO.product_parent_grid_selector);

				if (productParent) {
					const saleClockElement = productParent.querySelector(WSAIO.product_saleClock_selector);

						saleClockElement.insertAdjacentHTML('afterend', htmlContent);
					}
				}
      } else {
		  WS.removeClock(id);
		}
	  } else {
		WS.removeClock(id);
	  }
	}
	if (_type == 1 || _type == 8 || _type == 9) {
		setInterval(function() {
				  _runClock();
	}, 1000);
  } else {
	_runClock();
  }
  };
  
  WSAIO.getClockTextByType = function (ends_in, schedule, type) {
	function get_date_time_value(dateTimeStr) {
		return dateTimeStr.replace(' ', 'T');  // e.g., "2025-04-29T17:00:00"
	}
	var ends_message = '';
	try {
	  switch (type) {
		case "1":
          if (ends_in.years > 0) {
            ends_message += ends_in.years + (ends_in.years == 1 ? 'year, ' : 'years, ');
          }
          if (ends_in.months > 0) {
            ends_message += ends_in.months + (ends_in.months == 1 ? 'month, ' : 'months, ');
          }
		  if (ends_in.days > 0) {
			ends_message += ends_in.days + (ends_in.days == 1 ? 'day, ' : 'days, ');
		  }
		  if (ends_in.hours > 0) {
			ends_message += ends_in.hours + (ends_in.hours == 1 ? 'hour, ' : 'hours, ');
		  }
		  if (ends_in.minutes > 0) {
			var minutes = ends_in.minutes;
			if (minutes < 10) {
			  minutes = '0' + minutes;
			}
			ends_message += minutes + (ends_in.minutes == 1 ? 'minute, ' : 'minutes, ');
		  }
		  if (ends_in.seconds >= 0) {
			var seconds = ends_in.seconds;
			if (seconds < 10) {
			  seconds = '0' + seconds;
			}
			ends_message += '<span class="wsaio--seconds">' + seconds + '</span>' + (ends_in.seconds <= 1 ? 'second' : 'seconds');
		  }
		  break;
		case '2':
		  if (ends_in.days > 0) {
			ends_message += ends_in.days + (ends_in.days == 1 ? ' day' : ' days');
		  } else if (ends_in.days == 0) {
			if (ends_in.hours > 0) {
			  ends_message += ends_in.hours + (ends_in.hours == 1 ? 'hour' : 'hours');
			}
		  } else {
			ends_message += "";
		  }
		  break;
		case '3':
		  var options = {
			timeZone: 'America/New_York',
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
			second: 'numeric'
		  };
		  ends_message += new Date(get_date_time_value(schedule.end_date)).toLocaleDateString('en-US', options);
		  break;
		case '4':
		  var options = {
			timeZone: 'America/New_York',
			weekday: 'long',
			year: 'numeric',
			month: 'long',
			day: 'numeric'
		  };
		  ends_message += new Date(get_date_time_value(schedule.end_date)).toLocaleDateString('en-US', options);
		  break;
		case '5':
		  var options = {
			timeZone: 'America/New_York',
			year: 'numeric',
			month: 'long',
			day: 'numeric'
		  };
		  ends_message += new Date(get_date_time_value(schedule.end_date)).toLocaleDateString('en-US', options);
		  break;
		case '6':
		  var options = {
			timeZone: 'America/New_York',
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
			second: 'numeric'
		  };
		  ends_message += new Date(get_date_time_value(schedule.end_date)).toLocaleDateString('en-US', options);
		  break;
		case '7':
		  var options = {
			timeZone: 'America/New_York',
			year: 'numeric',
			month: 'short',
			day: 'numeric'
		  };
		  ends_message += new Date(get_date_time_value(schedule.end_date)).toLocaleDateString('en-US', options);
		  break;
		case '8':
		  if (ends_in.years > 0) {
		    ends_message += ends_in.years + 'y:';
		  }
		  if (ends_in.months > 0) {
		    ends_message += ends_in.months + 'm:';
		  }
		  if (ends_in.days > 0) {
			ends_message += ends_in.days + 'd:';
		  }
		  if (ends_in.hours > 0) {
			ends_message += ends_in.hours + 'h:';
		  }
		  if (ends_in.minutes > 0) {
			var minutes = ends_in.minutes;
			if (minutes < 10) {
			  minutes = '0' + minutes;
			}
			ends_message += minutes + 'm:';
		  }
		  if (ends_in.seconds >= 0) {
			var seconds = ends_in.seconds;
			if (seconds < 10) {
			  seconds = '0' + seconds;
			}
			ends_message += '<span class="wsaio-seconds">' + seconds + '</span>' + 's';
		  }
		  break;
		case '9':
		  if (ends_in.years > 0) {
			ends_message += ends_in.years + (ends_in.years == 1 ? 'year, ' : 'years, ');
		  }
		  if (ends_in.months > 0) {
		  ends_message += ends_in.months + (ends_in.months == 1 ? 'month, ' : 'months, ');
		  }
		  if (ends_in.days > 0) {
			ends_message += ends_in.days + (ends_in.days == 1 ? 'day ' : 'days ');
		  }
		  if (ends_in.hours > 0) {
			ends_message += ends_in.hours + (ends_in.hours == 1 ? 'hour ' : 'hours ');
		  }
		  if (ends_in.minutes > 0) {
			var minutes = ends_in.minutes;
			if (minutes < 10) {
			  minutes = '0' + minutes;
			}
			ends_message += minutes + (ends_in.minutes == 1 ? 'minute ' : 'minutes ');
		  }
		  if (ends_in.seconds >= 0) {
			var seconds = ends_in.seconds;
			if (seconds < 10) {
			  seconds = '0' + seconds;
			}
			ends_message += '<span class="wsaio-seconds">' + seconds + '</span>' + (ends_in.seconds <= 1 ? 'second' : 'seconds');
		  }
		  break;
		default:
		  break;
	  }
	} catch (e) {
	  log(e);
	}
	return ends_message;
  };
  
  WSAIO.isCustomerLoggedIn = function () {
	var is_logged = false;
	if (WSAIO.customer && WSAIO.customer.id) {
	  is_logged = true;
	}
	return is_logged;
  };
  
  WSAIO.isWholesaleCustomer = function () {
	var is_vd_applied = false;
	var is_rd_applied = false;
	var is_cart_ld_applied = WS.cartLevelDiscount() ? true : false;
	var is_ships_applied = WSAIO.ships_exists ? false : true;
	if (WSAIO.regular_discounts && WSAIO.regular_discounts.length > 0) {
	  // for loop
	  for (var i = 0, len_i = WS.regular_discounts.length; i < len_i; i++) {
		var regular_discount = WS.regular_discounts[i];
		if (regular_discount.state !== 'published') continue;
		if (WS.checkCustomer(regular_discount.customer_group, regular_discount.tags, regular_discount.tags_excluded) === false) continue;
		if (regular_discount.schedule_active) {
		  var _schedule = WS.getSchedule(regular_discount.schedule);
		  log("_schedule", _schedule);
		  if (_schedule.ends_in) {
			if (
			  Number(_schedule.ends_in.years) <= 0 &&
			  Number(_schedule.ends_in.months) <= 0 &&
			  Number(_schedule.ends_in.days) <= 0 &&
			  Number(_schedule.ends_in.hours) <= 0 &&
			  Number(_schedule.ends_in.minutes) <= 0 &&
			  Number(_schedule.ends_in.seconds) <= 0
			) {
			  log("This rule was expired", _schedule);
			  continue;
			}
			if (
			  Number(_schedule.started.years) >= 0 &&
			  Number(_schedule.started.months) >= 0 &&
			  Number(_schedule.started.days) >= 0 &&
			  Number(_schedule.started.hours) >= 0 &&
			  Number(_schedule.started.minutes) >= 0 &&
			  Number(_schedule.started.seconds) >= 0
			) {
			  log("This rule was schedules and will be started in", _schedule);
			  continue;
			}
		  }
		}
		is_rd_applied = true;
	  } // end for loop
	}
	if (!is_rd_applied && WSAIO.volume_discounts && WSAIO.volume_discounts.length > 0) {
	  // for loop
	  for (var i = 0, len_i = WS.volume_discounts.length; i < len_i; i++) {
		var volume_discount = WS.volume_discounts[i];
		if (volume_discount.state !== 'published') continue;
		if (WS.checkCustomer(volume_discount.customer_group, volume_discount.tags, volume_discount.tags_excluded) === false) continue;
		if (volume_discount.schedule_active) {
		  var _schedule = WS.getSchedule(volume_discount.schedule);
		  log("_schedule", _schedule);
		  if (_schedule.ends_in) {
			if (
			  Number(_schedule.ends_in.years) <= 0 &&
			  Number(_schedule.ends_in.months) <= 0 &&
			  Number(_schedule.ends_in.days) <= 0 &&
			  Number(_schedule.ends_in.hours) <= 0 &&
			  Number(_schedule.ends_in.minutes) <= 0 &&
			  Number(_schedule.ends_in.seconds) <= 0
			) {
			  log("This rule was expired", _schedule);
			  continue;
			}
			if (
			  Number(_schedule.started.years) >= 0 &&
			  Number(_schedule.started.months) >= 0 &&
			  Number(_schedule.started.days) >= 0 &&
			  Number(_schedule.started.hours) >= 0 &&
			  Number(_schedule.started.minutes) >= 0 &&
			  Number(_schedule.started.seconds) >= 0
			) {
			  log("This rule was schedules and will be started in", _schedule);
			  continue;
			}
		  }
		}
		is_vd_applied = true;
	  } // end for loop
	}
	if (!is_rd_applied && !is_vd_applied && WSAIO.app_shipping && WSAIO.app_shipping.length > 0) {
	  for (var kktt = 0; kktt < WSAIO.app_shipping.length; kktt++) {
		var temp_app_shipping = WSAIO.app_shipping[kktt];
		if (temp_app_shipping.status === "active") {
		  switch (temp_app_shipping.customer_group) {
			case "all":
			  if (temp_app_shipping.except_logged_in) {
				if (WSAIO.isCustomerLoggedIn() === false) {
				  is_ships_applied = true;
				}
			  } else {
				is_ships_applied = true;
			  }
			  break;
			case "logged_in":
			  is_ships_applied = true;
			  break;
			case "tag_based":
			  if (WSAIO.isCustomerLoggedIn()) {
				if (WSAIO.customer.tags && WSAIO.customer.tags.length > 0) {
				  for (var ctk = 0; ctk < WSAIO.customer.tags.length; ctk++) {
					var dfes = WSAIO.customer.tags[ctk];
					if (temp_app_shipping.customer_tags.findIndex(function (t) {
					  return t.toLowerCase() == dfes.toLowerCase()
					}) > -1) {
					  is_ships_applied = true;
					  break;
					}
				  }
				}
			  }
			  break;
			default:
			  break;
		  }
		}
	  }
	}
	if (!is_vd_applied) {
	  log("WSAIO: volume discount not found");
	}
	if (!is_rd_applied) {
	  log("WSAIO: regular discount not found");
	}
	if (!is_ships_applied) {
	  log("WSAIO: shipping not found");
	}
	if (!is_cart_ld_applied) {
	  log("WSAIO: cart level discount not found");
	}
	if (is_vd_applied || is_rd_applied || is_ships_applied || is_cart_ld_applied) {
	  return true;
	} else {
	  return false;
	}
  };
  WSAIO.buyNowEventListener()
	WSAIO.ajax = async function (params) {
		if (!params || !params.url || !params.type) {
			throw new Error("Ajax parameters can't be null. Required parameters are type and url. Optional parameters are success and error functions");
		}

		const { url, type, data, success, error } = params;
		const onSuccess = success || (() => {});
		const onError = error || ((e) => console.error("WSAIO AJAX Error:", e));

		try {
			const fetchOptions = {
				method: type.toUpperCase(),
				headers: {
					'Content-Type': 'application/json', 
					'Accept': 'application/json' 
				}
			};
			if (data && fetchOptions.method !== 'GET' && fetchOptions.method !== 'HEAD') {
				fetchOptions.body = JSON.stringify(data);
			} 

			const response = await fetch(url, fetchOptions);

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			const responseTxt = await response.json();
			onSuccess(responseTxt);

		} catch (e) {
			onError(e);
		}
	};
  
  if (isNaN(WSAIO.buy_now_btn_interval)) {
	WSAIO.buy_now_btn_interval = 1000;
  }
  
  function serverLogging(pre_checkout) {
	var logging_data = {
	  is_wholesale: WSAIO.isWholesaleCustomer(),
	  customer: {
		id: WSAIO.customer.id,
		email: WSAIO.customer.email,
		tags: WSAIO.customer.tags
	  },
	  template: WSAIO.landingTemplate,
	  shop: {
		url: WSAIO.shopInfo.url,
		shop: WSAIO.shopInfo.shop
	  },
	  cart: WSAIO.cart_object,
	  date: new Date(),
	  pre_checkout: pre_checkout || {}
	};
	localStorage.setItem("wsaio_logging", JSON.stringify(logging_data));
  }
  serverLogging({});
  
  WSAIO.run_app = function () {
	if (window.Currency && window.Currency.rates) {
	  WSAIO.Currency.rates = window.Currency.rates;
	}
	if (WS.general_settings.discount_method === 'line_items' && true === WSAIO.general_settings.enable_additional_coupon_code) {
	  WS.DiscountCode.addForm();
	  WS.DiscountCode.subscribe(); // subscribe on click event
	}
	if (WS.landingTemplate === "cart") {
	  WS.checkoutEventListner(); // Subscribe checkout button on click event
	  WS.preloadCheckout(); // Get wholesale price from server on window load
	}
	WS.signUpForm();
	if (typeof wsaio_execute_custom_code !== "undefined") {
			var jQ = typeof window.WSAIO_GET_JQUERY === "function" ? window.WSAIO_GET_JQUERY() : jQuery;
			if(jQ){
			    wsaio_execute_custom_code(jQ);
        }else{
                wsaio_execute_custom_code();
        }
    }
	
  };
  window.wsaioClosePreview = function () {
	WSAIO.removeQueryString("test-mode", WSAIO.getParameterByName("test-mode")[0]);
	localStorage.removeItem("wsaio-app-mode");
	WSAIO.user_mode = "live";
	setTimeout(function () {
	  window.location.replace('https://' + Shopify.shop);
	}, 500);
  }
  
  window.wsaioHidePreview = function () {
		document.querySelectorAll(".wholesaleAllInOnePreview").forEach(element => {
			element.remove();
		});
		document.documentElement.style.paddingBottom = "";
  }
  
  WSAIO.addPreviewBar = function () {
	var previewBar = '<div class="wholesaleAllInOnePreview" style="background-color: white;display:flex;height: 60px;align-items: center;width: 100%;padding: 13px 0px;box-shadow: rgba(0, 0, 0, 0.2) 0px -1px 3px;overflow: hidden;position: fixed;bottom: 0;left: 0;right: 0;z-index: 3147483648;opacity: 0.97;">'+
		'<div style="flex-grow:1;padding-left:20px"><p style="margin: 0px;color:black"><span>'+
		'<b>Wholesale All In One Preview: </b></span>'+
		'Wholesale pricing are only visible to you. <a href="https://support.digitalcoo.com/hc/en-us/articles/360042800512"><u>Learn More</u></a></p></div>'+'<div style="padding-right: 23px;">'+
		'<button class="ws--preview-bar-btn" onclick="wsaioClosePreview();">Close Preview</button>'+
		'<button style="width: auto;border:none;margin-left:.3rem;background:0 0;box-shadow:none;color:#007ace;font-size:14px;opacity:1" onclick="wsaioHidePreview();">Hide bar</button>'+
		'</div>'+
		'</div>';

		if (document.querySelectorAll(".wholesaleAllInOnePreview").length === 0) {
			document.body.insertAdjacentHTML('beforeend', previewBar);
		}
		document.documentElement.style.paddingBottom = "60px";
  }
  
  WSAIO.store = {
	get: function (key) {
	  return sessionStorage.getItem(key);
	},
	set: function (key, value) {
	  return sessionStorage.setItem(key, value);
	},
	del: function (key) {
	  return sessionStorage.removeItem(key);
	}
  }
  
  WSAIO.handleBrowserURL = function () {
	function $track_overriding(product, variant, selector, trackClass) {
	  var counter = 1;
	  function $check(counter) {
		log("$tracking variant change...");
		counter++;
		if(document.querySelector(selector).classList.contains(trackClass)){
		  // log("$tracking variant changed! Discount did not override");
		}
		else{
		  log("$tracking Discount has been overrided by another function. Let's change it according to WSAIO");
		  WSAIO.variantChange(product, variant);
		  counter = 3000;
		}
		if(counter < 3000){
		  setTimeout(function () {
			$check(counter);
		  }, 1);
		}
	  }
	  $check(counter);
	}
	function $handle_variant_change(variant_id) {
	  var pt_index = -1;
	  try {
		pt_index = WSAIO.product_details.variants.findIndex(function (x) {
		  return x.id == variant_id
		});
	  } catch (e) {}
	  if(document.querySelector(WSAIO.product_price_selector).classList.contains("wsdapp")){
		document.querySelectorAll(WSAIO.product_price_selector).forEach(element => {
			element.classList.remove("wsdapp");
		});
	  }
	  if (pt_index > -1) {
		WS.selected_variant = WSAIO.product_details.variants[pt_index];
		var variant = WSAIO.product_details.variants[pt_index];
		WSAIO.variantChange(WSAIO.product_details, variant);
		$track_overriding(WSAIO.product_details, variant, WSAIO.product_price_selector, "wsdapp");
	  }
	}
	var selected_variant_id = WSAIO.getParameterByName("variant")[0];
	if(selected_variant_id){
	  log("Got variant id from browser url");
	  $handle_variant_change(selected_variant_id);
	}
	else{
	  setTimeout(function () {
		selected_variant_id = document.querySelector('[name="id"]').value;
		if(selected_variant_id){
		  log("Got variant id from name=id attribute");
		  $handle_variant_change(selected_variant_id);
		}
		else{
		  isError("Error 404! Variant ID not found");
		}
	  }, 1000);
	}
  
  };
  
  WSAIO.listenLocationChange = (function () {
	var pushState = history.pushState;
	var replaceState = history.replaceState;
	history.pushState = function() {
	  pushState.apply(history, arguments);
	  window.dispatchEvent(new Event('pushstate'));
	  window.dispatchEvent(new Event('locationchange'));
	};
	history.replaceState = function() {
	  replaceState.apply(history, arguments);
	  window.dispatchEvent(new Event('replacestate'));
	  window.dispatchEvent(new Event('locationchange'));
	};
	window.addEventListener('popstate', function() {
	  window.dispatchEvent(new Event('locationchange'))
	});
	// window.addEventListener('locationchange', WSAIO.handleBrowserURL);
  })();
  
  if (WS.app_auto_start) {
	WS.run_app();
  }
  }; //end WSAIO.init
  
  window.ws_load_app = function(JQ = null){
	if (WSAIO.db_config == 'database') {
				const apiUrl = WSAIO.App.url + '/api/2021-03/get-rules?shop=' + WSAIO.shopInfo.shop;
				fetch(apiUrl, {
					method: 'GET', 
					cache: 'no-store' 
				})
				.then(response => {
					if (!response.ok) {
						throw new Error(`HTTP error! status: ${response.status}`);
					}
					return response.json();
				})
				.then(rules => {
					if (rules) {
						if (rules.volume_discounts) {
							WSAIO.volume_discounts = rules.volume_discounts;
						}
						if (rules.regular_discounts) {
							WSAIO.regular_discounts = rules.regular_discounts;
						}
						if (rules.cart_discounts) { 
							WSAIO.cart_ld_discounts = WSAIO.cart_discounts;
						}
						WSAIO.init();
					}
				})
				.catch(error => {
					if (!WSAIO.no_logs) {
						console.error('WSAIO could not be initialized.', error);
					}
				});
	} else {
	  WSAIO.init();
	}
  }
  
  WSAIO.removeQueryString = function (a, d) {
	var b = document.location.href,
		c = location.search;
	"" != a ? (d = encodeURIComponent(d), a = a + "=" + d, "-1" != c.indexOf("?" + a + "&") ? b = b.replace("?" + a + "&", "?") : "-1" != c.indexOf("&" + a + "&") ? b = b.replace("&" + a + "&", "&") : "-1" != c.indexOf("?" + a) ? b = b.replace("?" + a, "") : "-1" != c.indexOf("&" + a) && (b = b.replace("&" + a, ""))) : (c = location.search, b = b.replace(c, ""));
	history.pushState({
	  state: 1,
	  rand: Math.random()
	}, "", b)
  };
  
  
  
  WSAIO.getParameterByName = function (e) {
	for (var b = [], c = window.location.search.substring(1).split("&"), a = 0; a < c.length; a++) {
	  var d = c[a].split("=");
	  d[0] == e && b.push(decodeURIComponent(d[1]))
	}
	return b
  };
  
  var waioLoadScript = function (c, b) {
	var a = document.createElement("script");
	a.type = "text/javascript";
	a.readyState ? a.onreadystatechange = function () {
	  if ("loaded" == a.readyState || "complete" == a.readyState) a.onreadystatechange = null, b()
		} : a.onload = function () {
	  b()
	};
	a.src = c;
	document.getElementsByTagName("head")[0].appendChild(a)
  };
  
  if ("yes" === WSAIO.getParameterByName("test-mode")[0]) {
	WSAIO.user_mode = "test";
	localStorage.setItem("wsaio-app-mode", "test");
	WSAIO.show_preview_bar = true;
  }
  
  if (localStorage.getItem("wsaio-app-mode") === "yes") {
	WSAIO.show_preview_bar = true;
  }
  
  if (WSAIO.app_mode === 'live' && WSAIO.disable_logs_when_live === true) {
	WSAIO.log = '';
	WSAIO.errorLog = '';
  }
 
  if (WSAIO.app_mode === "live" || (WSAIO.app_mode === WSAIO.user_mode)) {
			var jQ = typeof window.WSAIO_GET_JQUERY === "function" ? window.WSAIO_GET_JQUERY() : jQuery;
			if(jQ){
				window.ws_load_app(jQ);
		}else{
			window.ws_load_app();
		}
  }
  else {
	if(!WSAIO.no_logs){
	  console.warn("%c'Wholesale All In One' is disabled", "font-size: 20px");
	}
	WSAIO_is_disabled = true;
  }

 if(typeof WSAIO.app_mode_applied != 'undefined' && WSAIO.app_mode_applied){


if(WSAIO.template !== 'cart'){
WSAIO.cartDrawer(1000)    
}   
//============= For Collection ID ==================//
document.querySelectorAll('.col_clct').forEach(function (el) {
var clctn_dta = JSON.parse(el.getAttribute('clct'));
for (var i = 0; i < clctn_dta.length; i++) {
if (typeof WSAIO.product_in_collects !== 'undefined') {
WSAIO.product_in_collects.push(clctn_dta[i]);
}
if (typeof WSAIO.products_with_collections !== 'undefined') {
WSAIO.products_with_collections.push(clctn_dta[i]);
}
if (typeof WSAIO.product_collections !== 'undefined') {
WSAIO.product_collections.push(clctn_dta[i]);
} 
} 
});



//====================== Collection function =========================
function collection_discount() {  

const items = document.querySelectorAll('ul#collection li , li.product-card ,li.snize-product  ,.product-recommendations.cart-upsell li.product-card');
for (const element of items) {
if (element.querySelector('.wsdapp')) {
continue;
}

// Get product link
const collection_linkElement = element.querySelector('h3.p0 a ,div a ,.snize-item') || element;
let collection_product_handle = collection_linkElement.getAttribute('href');
if (!collection_product_handle ||collection_product_handle === '#' ||!collection_product_handle.includes('/products/')) {
continue;
}
collection_product_handle = collection_product_handle
.split('/products/')[1]
.split('?')[0];
//console.log('collection_product_handle ',collection_product_handle )
fetch('/products/' + collection_product_handle + '.js')
.then(response => response.json())
.then(product => {
const defaultVariant = product.variants[0];
const priceSelector = element.querySelectorAll('.coll_p ,.snize-price-list');
if (!priceSelector.length) return;
if (typeof WSAIO === 'undefined' || typeof WSAIO.productDiscount === 'undefined') {
return;
}
WSAIO.productDiscount({
template: 'collection',
item_price_selector: priceSelector,
product_id: product.id,
product_handle: product.handle,
variant_id: defaultVariant.id,
variant_sku: defaultVariant.sku,
variant_price: defaultVariant.price,
variant_compare_at_price: defaultVariant.compare_at_price
});
})
.catch(() => {});
}
}



collection_discount();


//============= Filters ==================== //
let isRecentViewSectionVisible = false;
const visibilityCheckInterval = 500; // Check every 500ms

const recentViewInterval = setInterval(() => {
const isProcessingGridVisible = document.querySelectorAll('.f8fl.processing').length > 0;

// Only update state if it has changed
if (isProcessingGridVisible && !isRecentViewSectionVisible) {
isRecentViewSectionVisible = true;
//console.log("Recent view section opened");
// Add your "open" logic here

}  
else if (!isProcessingGridVisible && isRecentViewSectionVisible) {
isRecentViewSectionVisible = false;
//console.log("Recent view section closed");
// Add your "close" logic here
collection_discount();
}
}, visibilityCheckInterval);





//====================== Product function ========================= 
if(WSAIO.template == 'product'){
function Product_disocunt() {
document.querySelectorAll('#main-product span.price-main').forEach(el => {
const classes = Array.from(el.classList);
const filtered = classes.filter(cls =>
!cls.startsWith('wsaio_') && cls !== 'wsdapp'
);  
el.className = '';
el.classList.add(...filtered);
});
HandleQty.init(); 
let Variant_ID = document.querySelector('#main-product [name="id"]')?.value;
if (!Variant_ID) {
const urlParts = window.location.href.split('variant=');
Variant_ID = urlParts[1] || '';
}
window.current_product = WSAIO.product_details;
// Reset price list class
const priceListLarge = document.querySelector('span.price-main');  
const matching_variant = current_product.variants.findIndex(v => v.id == Variant_ID);
window.selected_variant_id = current_product.variants[matching_variant].id;
WSAIO.variantChange( 
current_product,
current_product.variants[matching_variant]
);
if (WSAIO.productDiscount != undefined) {
WSAIO.productDiscount({
item_price_selector: priceListLarge,
template: 'product',
product_id: current_product.id,
product_handle: current_product.handle,
variant_id: Variant_ID,
variant_sku: current_product.variants[matching_variant].sku,
variant_price: current_product.variants[matching_variant].price,
variant_compare_at_price: current_product.variants[matching_variant].compare_at_price
},function handleResponse(response) {
		$('.overlay-dynamic_buy_button').hide();
const badges = document.querySelectorAll('#main-product span.s1lb.label');

if (response && response.regular_discount && Number(response.regular_discount.ws_discount) > 0) {

badges.forEach(badge => badge.style.display = 'none');
} else {
badges.forEach(badge => badge.style.display = 'flex');
}
});
}
}
Product_disocunt();

} 

//============= cart drawer Qty==================//
document.addEventListener('click', function (e) {
const target = e.target.closest('.semantic-amount a ,.remove-from-cart-link');
if (!target) return;

WSAIO.cartDrawer(1500)
//console.log('cart drawer add');
});


document.addEventListener('change', function (e) {
const target = e.target.closest('.semantic-amount input.disable-on-change');
if (!target) return;
setTimeout(() => {
collection_discount();
}, 3500);
WSAIO.cartDrawer(1500)
//console.log('cart drawer add chnage');
});



let recentViewActive = false;

const recentViewTimer = setInterval(() => {
const isProcessingActive =
document.querySelectorAll('.f8pr.form-card.cart-initialized.processing').length > 0;

if (isProcessingActive && recentViewActive === false) {
recentViewActive = true;
//console.log("open recentView");


}

else if (!isProcessingActive && recentViewActive === true) {
recentViewActive = false;
//console.log("close recentView");
setTimeout(() => {
collection_discount();
}, 1500);
WSAIO.cartDrawer(1500)
}

}, 500);



//================ Live search ==================//
let frameCounter = 0;
let typing = false;

document.addEventListener('keyup', function(e) {
if (!e.target.matches('[type="search"]')) return;

if (!typing) {
typing = true;
frameCounter = 0;

function waitFrames() {
frameCounter++;

if (frameCounter > 180) {
// console.log('search typing (delayed):', e.target.value);
collection_discount();
typing = false; // reset for next typing
} else {
requestAnimationFrame(waitFrames); // continue counting frames
}
}

requestAnimationFrame(waitFrames);
}
});
//============ cart drawer ================//
let cartDrawerOpened = false;

const cartDrawerInterval = setInterval(function () {

const cartDrawer = document.querySelector('.m6pn.base-font.toggle');

if (cartDrawer && cartDrawerOpened === false) {

cartDrawerOpened = true;

//console.log("open cart drawer");

WSAIO.cartDrawer(500)


} else if (!cartDrawer && cartDrawerOpened === true) {

cartDrawerOpened = false;

//console.log("close cart drawer");
}

}, 500);

//=================== cart discount fucntion=========

if (typeof WSAIO.cartDrawer != 'undefined'){WSAIO.cartDrawer(100)}

function debounce(func, wait = 100) {
let timeout;
return function(...args) {
clearTimeout(timeout);
timeout = setTimeout(() => func.apply(this, args), wait);
};
}


function createWatcher({ el, watch = "class", attribute = null, onChange = () => {} }) {
if (!el) return;
let lastState = watch === "class" ? el.className
: watch === "attribute" ? el.getAttribute(attribute)
: el.innerText.trim();

const obs = new MutationObserver(() => {
const newState = watch === "class" ? el.className
: watch === "attribute" ? el.getAttribute(attribute)
: el.innerText.trim();
if (newState !== lastState) {
lastState = newState;
onChange(newState);
}
});

obs.observe(el, {
attributes: watch === "class" || watch === "attribute",
attributeFilter: watch === "attribute" ? [attribute] : undefined,
childList: watch === "content",
subtree: watch === "content"
});
return obs;
}


function bindDynamicWatcher(selector, config, parentSelector) {
let currentEl = document.querySelector(selector);
if (currentEl) createWatcher({ el: currentEl, ...config });
const parent = parentSelector ? document.querySelector(parentSelector) : document.body;
if (!parent) return;
const rebinder = new MutationObserver(() => {
const newEl = document.querySelector(selector);
if (newEl && newEl !== currentEl) {
currentEl = newEl;
createWatcher({ el: currentEl, ...config });
}
});

rebinder.observe(parent, { childList: true, subtree: true });
}


function bindMultipleWatchers(selector, config, parentSelector = "body") {
const bindToElements = () => {
document.querySelectorAll(selector).forEach(el => {
if (!el._watched) {
createWatcher({ el, ...config });
el._watched = true;
}
});
};

bindToElements();
const parent = document.querySelector(parentSelector);
if (!parent) return;
const rebinder = new MutationObserver(() => bindToElements());
rebinder.observe(parent, { childList: true, subtree: true });
}





const watchers = [
//================== product  recommendations =======================//
{
selector: ".product-recommendations",
watch: "content",
onChange: debounce((val) => {
//console.log(val,'open recommendations')
collection_discount()
}, 100),
parent: ".product-recommendations",
multiple: true
},
//================== product  recently-viewed=======================//

{
selector: ".shopify-section.recently-viewed-products",
watch: "content",
onChange: debounce((val) => {
//console.log(val,'open recent view')
collection_discount()
}, 100),  
parent: ".shopify-section.recently-viewed-products",
multiple: true
},

//================== cart drawer add =======================//

{
selector: ".sticky-in-panel.sticky-panel-initialized.is-sticky ",
watch: "content",
onChange: debounce((val) => {
//console.log(val,'open drawer add')
collection_discount()
}, 100),  
parent: ".sticky-in-panel.sticky-panel-initialized.is-sticky ",
multiple: true
},





];  

watchers.forEach(cfg => {
if (cfg.multiple) bindMultipleWatchers(cfg.selector, cfg, cfg.parent);
else bindDynamicWatcher(cfg.selector, cfg, cfg.parent);
});

}
